// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension="
// @generated from file bsky.proto (package bsky, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum bsky.NotificationInclude
 */
export enum NotificationInclude {
  /**
   * @generated from enum value: NOTIFICATION_INCLUDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_INCLUDE_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: NOTIFICATION_INCLUDE_FOLLOWS = 2;
   */
  FOLLOWS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(NotificationInclude)
proto3.util.setEnumType(NotificationInclude, "bsky.NotificationInclude", [
  { no: 0, name: "NOTIFICATION_INCLUDE_UNSPECIFIED" },
  { no: 1, name: "NOTIFICATION_INCLUDE_ALL" },
  { no: 2, name: "NOTIFICATION_INCLUDE_FOLLOWS" },
]);

/**
 * @generated from enum bsky.FeedType
 */
export enum FeedType {
  /**
   * @generated from enum value: FEED_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FEED_TYPE_POSTS_AND_AUTHOR_THREADS = 1;
   */
  POSTS_AND_AUTHOR_THREADS = 1,

  /**
   * @generated from enum value: FEED_TYPE_POSTS_NO_REPLIES = 2;
   */
  POSTS_NO_REPLIES = 2,

  /**
   * @generated from enum value: FEED_TYPE_POSTS_WITH_MEDIA = 3;
   */
  POSTS_WITH_MEDIA = 3,

  /**
   * @generated from enum value: FEED_TYPE_POSTS_WITH_VIDEO = 4;
   */
  POSTS_WITH_VIDEO = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(FeedType)
proto3.util.setEnumType(FeedType, "bsky.FeedType", [
  { no: 0, name: "FEED_TYPE_UNSPECIFIED" },
  { no: 1, name: "FEED_TYPE_POSTS_AND_AUTHOR_THREADS" },
  { no: 2, name: "FEED_TYPE_POSTS_NO_REPLIES" },
  { no: 3, name: "FEED_TYPE_POSTS_WITH_MEDIA" },
  { no: 4, name: "FEED_TYPE_POSTS_WITH_VIDEO" },
]);

/**
 * @generated from enum bsky.SearchSortOrder
 */
export enum SearchSortOrder {
  /**
   * @generated from enum value: SEARCH_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEARCH_SORT_ORDER_RECENT = 1;
   */
  RECENT = 1,

  /**
   * @generated from enum value: SEARCH_SORT_ORDER_TOP = 2;
   */
  TOP = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(SearchSortOrder)
proto3.util.setEnumType(SearchSortOrder, "bsky.SearchSortOrder", [
  { no: 0, name: "SEARCH_SORT_ORDER_UNSPECIFIED" },
  { no: 1, name: "SEARCH_SORT_ORDER_RECENT" },
  { no: 2, name: "SEARCH_SORT_ORDER_TOP" },
]);

/**
 * @generated from enum bsky.SearchQueryLanguage
 */
export enum SearchQueryLanguage {
  /**
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Japanese (Kuromoji)
   *
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_JA = 1;
   */
  JA = 1,

  /**
   * Chinese (smartcn)
   *
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_ZH = 2;
   */
  ZH = 2,

  /**
   * Korean (nori)
   *
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_KO = 3;
   */
  KO = 3,

  /**
   * Thai
   *
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_TH = 4;
   */
  TH = 4,

  /**
   * Arabic
   *
   * @generated from enum value: SEARCH_QUERY_LANGUAGE_AR = 5;
   */
  AR = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(SearchQueryLanguage)
proto3.util.setEnumType(SearchQueryLanguage, "bsky.SearchQueryLanguage", [
  { no: 0, name: "SEARCH_QUERY_LANGUAGE_UNSPECIFIED" },
  { no: 1, name: "SEARCH_QUERY_LANGUAGE_JA" },
  { no: 2, name: "SEARCH_QUERY_LANGUAGE_ZH" },
  { no: 3, name: "SEARCH_QUERY_LANGUAGE_KO" },
  { no: 4, name: "SEARCH_QUERY_LANGUAGE_TH" },
  { no: 5, name: "SEARCH_QUERY_LANGUAGE_AR" },
]);

/**
 * @generated from enum bsky.SitemapPageType
 */
export enum SitemapPageType {
  /**
   * @generated from enum value: SITEMAP_PAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SITEMAP_PAGE_TYPE_USER = 1;
   */
  USER = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(SitemapPageType)
proto3.util.setEnumType(SitemapPageType, "bsky.SitemapPageType", [
  { no: 0, name: "SITEMAP_PAGE_TYPE_UNSPECIFIED" },
  { no: 1, name: "SITEMAP_PAGE_TYPE_USER" },
]);

/**
 * @generated from message bsky.Record
 */
export class Record extends Message<Record> {
  /**
   * @generated from field: bytes record = 1;
   */
  record = new Uint8Array(0);

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  /**
   * @generated from field: google.protobuf.Timestamp indexed_at = 4;
   */
  indexedAt?: Timestamp;

  /**
   * @generated from field: bool taken_down = 5;
   */
  takenDown = false;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp sorted_at = 7;
   */
  sortedAt?: Timestamp;

  /**
   * @generated from field: string takedown_ref = 8;
   */
  takedownRef = "";

  /**
   * @generated from field: repeated string tags = 9;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<Record>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.Record";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "record", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "indexed_at", kind: "message", T: Timestamp },
    { no: 5, name: "taken_down", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "sorted_at", kind: "message", T: Timestamp },
    { no: 8, name: "takedown_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Record {
    return new Record().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Record {
    return new Record().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Record {
    return new Record().fromJsonString(jsonString, options);
  }

  static equals(a: Record | PlainMessage<Record> | undefined, b: Record | PlainMessage<Record> | undefined): boolean {
    return proto3.util.equals(Record, a, b);
  }
}

/**
 * @generated from message bsky.GetBlockRecordsRequest
 */
export class GetBlockRecordsRequest extends Message<GetBlockRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetBlockRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlockRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlockRecordsRequest {
    return new GetBlockRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlockRecordsRequest {
    return new GetBlockRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlockRecordsRequest {
    return new GetBlockRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlockRecordsRequest | PlainMessage<GetBlockRecordsRequest> | undefined, b: GetBlockRecordsRequest | PlainMessage<GetBlockRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetBlockRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlockRecordsResponse
 */
export class GetBlockRecordsResponse extends Message<GetBlockRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetBlockRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlockRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlockRecordsResponse {
    return new GetBlockRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlockRecordsResponse {
    return new GetBlockRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlockRecordsResponse {
    return new GetBlockRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlockRecordsResponse | PlainMessage<GetBlockRecordsResponse> | undefined, b: GetBlockRecordsResponse | PlainMessage<GetBlockRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetBlockRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetFeedGeneratorRecordsRequest
 */
export class GetFeedGeneratorRecordsRequest extends Message<GetFeedGeneratorRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetFeedGeneratorRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFeedGeneratorRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFeedGeneratorRecordsRequest {
    return new GetFeedGeneratorRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFeedGeneratorRecordsRequest {
    return new GetFeedGeneratorRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFeedGeneratorRecordsRequest {
    return new GetFeedGeneratorRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFeedGeneratorRecordsRequest | PlainMessage<GetFeedGeneratorRecordsRequest> | undefined, b: GetFeedGeneratorRecordsRequest | PlainMessage<GetFeedGeneratorRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetFeedGeneratorRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetFeedGeneratorRecordsResponse
 */
export class GetFeedGeneratorRecordsResponse extends Message<GetFeedGeneratorRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetFeedGeneratorRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFeedGeneratorRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFeedGeneratorRecordsResponse {
    return new GetFeedGeneratorRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFeedGeneratorRecordsResponse {
    return new GetFeedGeneratorRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFeedGeneratorRecordsResponse {
    return new GetFeedGeneratorRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFeedGeneratorRecordsResponse | PlainMessage<GetFeedGeneratorRecordsResponse> | undefined, b: GetFeedGeneratorRecordsResponse | PlainMessage<GetFeedGeneratorRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetFeedGeneratorRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowRecordsRequest
 */
export class GetFollowRecordsRequest extends Message<GetFollowRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetFollowRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowRecordsRequest {
    return new GetFollowRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowRecordsRequest {
    return new GetFollowRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowRecordsRequest {
    return new GetFollowRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowRecordsRequest | PlainMessage<GetFollowRecordsRequest> | undefined, b: GetFollowRecordsRequest | PlainMessage<GetFollowRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetFollowRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowRecordsResponse
 */
export class GetFollowRecordsResponse extends Message<GetFollowRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetFollowRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowRecordsResponse {
    return new GetFollowRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowRecordsResponse {
    return new GetFollowRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowRecordsResponse {
    return new GetFollowRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowRecordsResponse | PlainMessage<GetFollowRecordsResponse> | undefined, b: GetFollowRecordsResponse | PlainMessage<GetFollowRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetFollowRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetLikeRecordsRequest
 */
export class GetLikeRecordsRequest extends Message<GetLikeRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetLikeRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikeRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikeRecordsRequest {
    return new GetLikeRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikeRecordsRequest {
    return new GetLikeRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikeRecordsRequest {
    return new GetLikeRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikeRecordsRequest | PlainMessage<GetLikeRecordsRequest> | undefined, b: GetLikeRecordsRequest | PlainMessage<GetLikeRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetLikeRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLikeRecordsResponse
 */
export class GetLikeRecordsResponse extends Message<GetLikeRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetLikeRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikeRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikeRecordsResponse {
    return new GetLikeRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikeRecordsResponse {
    return new GetLikeRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikeRecordsResponse {
    return new GetLikeRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikeRecordsResponse | PlainMessage<GetLikeRecordsResponse> | undefined, b: GetLikeRecordsResponse | PlainMessage<GetLikeRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetLikeRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetListBlockRecordsRequest
 */
export class GetListBlockRecordsRequest extends Message<GetListBlockRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetListBlockRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListBlockRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListBlockRecordsRequest {
    return new GetListBlockRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListBlockRecordsRequest {
    return new GetListBlockRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListBlockRecordsRequest {
    return new GetListBlockRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListBlockRecordsRequest | PlainMessage<GetListBlockRecordsRequest> | undefined, b: GetListBlockRecordsRequest | PlainMessage<GetListBlockRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetListBlockRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListBlockRecordsResponse
 */
export class GetListBlockRecordsResponse extends Message<GetListBlockRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetListBlockRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListBlockRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListBlockRecordsResponse {
    return new GetListBlockRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListBlockRecordsResponse {
    return new GetListBlockRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListBlockRecordsResponse {
    return new GetListBlockRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListBlockRecordsResponse | PlainMessage<GetListBlockRecordsResponse> | undefined, b: GetListBlockRecordsResponse | PlainMessage<GetListBlockRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetListBlockRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetListItemRecordsRequest
 */
export class GetListItemRecordsRequest extends Message<GetListItemRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetListItemRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListItemRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListItemRecordsRequest {
    return new GetListItemRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListItemRecordsRequest {
    return new GetListItemRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListItemRecordsRequest {
    return new GetListItemRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListItemRecordsRequest | PlainMessage<GetListItemRecordsRequest> | undefined, b: GetListItemRecordsRequest | PlainMessage<GetListItemRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetListItemRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListItemRecordsResponse
 */
export class GetListItemRecordsResponse extends Message<GetListItemRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetListItemRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListItemRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListItemRecordsResponse {
    return new GetListItemRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListItemRecordsResponse {
    return new GetListItemRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListItemRecordsResponse {
    return new GetListItemRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListItemRecordsResponse | PlainMessage<GetListItemRecordsResponse> | undefined, b: GetListItemRecordsResponse | PlainMessage<GetListItemRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetListItemRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetListRecordsRequest
 */
export class GetListRecordsRequest extends Message<GetListRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetListRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListRecordsRequest {
    return new GetListRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListRecordsRequest {
    return new GetListRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListRecordsRequest {
    return new GetListRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListRecordsRequest | PlainMessage<GetListRecordsRequest> | undefined, b: GetListRecordsRequest | PlainMessage<GetListRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetListRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListRecordsResponse
 */
export class GetListRecordsResponse extends Message<GetListRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetListRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListRecordsResponse {
    return new GetListRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListRecordsResponse {
    return new GetListRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListRecordsResponse {
    return new GetListRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListRecordsResponse | PlainMessage<GetListRecordsResponse> | undefined, b: GetListRecordsResponse | PlainMessage<GetListRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetListRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.PostRecordMeta
 */
export class PostRecordMeta extends Message<PostRecordMeta> {
  /**
   * @generated from field: bool violates_thread_gate = 1;
   */
  violatesThreadGate = false;

  /**
   * @generated from field: bool has_media = 2;
   */
  hasMedia = false;

  /**
   * @generated from field: bool is_reply = 3;
   */
  isReply = false;

  /**
   * @generated from field: bool violates_embedding_rules = 4;
   */
  violatesEmbeddingRules = false;

  /**
   * @generated from field: bool has_post_gate = 5;
   */
  hasPostGate = false;

  /**
   * @generated from field: bool has_thread_gate = 6;
   */
  hasThreadGate = false;

  /**
   * @generated from field: bool has_video = 7;
   */
  hasVideo = false;

  constructor(data?: PartialMessage<PostRecordMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PostRecordMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "violates_thread_gate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "has_media", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "violates_embedding_rules", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "has_post_gate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "has_thread_gate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "has_video", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostRecordMeta {
    return new PostRecordMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostRecordMeta {
    return new PostRecordMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostRecordMeta {
    return new PostRecordMeta().fromJsonString(jsonString, options);
  }

  static equals(a: PostRecordMeta | PlainMessage<PostRecordMeta> | undefined, b: PostRecordMeta | PlainMessage<PostRecordMeta> | undefined): boolean {
    return proto3.util.equals(PostRecordMeta, a, b);
  }
}

/**
 * @generated from message bsky.GetPostRecordsRequest
 */
export class GetPostRecordsRequest extends Message<GetPostRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: optional string process_dynamic_tags_for_view = 2;
   */
  processDynamicTagsForView?: string;

  /**
   * @generated from field: optional string viewer_did = 3;
   */
  viewerDid?: string;

  /**
   * Include complete canonical OP threads used by AppView to derive position
   * metadata. This is opt-in because resolving them is more expensive than
   * the normal post record lookup.
   *
   * @generated from field: bool include_op_thread_metadata = 4;
   */
  includeOpThreadMetadata = false;

  constructor(data?: PartialMessage<GetPostRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetPostRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "process_dynamic_tags_for_view", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "viewer_did", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "include_op_thread_metadata", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPostRecordsRequest {
    return new GetPostRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPostRecordsRequest {
    return new GetPostRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPostRecordsRequest {
    return new GetPostRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPostRecordsRequest | PlainMessage<GetPostRecordsRequest> | undefined, b: GetPostRecordsRequest | PlainMessage<GetPostRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetPostRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetPostRecordsResponse
 */
export class GetPostRecordsResponse extends Message<GetPostRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  /**
   * @generated from field: repeated bsky.PostRecordMeta meta = 2;
   */
  meta: PostRecordMeta[] = [];

  /**
   * Complete canonical OP threads for roots represented by the requested
   * posts. AppView derives each post's index and count from these chains.
   *
   * @generated from field: repeated bsky.OpThread op_threads = 3;
   */
  opThreads: OpThread[] = [];

  constructor(data?: PartialMessage<GetPostRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetPostRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
    { no: 2, name: "meta", kind: "message", T: PostRecordMeta, repeated: true },
    { no: 3, name: "op_threads", kind: "message", T: OpThread, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPostRecordsResponse {
    return new GetPostRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPostRecordsResponse {
    return new GetPostRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPostRecordsResponse {
    return new GetPostRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPostRecordsResponse | PlainMessage<GetPostRecordsResponse> | undefined, b: GetPostRecordsResponse | PlainMessage<GetPostRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetPostRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.OpThread
 */
export class OpThread extends Message<OpThread> {
  /**
   * @generated from field: string root_uri = 1;
   */
  rootUri = "";

  /**
   * The root post followed by its canonical chain of OP replies. Only chains
   * containing at least one OP reply are returned.
   *
   * @generated from field: repeated string uris = 2;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<OpThread>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.OpThread";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "root_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpThread {
    return new OpThread().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpThread {
    return new OpThread().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpThread {
    return new OpThread().fromJsonString(jsonString, options);
  }

  static equals(a: OpThread | PlainMessage<OpThread> | undefined, b: OpThread | PlainMessage<OpThread> | undefined): boolean {
    return proto3.util.equals(OpThread, a, b);
  }
}

/**
 * @generated from message bsky.GetProfileRecordsRequest
 */
export class GetProfileRecordsRequest extends Message<GetProfileRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetProfileRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetProfileRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileRecordsRequest {
    return new GetProfileRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileRecordsRequest {
    return new GetProfileRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileRecordsRequest {
    return new GetProfileRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileRecordsRequest | PlainMessage<GetProfileRecordsRequest> | undefined, b: GetProfileRecordsRequest | PlainMessage<GetProfileRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetProfileRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetProfileRecordsResponse
 */
export class GetProfileRecordsResponse extends Message<GetProfileRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetProfileRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetProfileRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileRecordsResponse {
    return new GetProfileRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileRecordsResponse {
    return new GetProfileRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileRecordsResponse {
    return new GetProfileRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileRecordsResponse | PlainMessage<GetProfileRecordsResponse> | undefined, b: GetProfileRecordsResponse | PlainMessage<GetProfileRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetProfileRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActorChatDeclarationRecordsRequest
 */
export class GetActorChatDeclarationRecordsRequest extends Message<GetActorChatDeclarationRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetActorChatDeclarationRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorChatDeclarationRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorChatDeclarationRecordsRequest {
    return new GetActorChatDeclarationRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorChatDeclarationRecordsRequest {
    return new GetActorChatDeclarationRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorChatDeclarationRecordsRequest {
    return new GetActorChatDeclarationRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorChatDeclarationRecordsRequest | PlainMessage<GetActorChatDeclarationRecordsRequest> | undefined, b: GetActorChatDeclarationRecordsRequest | PlainMessage<GetActorChatDeclarationRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorChatDeclarationRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorChatDeclarationRecordsResponse
 */
export class GetActorChatDeclarationRecordsResponse extends Message<GetActorChatDeclarationRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetActorChatDeclarationRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorChatDeclarationRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorChatDeclarationRecordsResponse {
    return new GetActorChatDeclarationRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorChatDeclarationRecordsResponse {
    return new GetActorChatDeclarationRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorChatDeclarationRecordsResponse {
    return new GetActorChatDeclarationRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorChatDeclarationRecordsResponse | PlainMessage<GetActorChatDeclarationRecordsResponse> | undefined, b: GetActorChatDeclarationRecordsResponse | PlainMessage<GetActorChatDeclarationRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorChatDeclarationRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationDeclarationRecordsRequest
 */
export class GetNotificationDeclarationRecordsRequest extends Message<GetNotificationDeclarationRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetNotificationDeclarationRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationDeclarationRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationDeclarationRecordsRequest {
    return new GetNotificationDeclarationRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationDeclarationRecordsRequest {
    return new GetNotificationDeclarationRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationDeclarationRecordsRequest {
    return new GetNotificationDeclarationRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationDeclarationRecordsRequest | PlainMessage<GetNotificationDeclarationRecordsRequest> | undefined, b: GetNotificationDeclarationRecordsRequest | PlainMessage<GetNotificationDeclarationRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetNotificationDeclarationRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationDeclarationRecordsResponse
 */
export class GetNotificationDeclarationRecordsResponse extends Message<GetNotificationDeclarationRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetNotificationDeclarationRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationDeclarationRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationDeclarationRecordsResponse {
    return new GetNotificationDeclarationRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationDeclarationRecordsResponse {
    return new GetNotificationDeclarationRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationDeclarationRecordsResponse {
    return new GetNotificationDeclarationRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationDeclarationRecordsResponse | PlainMessage<GetNotificationDeclarationRecordsResponse> | undefined, b: GetNotificationDeclarationRecordsResponse | PlainMessage<GetNotificationDeclarationRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetNotificationDeclarationRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetGermDeclarationRecordsRequest
 */
export class GetGermDeclarationRecordsRequest extends Message<GetGermDeclarationRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetGermDeclarationRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetGermDeclarationRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGermDeclarationRecordsRequest {
    return new GetGermDeclarationRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGermDeclarationRecordsRequest {
    return new GetGermDeclarationRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGermDeclarationRecordsRequest {
    return new GetGermDeclarationRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGermDeclarationRecordsRequest | PlainMessage<GetGermDeclarationRecordsRequest> | undefined, b: GetGermDeclarationRecordsRequest | PlainMessage<GetGermDeclarationRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetGermDeclarationRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetGermDeclarationRecordsResponse
 */
export class GetGermDeclarationRecordsResponse extends Message<GetGermDeclarationRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetGermDeclarationRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetGermDeclarationRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGermDeclarationRecordsResponse {
    return new GetGermDeclarationRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGermDeclarationRecordsResponse {
    return new GetGermDeclarationRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGermDeclarationRecordsResponse {
    return new GetGermDeclarationRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGermDeclarationRecordsResponse | PlainMessage<GetGermDeclarationRecordsResponse> | undefined, b: GetGermDeclarationRecordsResponse | PlainMessage<GetGermDeclarationRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetGermDeclarationRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetStatusRecordsRequest
 */
export class GetStatusRecordsRequest extends Message<GetStatusRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetStatusRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStatusRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStatusRecordsRequest {
    return new GetStatusRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStatusRecordsRequest {
    return new GetStatusRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStatusRecordsRequest {
    return new GetStatusRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStatusRecordsRequest | PlainMessage<GetStatusRecordsRequest> | undefined, b: GetStatusRecordsRequest | PlainMessage<GetStatusRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetStatusRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetStatusRecordsResponse
 */
export class GetStatusRecordsResponse extends Message<GetStatusRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetStatusRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStatusRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStatusRecordsResponse {
    return new GetStatusRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStatusRecordsResponse {
    return new GetStatusRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStatusRecordsResponse {
    return new GetStatusRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStatusRecordsResponse | PlainMessage<GetStatusRecordsResponse> | undefined, b: GetStatusRecordsResponse | PlainMessage<GetStatusRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetStatusRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetRepostRecordsRequest
 */
export class GetRepostRecordsRequest extends Message<GetRepostRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetRepostRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostRecordsRequest {
    return new GetRepostRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostRecordsRequest {
    return new GetRepostRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostRecordsRequest {
    return new GetRepostRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostRecordsRequest | PlainMessage<GetRepostRecordsRequest> | undefined, b: GetRepostRecordsRequest | PlainMessage<GetRepostRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetRepostRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetRepostRecordsResponse
 */
export class GetRepostRecordsResponse extends Message<GetRepostRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetRepostRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostRecordsResponse {
    return new GetRepostRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostRecordsResponse {
    return new GetRepostRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostRecordsResponse {
    return new GetRepostRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostRecordsResponse | PlainMessage<GetRepostRecordsResponse> | undefined, b: GetRepostRecordsResponse | PlainMessage<GetRepostRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetRepostRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetThreadGateRecordsRequest
 */
export class GetThreadGateRecordsRequest extends Message<GetThreadGateRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetThreadGateRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadGateRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadGateRecordsRequest {
    return new GetThreadGateRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadGateRecordsRequest {
    return new GetThreadGateRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadGateRecordsRequest {
    return new GetThreadGateRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadGateRecordsRequest | PlainMessage<GetThreadGateRecordsRequest> | undefined, b: GetThreadGateRecordsRequest | PlainMessage<GetThreadGateRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetThreadGateRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetThreadGateRecordsResponse
 */
export class GetThreadGateRecordsResponse extends Message<GetThreadGateRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetThreadGateRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadGateRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadGateRecordsResponse {
    return new GetThreadGateRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadGateRecordsResponse {
    return new GetThreadGateRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadGateRecordsResponse {
    return new GetThreadGateRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadGateRecordsResponse | PlainMessage<GetThreadGateRecordsResponse> | undefined, b: GetThreadGateRecordsResponse | PlainMessage<GetThreadGateRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetThreadGateRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetPostgateRecordsRequest
 */
export class GetPostgateRecordsRequest extends Message<GetPostgateRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetPostgateRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetPostgateRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPostgateRecordsRequest {
    return new GetPostgateRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPostgateRecordsRequest {
    return new GetPostgateRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPostgateRecordsRequest {
    return new GetPostgateRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPostgateRecordsRequest | PlainMessage<GetPostgateRecordsRequest> | undefined, b: GetPostgateRecordsRequest | PlainMessage<GetPostgateRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetPostgateRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetPostgateRecordsResponse
 */
export class GetPostgateRecordsResponse extends Message<GetPostgateRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetPostgateRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetPostgateRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPostgateRecordsResponse {
    return new GetPostgateRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPostgateRecordsResponse {
    return new GetPostgateRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPostgateRecordsResponse {
    return new GetPostgateRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPostgateRecordsResponse | PlainMessage<GetPostgateRecordsResponse> | undefined, b: GetPostgateRecordsResponse | PlainMessage<GetPostgateRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetPostgateRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetLabelerRecordsRequest
 */
export class GetLabelerRecordsRequest extends Message<GetLabelerRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetLabelerRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLabelerRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLabelerRecordsRequest {
    return new GetLabelerRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLabelerRecordsRequest {
    return new GetLabelerRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLabelerRecordsRequest {
    return new GetLabelerRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLabelerRecordsRequest | PlainMessage<GetLabelerRecordsRequest> | undefined, b: GetLabelerRecordsRequest | PlainMessage<GetLabelerRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetLabelerRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLabelerRecordsResponse
 */
export class GetLabelerRecordsResponse extends Message<GetLabelerRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetLabelerRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLabelerRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLabelerRecordsResponse {
    return new GetLabelerRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLabelerRecordsResponse {
    return new GetLabelerRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLabelerRecordsResponse {
    return new GetLabelerRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLabelerRecordsResponse | PlainMessage<GetLabelerRecordsResponse> | undefined, b: GetLabelerRecordsResponse | PlainMessage<GetLabelerRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetLabelerRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetAllLabelersRequest
 */
export class GetAllLabelersRequest extends Message<GetAllLabelersRequest> {
  constructor(data?: PartialMessage<GetAllLabelersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetAllLabelersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAllLabelersRequest {
    return new GetAllLabelersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAllLabelersRequest {
    return new GetAllLabelersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAllLabelersRequest {
    return new GetAllLabelersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAllLabelersRequest | PlainMessage<GetAllLabelersRequest> | undefined, b: GetAllLabelersRequest | PlainMessage<GetAllLabelersRequest> | undefined): boolean {
    return proto3.util.equals(GetAllLabelersRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetAllLabelersResponse
 */
export class GetAllLabelersResponse extends Message<GetAllLabelersResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: repeated bsky.Record records = 2;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetAllLabelersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetAllLabelersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAllLabelersResponse {
    return new GetAllLabelersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAllLabelersResponse {
    return new GetAllLabelersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAllLabelersResponse {
    return new GetAllLabelersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAllLabelersResponse | PlainMessage<GetAllLabelersResponse> | undefined, b: GetAllLabelersResponse | PlainMessage<GetAllLabelersResponse> | undefined): boolean {
    return proto3.util.equals(GetAllLabelersResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetStarterPackRecordsRequest
 */
export class GetStarterPackRecordsRequest extends Message<GetStarterPackRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetStarterPackRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStarterPackRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStarterPackRecordsRequest {
    return new GetStarterPackRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStarterPackRecordsRequest {
    return new GetStarterPackRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStarterPackRecordsRequest {
    return new GetStarterPackRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStarterPackRecordsRequest | PlainMessage<GetStarterPackRecordsRequest> | undefined, b: GetStarterPackRecordsRequest | PlainMessage<GetStarterPackRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetStarterPackRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetStarterPackRecordsResponse
 */
export class GetStarterPackRecordsResponse extends Message<GetStarterPackRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetStarterPackRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStarterPackRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStarterPackRecordsResponse {
    return new GetStarterPackRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStarterPackRecordsResponse {
    return new GetStarterPackRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStarterPackRecordsResponse {
    return new GetStarterPackRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStarterPackRecordsResponse | PlainMessage<GetStarterPackRecordsResponse> | undefined, b: GetStarterPackRecordsResponse | PlainMessage<GetStarterPackRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetStarterPackRecordsResponse, a, b);
  }
}

/**
 * - Return follow uris where user A follows users B, C, D, …
 *     - E.g. for viewer state on `getProfiles`
 *
 * @generated from message bsky.GetActorFollowsActorsRequest
 */
export class GetActorFollowsActorsRequest extends Message<GetActorFollowsActorsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string target_dids = 2;
   */
  targetDids: string[] = [];

  constructor(data?: PartialMessage<GetActorFollowsActorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorFollowsActorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorFollowsActorsRequest {
    return new GetActorFollowsActorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorFollowsActorsRequest {
    return new GetActorFollowsActorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorFollowsActorsRequest {
    return new GetActorFollowsActorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorFollowsActorsRequest | PlainMessage<GetActorFollowsActorsRequest> | undefined, b: GetActorFollowsActorsRequest | PlainMessage<GetActorFollowsActorsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorFollowsActorsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorFollowsActorsResponse
 */
export class GetActorFollowsActorsResponse extends Message<GetActorFollowsActorsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetActorFollowsActorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorFollowsActorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorFollowsActorsResponse {
    return new GetActorFollowsActorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorFollowsActorsResponse {
    return new GetActorFollowsActorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorFollowsActorsResponse {
    return new GetActorFollowsActorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorFollowsActorsResponse | PlainMessage<GetActorFollowsActorsResponse> | undefined, b: GetActorFollowsActorsResponse | PlainMessage<GetActorFollowsActorsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorFollowsActorsResponse, a, b);
  }
}

/**
 * - Return follow uris of users who follows user A
 *     - For `getFollowers` list
 *
 * @generated from message bsky.GetFollowersRequest
 */
export class GetFollowersRequest extends Message<GetFollowersRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: string sort = 4;
   */
  sort = "";

  constructor(data?: PartialMessage<GetFollowersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowersRequest {
    return new GetFollowersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowersRequest {
    return new GetFollowersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowersRequest {
    return new GetFollowersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowersRequest | PlainMessage<GetFollowersRequest> | undefined, b: GetFollowersRequest | PlainMessage<GetFollowersRequest> | undefined): boolean {
    return proto3.util.equals(GetFollowersRequest, a, b);
  }
}

/**
 * @generated from message bsky.FollowInfo
 */
export class FollowInfo extends Message<FollowInfo> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string actor_did = 2;
   */
  actorDid = "";

  /**
   * @generated from field: string subject_did = 3;
   */
  subjectDid = "";

  constructor(data?: PartialMessage<FollowInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.FollowInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FollowInfo {
    return new FollowInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FollowInfo {
    return new FollowInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FollowInfo {
    return new FollowInfo().fromJsonString(jsonString, options);
  }

  static equals(a: FollowInfo | PlainMessage<FollowInfo> | undefined, b: FollowInfo | PlainMessage<FollowInfo> | undefined): boolean {
    return proto3.util.equals(FollowInfo, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowersResponse
 */
export class GetFollowersResponse extends Message<GetFollowersResponse> {
  /**
   * @generated from field: repeated bsky.FollowInfo followers = 1;
   */
  followers: FollowInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetFollowersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "followers", kind: "message", T: FollowInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowersResponse {
    return new GetFollowersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowersResponse {
    return new GetFollowersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowersResponse {
    return new GetFollowersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowersResponse | PlainMessage<GetFollowersResponse> | undefined, b: GetFollowersResponse | PlainMessage<GetFollowersResponse> | undefined): boolean {
    return proto3.util.equals(GetFollowersResponse, a, b);
  }
}

/**
 * - Return follow uris of users A follows
 *     - For `getFollows` list
 *
 * @generated from message bsky.GetFollowsRequest
 */
export class GetFollowsRequest extends Message<GetFollowsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: string sort = 4;
   */
  sort = "";

  constructor(data?: PartialMessage<GetFollowsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowsRequest {
    return new GetFollowsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowsRequest {
    return new GetFollowsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowsRequest {
    return new GetFollowsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowsRequest | PlainMessage<GetFollowsRequest> | undefined, b: GetFollowsRequest | PlainMessage<GetFollowsRequest> | undefined): boolean {
    return proto3.util.equals(GetFollowsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowsResponse
 */
export class GetFollowsResponse extends Message<GetFollowsResponse> {
  /**
   * @generated from field: repeated bsky.FollowInfo follows = 1;
   */
  follows: FollowInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetFollowsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "follows", kind: "message", T: FollowInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowsResponse {
    return new GetFollowsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowsResponse {
    return new GetFollowsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowsResponse {
    return new GetFollowsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowsResponse | PlainMessage<GetFollowsResponse> | undefined, b: GetFollowsResponse | PlainMessage<GetFollowsResponse> | undefined): boolean {
    return proto3.util.equals(GetFollowsResponse, a, b);
  }
}

/**
 * @generated from message bsky.VerificationMeta
 */
export class VerificationMeta extends Message<VerificationMeta> {
  /**
   * @generated from field: string rkey = 1;
   */
  rkey = "";

  /**
   * @generated from field: string handle = 2;
   */
  handle = "";

  /**
   * @generated from field: string display_name = 3;
   */
  displayName = "";

  /**
   * @generated from field: google.protobuf.Timestamp sorted_at = 4;
   */
  sortedAt?: Timestamp;

  constructor(data?: PartialMessage<VerificationMeta>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.VerificationMeta";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rkey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sorted_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerificationMeta {
    return new VerificationMeta().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerificationMeta {
    return new VerificationMeta().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerificationMeta {
    return new VerificationMeta().fromJsonString(jsonString, options);
  }

  static equals(a: VerificationMeta | PlainMessage<VerificationMeta> | undefined, b: VerificationMeta | PlainMessage<VerificationMeta> | undefined): boolean {
    return proto3.util.equals(VerificationMeta, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationRecordsRequest
 */
export class GetVerificationRecordsRequest extends Message<GetVerificationRecordsRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetVerificationRecordsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationRecordsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationRecordsRequest {
    return new GetVerificationRecordsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationRecordsRequest {
    return new GetVerificationRecordsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationRecordsRequest {
    return new GetVerificationRecordsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationRecordsRequest | PlainMessage<GetVerificationRecordsRequest> | undefined, b: GetVerificationRecordsRequest | PlainMessage<GetVerificationRecordsRequest> | undefined): boolean {
    return proto3.util.equals(GetVerificationRecordsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationRecordsResponse
 */
export class GetVerificationRecordsResponse extends Message<GetVerificationRecordsResponse> {
  /**
   * @generated from field: repeated bsky.Record records = 1;
   */
  records: Record[] = [];

  constructor(data?: PartialMessage<GetVerificationRecordsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationRecordsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "records", kind: "message", T: Record, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationRecordsResponse {
    return new GetVerificationRecordsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationRecordsResponse {
    return new GetVerificationRecordsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationRecordsResponse {
    return new GetVerificationRecordsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationRecordsResponse | PlainMessage<GetVerificationRecordsResponse> | undefined, b: GetVerificationRecordsResponse | PlainMessage<GetVerificationRecordsResponse> | undefined): boolean {
    return proto3.util.equals(GetVerificationRecordsResponse, a, b);
  }
}

/**
 * @generated from message bsky.VerificationIssued
 */
export class VerificationIssued extends Message<VerificationIssued> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string rkey = 2;
   */
  rkey = "";

  /**
   * @generated from field: string subject_did = 3;
   */
  subjectDid = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp indexed_at = 8;
   */
  indexedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp sorted_at = 9;
   */
  sortedAt?: Timestamp;

  constructor(data?: PartialMessage<VerificationIssued>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.VerificationIssued";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rkey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "indexed_at", kind: "message", T: Timestamp },
    { no: 9, name: "sorted_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerificationIssued {
    return new VerificationIssued().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerificationIssued {
    return new VerificationIssued().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerificationIssued {
    return new VerificationIssued().fromJsonString(jsonString, options);
  }

  static equals(a: VerificationIssued | PlainMessage<VerificationIssued> | undefined, b: VerificationIssued | PlainMessage<VerificationIssued> | undefined): boolean {
    return proto3.util.equals(VerificationIssued, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationsIssuedRequest
 */
export class GetVerificationsIssuedRequest extends Message<GetVerificationsIssuedRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetVerificationsIssuedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationsIssuedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationsIssuedRequest {
    return new GetVerificationsIssuedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationsIssuedRequest {
    return new GetVerificationsIssuedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationsIssuedRequest {
    return new GetVerificationsIssuedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationsIssuedRequest | PlainMessage<GetVerificationsIssuedRequest> | undefined, b: GetVerificationsIssuedRequest | PlainMessage<GetVerificationsIssuedRequest> | undefined): boolean {
    return proto3.util.equals(GetVerificationsIssuedRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationsIssuedResponse
 */
export class GetVerificationsIssuedResponse extends Message<GetVerificationsIssuedResponse> {
  /**
   * @generated from field: repeated bsky.VerificationIssued verifications = 1;
   */
  verifications: VerificationIssued[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetVerificationsIssuedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationsIssuedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "verifications", kind: "message", T: VerificationIssued, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationsIssuedResponse {
    return new GetVerificationsIssuedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationsIssuedResponse {
    return new GetVerificationsIssuedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationsIssuedResponse {
    return new GetVerificationsIssuedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationsIssuedResponse | PlainMessage<GetVerificationsIssuedResponse> | undefined, b: GetVerificationsIssuedResponse | PlainMessage<GetVerificationsIssuedResponse> | undefined): boolean {
    return proto3.util.equals(GetVerificationsIssuedResponse, a, b);
  }
}

/**
 * @generated from message bsky.VerificationReceived
 */
export class VerificationReceived extends Message<VerificationReceived> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string rkey = 2;
   */
  rkey = "";

  /**
   * @generated from field: string subject_did = 3;
   */
  subjectDid = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp indexed_at = 8;
   */
  indexedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp sorted_at = 9;
   */
  sortedAt?: Timestamp;

  constructor(data?: PartialMessage<VerificationReceived>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.VerificationReceived";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rkey", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "indexed_at", kind: "message", T: Timestamp },
    { no: 9, name: "sorted_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerificationReceived {
    return new VerificationReceived().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerificationReceived {
    return new VerificationReceived().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerificationReceived {
    return new VerificationReceived().fromJsonString(jsonString, options);
  }

  static equals(a: VerificationReceived | PlainMessage<VerificationReceived> | undefined, b: VerificationReceived | PlainMessage<VerificationReceived> | undefined): boolean {
    return proto3.util.equals(VerificationReceived, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationsReceivedRequest
 */
export class GetVerificationsReceivedRequest extends Message<GetVerificationsReceivedRequest> {
  /**
   * @generated from field: string subject_did = 1;
   */
  subjectDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetVerificationsReceivedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationsReceivedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationsReceivedRequest {
    return new GetVerificationsReceivedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationsReceivedRequest {
    return new GetVerificationsReceivedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationsReceivedRequest {
    return new GetVerificationsReceivedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationsReceivedRequest | PlainMessage<GetVerificationsReceivedRequest> | undefined, b: GetVerificationsReceivedRequest | PlainMessage<GetVerificationsReceivedRequest> | undefined): boolean {
    return proto3.util.equals(GetVerificationsReceivedRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetVerificationsReceivedResponse
 */
export class GetVerificationsReceivedResponse extends Message<GetVerificationsReceivedResponse> {
  /**
   * @generated from field: repeated bsky.VerificationReceived verifications = 1;
   */
  verifications: VerificationReceived[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetVerificationsReceivedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetVerificationsReceivedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "verifications", kind: "message", T: VerificationReceived, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetVerificationsReceivedResponse {
    return new GetVerificationsReceivedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetVerificationsReceivedResponse {
    return new GetVerificationsReceivedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetVerificationsReceivedResponse {
    return new GetVerificationsReceivedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetVerificationsReceivedResponse | PlainMessage<GetVerificationsReceivedResponse> | undefined, b: GetVerificationsReceivedResponse | PlainMessage<GetVerificationsReceivedResponse> | undefined): boolean {
    return proto3.util.equals(GetVerificationsReceivedResponse, a, b);
  }
}

/**
 * - return like uris where subject uri is subject A
 *     - `getLikes` list for a post
 *
 * @generated from message bsky.GetLikesBySubjectRequest
 */
export class GetLikesBySubjectRequest extends Message<GetLikesBySubjectRequest> {
  /**
   * @generated from field: bsky.RecordRef subject = 1;
   */
  subject?: RecordRef;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetLikesBySubjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesBySubjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "message", T: RecordRef },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesBySubjectRequest {
    return new GetLikesBySubjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesBySubjectRequest {
    return new GetLikesBySubjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesBySubjectRequest {
    return new GetLikesBySubjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesBySubjectRequest | PlainMessage<GetLikesBySubjectRequest> | undefined, b: GetLikesBySubjectRequest | PlainMessage<GetLikesBySubjectRequest> | undefined): boolean {
    return proto3.util.equals(GetLikesBySubjectRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLikesBySubjectResponse
 */
export class GetLikesBySubjectResponse extends Message<GetLikesBySubjectResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetLikesBySubjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesBySubjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesBySubjectResponse {
    return new GetLikesBySubjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesBySubjectResponse {
    return new GetLikesBySubjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesBySubjectResponse {
    return new GetLikesBySubjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesBySubjectResponse | PlainMessage<GetLikesBySubjectResponse> | undefined, b: GetLikesBySubjectResponse | PlainMessage<GetLikesBySubjectResponse> | undefined): boolean {
    return proto3.util.equals(GetLikesBySubjectResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetLikesBySubjectSortedRequest
 */
export class GetLikesBySubjectSortedRequest extends Message<GetLikesBySubjectSortedRequest> {
  /**
   * @generated from field: bsky.RecordRef subject = 1;
   */
  subject?: RecordRef;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetLikesBySubjectSortedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesBySubjectSortedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "message", T: RecordRef },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesBySubjectSortedRequest {
    return new GetLikesBySubjectSortedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesBySubjectSortedRequest {
    return new GetLikesBySubjectSortedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesBySubjectSortedRequest {
    return new GetLikesBySubjectSortedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesBySubjectSortedRequest | PlainMessage<GetLikesBySubjectSortedRequest> | undefined, b: GetLikesBySubjectSortedRequest | PlainMessage<GetLikesBySubjectSortedRequest> | undefined): boolean {
    return proto3.util.equals(GetLikesBySubjectSortedRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLikesBySubjectSortedResponse
 */
export class GetLikesBySubjectSortedResponse extends Message<GetLikesBySubjectSortedResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetLikesBySubjectSortedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesBySubjectSortedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesBySubjectSortedResponse {
    return new GetLikesBySubjectSortedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesBySubjectSortedResponse {
    return new GetLikesBySubjectSortedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesBySubjectSortedResponse {
    return new GetLikesBySubjectSortedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesBySubjectSortedResponse | PlainMessage<GetLikesBySubjectSortedResponse> | undefined, b: GetLikesBySubjectSortedResponse | PlainMessage<GetLikesBySubjectSortedResponse> | undefined): boolean {
    return proto3.util.equals(GetLikesBySubjectSortedResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetKnownLikersRequest
 */
export class GetKnownLikersRequest extends Message<GetKnownLikersRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string subject_uris = 2;
   */
  subjectUris: string[] = [];

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  constructor(data?: PartialMessage<GetKnownLikersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetKnownLikersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetKnownLikersRequest {
    return new GetKnownLikersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetKnownLikersRequest {
    return new GetKnownLikersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetKnownLikersRequest {
    return new GetKnownLikersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetKnownLikersRequest | PlainMessage<GetKnownLikersRequest> | undefined, b: GetKnownLikersRequest | PlainMessage<GetKnownLikersRequest> | undefined): boolean {
    return proto3.util.equals(GetKnownLikersRequest, a, b);
  }
}

/**
 * @generated from message bsky.KnownLikersResult
 */
export class KnownLikersResult extends Message<KnownLikersResult> {
  /**
   * @generated from field: string subject_uri = 1;
   */
  subjectUri = "";

  /**
   * @generated from field: int32 count = 2;
   */
  count = 0;

  /**
   * @generated from field: repeated string dids = 3;
   */
  dids: string[] = [];

  constructor(data?: PartialMessage<KnownLikersResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.KnownLikersResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KnownLikersResult {
    return new KnownLikersResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KnownLikersResult {
    return new KnownLikersResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KnownLikersResult {
    return new KnownLikersResult().fromJsonString(jsonString, options);
  }

  static equals(a: KnownLikersResult | PlainMessage<KnownLikersResult> | undefined, b: KnownLikersResult | PlainMessage<KnownLikersResult> | undefined): boolean {
    return proto3.util.equals(KnownLikersResult, a, b);
  }
}

/**
 * @generated from message bsky.GetKnownLikersResponse
 */
export class GetKnownLikersResponse extends Message<GetKnownLikersResponse> {
  /**
   * @generated from field: repeated bsky.KnownLikersResult results = 1;
   */
  results: KnownLikersResult[] = [];

  constructor(data?: PartialMessage<GetKnownLikersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetKnownLikersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: KnownLikersResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetKnownLikersResponse {
    return new GetKnownLikersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetKnownLikersResponse {
    return new GetKnownLikersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetKnownLikersResponse {
    return new GetKnownLikersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetKnownLikersResponse | PlainMessage<GetKnownLikersResponse> | undefined, b: GetKnownLikersResponse | PlainMessage<GetKnownLikersResponse> | undefined): boolean {
    return proto3.util.equals(GetKnownLikersResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetQuotesBySubjectSortedRequest
 */
export class GetQuotesBySubjectSortedRequest extends Message<GetQuotesBySubjectSortedRequest> {
  /**
   * @generated from field: bsky.RecordRef subject = 1;
   */
  subject?: RecordRef;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetQuotesBySubjectSortedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetQuotesBySubjectSortedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "message", T: RecordRef },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetQuotesBySubjectSortedRequest {
    return new GetQuotesBySubjectSortedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetQuotesBySubjectSortedRequest {
    return new GetQuotesBySubjectSortedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetQuotesBySubjectSortedRequest {
    return new GetQuotesBySubjectSortedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetQuotesBySubjectSortedRequest | PlainMessage<GetQuotesBySubjectSortedRequest> | undefined, b: GetQuotesBySubjectSortedRequest | PlainMessage<GetQuotesBySubjectSortedRequest> | undefined): boolean {
    return proto3.util.equals(GetQuotesBySubjectSortedRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetQuotesBySubjectSortedResponse
 */
export class GetQuotesBySubjectSortedResponse extends Message<GetQuotesBySubjectSortedResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetQuotesBySubjectSortedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetQuotesBySubjectSortedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetQuotesBySubjectSortedResponse {
    return new GetQuotesBySubjectSortedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetQuotesBySubjectSortedResponse {
    return new GetQuotesBySubjectSortedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetQuotesBySubjectSortedResponse {
    return new GetQuotesBySubjectSortedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetQuotesBySubjectSortedResponse | PlainMessage<GetQuotesBySubjectSortedResponse> | undefined, b: GetQuotesBySubjectSortedResponse | PlainMessage<GetQuotesBySubjectSortedResponse> | undefined): boolean {
    return proto3.util.equals(GetQuotesBySubjectSortedResponse, a, b);
  }
}

/**
 * - return like uris for user A on subject B, C, D...
 *     - viewer state on posts
 *
 * @generated from message bsky.GetLikesByActorAndSubjectsRequest
 */
export class GetLikesByActorAndSubjectsRequest extends Message<GetLikesByActorAndSubjectsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated bsky.RecordRef refs = 2;
   */
  refs: RecordRef[] = [];

  constructor(data?: PartialMessage<GetLikesByActorAndSubjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesByActorAndSubjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "refs", kind: "message", T: RecordRef, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesByActorAndSubjectsRequest {
    return new GetLikesByActorAndSubjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesByActorAndSubjectsRequest {
    return new GetLikesByActorAndSubjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesByActorAndSubjectsRequest {
    return new GetLikesByActorAndSubjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesByActorAndSubjectsRequest | PlainMessage<GetLikesByActorAndSubjectsRequest> | undefined, b: GetLikesByActorAndSubjectsRequest | PlainMessage<GetLikesByActorAndSubjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetLikesByActorAndSubjectsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLikesByActorAndSubjectsResponse
 */
export class GetLikesByActorAndSubjectsResponse extends Message<GetLikesByActorAndSubjectsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetLikesByActorAndSubjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLikesByActorAndSubjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLikesByActorAndSubjectsResponse {
    return new GetLikesByActorAndSubjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLikesByActorAndSubjectsResponse {
    return new GetLikesByActorAndSubjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLikesByActorAndSubjectsResponse {
    return new GetLikesByActorAndSubjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLikesByActorAndSubjectsResponse | PlainMessage<GetLikesByActorAndSubjectsResponse> | undefined, b: GetLikesByActorAndSubjectsResponse | PlainMessage<GetLikesByActorAndSubjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetLikesByActorAndSubjectsResponse, a, b);
  }
}

/**
 * - return recent like uris for user A
 *     - `getActorLikes` list for a user
 *
 * @generated from message bsky.GetActorLikesRequest
 */
export class GetActorLikesRequest extends Message<GetActorLikesRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorLikesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorLikesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorLikesRequest {
    return new GetActorLikesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorLikesRequest {
    return new GetActorLikesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorLikesRequest {
    return new GetActorLikesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorLikesRequest | PlainMessage<GetActorLikesRequest> | undefined, b: GetActorLikesRequest | PlainMessage<GetActorLikesRequest> | undefined): boolean {
    return proto3.util.equals(GetActorLikesRequest, a, b);
  }
}

/**
 * @generated from message bsky.LikeInfo
 */
export class LikeInfo extends Message<LikeInfo> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string subject = 2;
   */
  subject = "";

  constructor(data?: PartialMessage<LikeInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.LikeInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LikeInfo {
    return new LikeInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LikeInfo {
    return new LikeInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LikeInfo {
    return new LikeInfo().fromJsonString(jsonString, options);
  }

  static equals(a: LikeInfo | PlainMessage<LikeInfo> | undefined, b: LikeInfo | PlainMessage<LikeInfo> | undefined): boolean {
    return proto3.util.equals(LikeInfo, a, b);
  }
}

/**
 * @generated from message bsky.GetActorLikesResponse
 */
export class GetActorLikesResponse extends Message<GetActorLikesResponse> {
  /**
   * @generated from field: repeated bsky.LikeInfo likes = 1;
   */
  likes: LikeInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorLikesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorLikesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "likes", kind: "message", T: LikeInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorLikesResponse {
    return new GetActorLikesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorLikesResponse {
    return new GetActorLikesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorLikesResponse {
    return new GetActorLikesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorLikesResponse | PlainMessage<GetActorLikesResponse> | undefined, b: GetActorLikesResponse | PlainMessage<GetActorLikesResponse> | undefined): boolean {
    return proto3.util.equals(GetActorLikesResponse, a, b);
  }
}

/**
 *
 * Interactions
 *
 *
 * @generated from message bsky.GetInteractionCountsRequest
 */
export class GetInteractionCountsRequest extends Message<GetInteractionCountsRequest> {
  /**
   * @generated from field: repeated bsky.RecordRef refs = 1;
   */
  refs: RecordRef[] = [];

  /**
   * @generated from field: repeated string skip_cache_for_dids = 2;
   */
  skipCacheForDids: string[] = [];

  constructor(data?: PartialMessage<GetInteractionCountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetInteractionCountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refs", kind: "message", T: RecordRef, repeated: true },
    { no: 2, name: "skip_cache_for_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInteractionCountsRequest {
    return new GetInteractionCountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInteractionCountsRequest {
    return new GetInteractionCountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInteractionCountsRequest {
    return new GetInteractionCountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetInteractionCountsRequest | PlainMessage<GetInteractionCountsRequest> | undefined, b: GetInteractionCountsRequest | PlainMessage<GetInteractionCountsRequest> | undefined): boolean {
    return proto3.util.equals(GetInteractionCountsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetInteractionCountsResponse
 */
export class GetInteractionCountsResponse extends Message<GetInteractionCountsResponse> {
  /**
   * @generated from field: repeated int32 likes = 1;
   */
  likes: number[] = [];

  /**
   * @generated from field: repeated int32 reposts = 2;
   */
  reposts: number[] = [];

  /**
   * @generated from field: repeated int32 replies = 3;
   */
  replies: number[] = [];

  /**
   * @generated from field: repeated int32 quotes = 4;
   */
  quotes: number[] = [];

  /**
   * @generated from field: repeated int32 bookmarks = 5;
   */
  bookmarks: number[] = [];

  constructor(data?: PartialMessage<GetInteractionCountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetInteractionCountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "likes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "reposts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "replies", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "quotes", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 5, name: "bookmarks", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInteractionCountsResponse {
    return new GetInteractionCountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInteractionCountsResponse {
    return new GetInteractionCountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInteractionCountsResponse {
    return new GetInteractionCountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetInteractionCountsResponse | PlainMessage<GetInteractionCountsResponse> | undefined, b: GetInteractionCountsResponse | PlainMessage<GetInteractionCountsResponse> | undefined): boolean {
    return proto3.util.equals(GetInteractionCountsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetCountsForUsersRequest
 */
export class GetCountsForUsersRequest extends Message<GetCountsForUsersRequest> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  constructor(data?: PartialMessage<GetCountsForUsersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetCountsForUsersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCountsForUsersRequest {
    return new GetCountsForUsersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCountsForUsersRequest {
    return new GetCountsForUsersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCountsForUsersRequest {
    return new GetCountsForUsersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetCountsForUsersRequest | PlainMessage<GetCountsForUsersRequest> | undefined, b: GetCountsForUsersRequest | PlainMessage<GetCountsForUsersRequest> | undefined): boolean {
    return proto3.util.equals(GetCountsForUsersRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetCountsForUsersResponse
 */
export class GetCountsForUsersResponse extends Message<GetCountsForUsersResponse> {
  /**
   * @generated from field: repeated int32 posts = 1;
   */
  posts: number[] = [];

  /**
   * @generated from field: repeated int32 reposts = 2;
   */
  reposts: number[] = [];

  /**
   * @generated from field: repeated int32 following = 3;
   */
  following: number[] = [];

  /**
   * @generated from field: repeated int32 followers = 4;
   */
  followers: number[] = [];

  /**
   * @generated from field: repeated int32 lists = 5;
   */
  lists: number[] = [];

  /**
   * @generated from field: repeated int32 feeds = 6;
   */
  feeds: number[] = [];

  /**
   * @generated from field: repeated int32 starter_packs = 7;
   */
  starterPacks: number[] = [];

  /**
   * @generated from field: repeated int32 drafts = 8;
   */
  drafts: number[] = [];

  constructor(data?: PartialMessage<GetCountsForUsersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetCountsForUsersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "posts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "reposts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 3, name: "following", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 4, name: "followers", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 5, name: "lists", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 6, name: "feeds", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 7, name: "starter_packs", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 8, name: "drafts", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetCountsForUsersResponse {
    return new GetCountsForUsersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetCountsForUsersResponse {
    return new GetCountsForUsersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetCountsForUsersResponse {
    return new GetCountsForUsersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetCountsForUsersResponse | PlainMessage<GetCountsForUsersResponse> | undefined, b: GetCountsForUsersResponse | PlainMessage<GetCountsForUsersResponse> | undefined): boolean {
    return proto3.util.equals(GetCountsForUsersResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetStarterPackCountsRequest
 */
export class GetStarterPackCountsRequest extends Message<GetStarterPackCountsRequest> {
  /**
   * @generated from field: repeated bsky.RecordRef refs = 1;
   */
  refs: RecordRef[] = [];

  constructor(data?: PartialMessage<GetStarterPackCountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStarterPackCountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refs", kind: "message", T: RecordRef, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStarterPackCountsRequest {
    return new GetStarterPackCountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStarterPackCountsRequest {
    return new GetStarterPackCountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStarterPackCountsRequest {
    return new GetStarterPackCountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStarterPackCountsRequest | PlainMessage<GetStarterPackCountsRequest> | undefined, b: GetStarterPackCountsRequest | PlainMessage<GetStarterPackCountsRequest> | undefined): boolean {
    return proto3.util.equals(GetStarterPackCountsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetStarterPackCountsResponse
 */
export class GetStarterPackCountsResponse extends Message<GetStarterPackCountsResponse> {
  /**
   * @generated from field: repeated int32 joined_week = 1;
   */
  joinedWeek: number[] = [];

  /**
   * @generated from field: repeated int32 joined_all_time = 2;
   */
  joinedAllTime: number[] = [];

  constructor(data?: PartialMessage<GetStarterPackCountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetStarterPackCountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "joined_week", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
    { no: 2, name: "joined_all_time", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStarterPackCountsResponse {
    return new GetStarterPackCountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStarterPackCountsResponse {
    return new GetStarterPackCountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStarterPackCountsResponse {
    return new GetStarterPackCountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStarterPackCountsResponse | PlainMessage<GetStarterPackCountsResponse> | undefined, b: GetStarterPackCountsResponse | PlainMessage<GetStarterPackCountsResponse> | undefined): boolean {
    return proto3.util.equals(GetStarterPackCountsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetListCountsRequest
 */
export class GetListCountsRequest extends Message<GetListCountsRequest> {
  /**
   * @generated from field: repeated bsky.RecordRef refs = 1;
   */
  refs: RecordRef[] = [];

  constructor(data?: PartialMessage<GetListCountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListCountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refs", kind: "message", T: RecordRef, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListCountsRequest {
    return new GetListCountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListCountsRequest {
    return new GetListCountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListCountsRequest {
    return new GetListCountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListCountsRequest | PlainMessage<GetListCountsRequest> | undefined, b: GetListCountsRequest | PlainMessage<GetListCountsRequest> | undefined): boolean {
    return proto3.util.equals(GetListCountsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListCountsResponse
 */
export class GetListCountsResponse extends Message<GetListCountsResponse> {
  /**
   * @generated from field: repeated int32 list_items = 1;
   */
  listItems: number[] = [];

  constructor(data?: PartialMessage<GetListCountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListCountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_items", kind: "scalar", T: 5 /* ScalarType.INT32 */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListCountsResponse {
    return new GetListCountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListCountsResponse {
    return new GetListCountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListCountsResponse {
    return new GetListCountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListCountsResponse | PlainMessage<GetListCountsResponse> | undefined, b: GetListCountsResponse | PlainMessage<GetListCountsResponse> | undefined): boolean {
    return proto3.util.equals(GetListCountsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetNewUserCountForRangeRequest
 */
export class GetNewUserCountForRangeRequest extends Message<GetNewUserCountForRangeRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp start = 1;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 2;
   */
  end?: Timestamp;

  constructor(data?: PartialMessage<GetNewUserCountForRangeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNewUserCountForRangeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start", kind: "message", T: Timestamp },
    { no: 2, name: "end", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNewUserCountForRangeRequest {
    return new GetNewUserCountForRangeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNewUserCountForRangeRequest {
    return new GetNewUserCountForRangeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNewUserCountForRangeRequest {
    return new GetNewUserCountForRangeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNewUserCountForRangeRequest | PlainMessage<GetNewUserCountForRangeRequest> | undefined, b: GetNewUserCountForRangeRequest | PlainMessage<GetNewUserCountForRangeRequest> | undefined): boolean {
    return proto3.util.equals(GetNewUserCountForRangeRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetNewUserCountForRangeResponse
 */
export class GetNewUserCountForRangeResponse extends Message<GetNewUserCountForRangeResponse> {
  /**
   * @generated from field: int32 count = 1;
   */
  count = 0;

  constructor(data?: PartialMessage<GetNewUserCountForRangeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNewUserCountForRangeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNewUserCountForRangeResponse {
    return new GetNewUserCountForRangeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNewUserCountForRangeResponse {
    return new GetNewUserCountForRangeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNewUserCountForRangeResponse {
    return new GetNewUserCountForRangeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNewUserCountForRangeResponse | PlainMessage<GetNewUserCountForRangeResponse> | undefined, b: GetNewUserCountForRangeResponse | PlainMessage<GetNewUserCountForRangeResponse> | undefined): boolean {
    return proto3.util.equals(GetNewUserCountForRangeResponse, a, b);
  }
}

/**
 * - return repost uris where subject uri is subject A
 *     - `getReposts` list for a post
 *
 * @generated from message bsky.GetRepostsBySubjectRequest
 */
export class GetRepostsBySubjectRequest extends Message<GetRepostsBySubjectRequest> {
  /**
   * @generated from field: bsky.RecordRef subject = 1;
   */
  subject?: RecordRef;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetRepostsBySubjectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostsBySubjectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "message", T: RecordRef },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostsBySubjectRequest {
    return new GetRepostsBySubjectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostsBySubjectRequest {
    return new GetRepostsBySubjectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostsBySubjectRequest {
    return new GetRepostsBySubjectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostsBySubjectRequest | PlainMessage<GetRepostsBySubjectRequest> | undefined, b: GetRepostsBySubjectRequest | PlainMessage<GetRepostsBySubjectRequest> | undefined): boolean {
    return proto3.util.equals(GetRepostsBySubjectRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetRepostsBySubjectResponse
 */
export class GetRepostsBySubjectResponse extends Message<GetRepostsBySubjectResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetRepostsBySubjectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostsBySubjectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostsBySubjectResponse {
    return new GetRepostsBySubjectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostsBySubjectResponse {
    return new GetRepostsBySubjectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostsBySubjectResponse {
    return new GetRepostsBySubjectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostsBySubjectResponse | PlainMessage<GetRepostsBySubjectResponse> | undefined, b: GetRepostsBySubjectResponse | PlainMessage<GetRepostsBySubjectResponse> | undefined): boolean {
    return proto3.util.equals(GetRepostsBySubjectResponse, a, b);
  }
}

/**
 * - return repost uris for user A on subject B, C, D...
 *     - viewer state on posts
 *
 * @generated from message bsky.GetRepostsByActorAndSubjectsRequest
 */
export class GetRepostsByActorAndSubjectsRequest extends Message<GetRepostsByActorAndSubjectsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated bsky.RecordRef refs = 2;
   */
  refs: RecordRef[] = [];

  constructor(data?: PartialMessage<GetRepostsByActorAndSubjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostsByActorAndSubjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "refs", kind: "message", T: RecordRef, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostsByActorAndSubjectsRequest {
    return new GetRepostsByActorAndSubjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostsByActorAndSubjectsRequest {
    return new GetRepostsByActorAndSubjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostsByActorAndSubjectsRequest {
    return new GetRepostsByActorAndSubjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostsByActorAndSubjectsRequest | PlainMessage<GetRepostsByActorAndSubjectsRequest> | undefined, b: GetRepostsByActorAndSubjectsRequest | PlainMessage<GetRepostsByActorAndSubjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetRepostsByActorAndSubjectsRequest, a, b);
  }
}

/**
 * @generated from message bsky.RecordRef
 */
export class RecordRef extends Message<RecordRef> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  constructor(data?: PartialMessage<RecordRef>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.RecordRef";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecordRef {
    return new RecordRef().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecordRef {
    return new RecordRef().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecordRef {
    return new RecordRef().fromJsonString(jsonString, options);
  }

  static equals(a: RecordRef | PlainMessage<RecordRef> | undefined, b: RecordRef | PlainMessage<RecordRef> | undefined): boolean {
    return proto3.util.equals(RecordRef, a, b);
  }
}

/**
 * @generated from message bsky.GetRepostsByActorAndSubjectsResponse
 */
export class GetRepostsByActorAndSubjectsResponse extends Message<GetRepostsByActorAndSubjectsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetRepostsByActorAndSubjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRepostsByActorAndSubjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRepostsByActorAndSubjectsResponse {
    return new GetRepostsByActorAndSubjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRepostsByActorAndSubjectsResponse {
    return new GetRepostsByActorAndSubjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRepostsByActorAndSubjectsResponse {
    return new GetRepostsByActorAndSubjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRepostsByActorAndSubjectsResponse | PlainMessage<GetRepostsByActorAndSubjectsResponse> | undefined, b: GetRepostsByActorAndSubjectsResponse | PlainMessage<GetRepostsByActorAndSubjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetRepostsByActorAndSubjectsResponse, a, b);
  }
}

/**
 * - return recent repost uris for user A
 *     - `getActorReposts` list for a user
 *
 * @generated from message bsky.GetActorRepostsRequest
 */
export class GetActorRepostsRequest extends Message<GetActorRepostsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorRepostsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorRepostsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorRepostsRequest {
    return new GetActorRepostsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorRepostsRequest {
    return new GetActorRepostsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorRepostsRequest {
    return new GetActorRepostsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorRepostsRequest | PlainMessage<GetActorRepostsRequest> | undefined, b: GetActorRepostsRequest | PlainMessage<GetActorRepostsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorRepostsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorRepostsResponse
 */
export class GetActorRepostsResponse extends Message<GetActorRepostsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorRepostsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorRepostsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorRepostsResponse {
    return new GetActorRepostsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorRepostsResponse {
    return new GetActorRepostsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorRepostsResponse {
    return new GetActorRepostsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorRepostsResponse | PlainMessage<GetActorRepostsResponse> | undefined, b: GetActorRepostsResponse | PlainMessage<GetActorRepostsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorRepostsResponse, a, b);
  }
}

/**
 * - return actor information for dids A, B, C…
 *     - profile hydration
 *     - should this include handles?  apply repo takedown?
 *
 * @generated from message bsky.GetActorsRequest
 */
export class GetActorsRequest extends Message<GetActorsRequest> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  /**
   * @generated from field: repeated string skip_cache_for_dids = 2;
   */
  skipCacheForDids: string[] = [];

  /**
   * @generated from field: repeated string return_age_assurance_for_dids = 3;
   */
  returnAgeAssuranceForDids: string[] = [];

  constructor(data?: PartialMessage<GetActorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "skip_cache_for_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "return_age_assurance_for_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorsRequest {
    return new GetActorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorsRequest {
    return new GetActorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorsRequest {
    return new GetActorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorsRequest | PlainMessage<GetActorsRequest> | undefined, b: GetActorsRequest | PlainMessage<GetActorsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorsRequest, a, b);
  }
}

/**
 * @generated from message bsky.ActorInfo
 */
export class ActorInfo extends Message<ActorInfo> {
  /**
   * @generated from field: bool exists = 1;
   */
  exists = false;

  /**
   * @generated from field: string handle = 2;
   */
  handle = "";

  /**
   * @generated from field: bsky.Record profile = 3;
   */
  profile?: Record;

  /**
   * @generated from field: bool taken_down = 4;
   */
  takenDown = false;

  /**
   * @generated from field: string takedown_ref = 5;
   */
  takedownRef = "";

  /**
   * @generated from field: google.protobuf.Timestamp tombstoned_at = 6;
   */
  tombstonedAt?: Timestamp;

  /**
   * @generated from field: bool labeler = 7;
   */
  labeler = false;

  /**
   * @generated from field: string allow_incoming_chats_from = 8;
   */
  allowIncomingChatsFrom = "";

  /**
   * @generated from field: string upstream_status = 9;
   */
  upstreamStatus = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: bool priority_notifications = 11;
   */
  priorityNotifications = false;

  /**
   * @generated from field: double pagerank = 12;
   */
  pagerank = 0;

  /**
   * @generated from field: bool trusted_verifier = 13;
   */
  trustedVerifier = false;

  /**
   * @generated from field: map<string, bsky.VerificationMeta> verified_by = 14;
   */
  verifiedBy: { [key: string]: VerificationMeta } = {};

  /**
   * Tags being applied to the account itself
   *
   * @generated from field: repeated string tags = 15;
   */
  tags: string[] = [];

  /**
   * Tags being applied to the profile record
   *
   * @generated from field: repeated string profile_tags = 16;
   */
  profileTags: string[] = [];

  /**
   * @generated from field: bsky.Record status_record = 17;
   */
  statusRecord?: Record;

  /**
   * @generated from field: string allow_activity_subscriptions_from = 18;
   */
  allowActivitySubscriptionsFrom = "";

  /**
   * @generated from field: optional bsky.AgeAssuranceStatus age_assurance_status = 19;
   */
  ageAssuranceStatus?: AgeAssuranceStatus;

  /**
   * @generated from field: bsky.Record germ_record = 21;
   */
  germRecord?: Record;

  /**
   * @generated from field: string allow_group_chat_invites_from = 22;
   */
  allowGroupChatInvitesFrom = "";

  constructor(data?: PartialMessage<ActorInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ActorInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "exists", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "profile", kind: "message", T: Record },
    { no: 4, name: "taken_down", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "takedown_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tombstoned_at", kind: "message", T: Timestamp },
    { no: 7, name: "labeler", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "allow_incoming_chats_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "upstream_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "priority_notifications", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "pagerank", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "trusted_verifier", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "verified_by", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: VerificationMeta} },
    { no: 15, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "profile_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "status_record", kind: "message", T: Record },
    { no: 18, name: "allow_activity_subscriptions_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "age_assurance_status", kind: "message", T: AgeAssuranceStatus, opt: true },
    { no: 21, name: "germ_record", kind: "message", T: Record },
    { no: 22, name: "allow_group_chat_invites_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActorInfo {
    return new ActorInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActorInfo {
    return new ActorInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActorInfo {
    return new ActorInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ActorInfo | PlainMessage<ActorInfo> | undefined, b: ActorInfo | PlainMessage<ActorInfo> | undefined): boolean {
    return proto3.util.equals(ActorInfo, a, b);
  }
}

/**
 * @generated from message bsky.AgeAssuranceStatus
 */
export class AgeAssuranceStatus extends Message<AgeAssuranceStatus> {
  /**
   * @generated from field: string status = 1;
   */
  status = "";

  /**
   * @generated from field: google.protobuf.Timestamp last_initiated_at = 2;
   */
  lastInitiatedAt?: Timestamp;

  /**
   * @generated from field: bool override_applied = 3;
   */
  overrideApplied = false;

  /**
   * @generated from field: string access = 4;
   */
  access = "";

  constructor(data?: PartialMessage<AgeAssuranceStatus>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.AgeAssuranceStatus";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last_initiated_at", kind: "message", T: Timestamp },
    { no: 3, name: "override_applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "access", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgeAssuranceStatus {
    return new AgeAssuranceStatus().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgeAssuranceStatus {
    return new AgeAssuranceStatus().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgeAssuranceStatus {
    return new AgeAssuranceStatus().fromJsonString(jsonString, options);
  }

  static equals(a: AgeAssuranceStatus | PlainMessage<AgeAssuranceStatus> | undefined, b: AgeAssuranceStatus | PlainMessage<AgeAssuranceStatus> | undefined): boolean {
    return proto3.util.equals(AgeAssuranceStatus, a, b);
  }
}

/**
 * @generated from message bsky.GetActorsResponse
 */
export class GetActorsResponse extends Message<GetActorsResponse> {
  /**
   * @generated from field: repeated bsky.ActorInfo actors = 1;
   */
  actors: ActorInfo[] = [];

  constructor(data?: PartialMessage<GetActorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actors", kind: "message", T: ActorInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorsResponse {
    return new GetActorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorsResponse {
    return new GetActorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorsResponse {
    return new GetActorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorsResponse | PlainMessage<GetActorsResponse> | undefined, b: GetActorsResponse | PlainMessage<GetActorsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorsResponse, a, b);
  }
}

/**
 * - return did for handle A
 *     - `resolveHandle`
 *     - answering queries where the query param is a handle
 *
 * @generated from message bsky.GetDidsByHandlesRequest
 */
export class GetDidsByHandlesRequest extends Message<GetDidsByHandlesRequest> {
  /**
   * @generated from field: repeated string handles = 1;
   */
  handles: string[] = [];

  /**
   * @generated from field: bool lookup_unidirectional = 2;
   */
  lookupUnidirectional = false;

  constructor(data?: PartialMessage<GetDidsByHandlesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetDidsByHandlesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "handles", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "lookup_unidirectional", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDidsByHandlesRequest {
    return new GetDidsByHandlesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDidsByHandlesRequest {
    return new GetDidsByHandlesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDidsByHandlesRequest {
    return new GetDidsByHandlesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDidsByHandlesRequest | PlainMessage<GetDidsByHandlesRequest> | undefined, b: GetDidsByHandlesRequest | PlainMessage<GetDidsByHandlesRequest> | undefined): boolean {
    return proto3.util.equals(GetDidsByHandlesRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetDidsByHandlesResponse
 */
export class GetDidsByHandlesResponse extends Message<GetDidsByHandlesResponse> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  constructor(data?: PartialMessage<GetDidsByHandlesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetDidsByHandlesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDidsByHandlesResponse {
    return new GetDidsByHandlesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDidsByHandlesResponse {
    return new GetDidsByHandlesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDidsByHandlesResponse {
    return new GetDidsByHandlesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDidsByHandlesResponse | PlainMessage<GetDidsByHandlesResponse> | undefined, b: GetDidsByHandlesResponse | PlainMessage<GetDidsByHandlesResponse> | undefined): boolean {
    return proto3.util.equals(GetDidsByHandlesResponse, a, b);
  }
}

/**
 * - return relationships between user A and users B, C, D...
 *     - profile hydration
 *     - block application
 *
 * @generated from message bsky.GetRelationshipsRequest
 */
export class GetRelationshipsRequest extends Message<GetRelationshipsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string target_dids = 2;
   */
  targetDids: string[] = [];

  constructor(data?: PartialMessage<GetRelationshipsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRelationshipsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRelationshipsRequest {
    return new GetRelationshipsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRelationshipsRequest {
    return new GetRelationshipsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRelationshipsRequest {
    return new GetRelationshipsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRelationshipsRequest | PlainMessage<GetRelationshipsRequest> | undefined, b: GetRelationshipsRequest | PlainMessage<GetRelationshipsRequest> | undefined): boolean {
    return proto3.util.equals(GetRelationshipsRequest, a, b);
  }
}

/**
 * @generated from message bsky.Relationships
 */
export class Relationships extends Message<Relationships> {
  /**
   * whether a full (unscoped) direct mute exists. Mutually exclusive with
   * the scoped muted_only_* fields: a reposts- or quoteposts-scoped mute reports
   * muted=false.
   *
   * @generated from field: bool muted = 1;
   */
  muted = false;

  /**
   * @generated from field: string muted_by_list = 2;
   */
  mutedByList = "";

  /**
   * @generated from field: string blocked_by = 3;
   */
  blockedBy = "";

  /**
   * @generated from field: string blocking = 4;
   */
  blocking = "";

  /**
   * @generated from field: string blocked_by_list = 5;
   */
  blockedByList = "";

  /**
   * @generated from field: string blocking_by_list = 6;
   */
  blockingByList = "";

  /**
   * @generated from field: string following = 7;
   */
  following = "";

  /**
   * @generated from field: string followed_by = 8;
   */
  followedBy = "";

  /**
   * @generated from field: bool muted_only_reposts = 9;
   */
  mutedOnlyReposts = false;

  /**
   * @generated from field: bool muted_only_quoteposts = 10;
   */
  mutedOnlyQuoteposts = false;

  constructor(data?: PartialMessage<Relationships>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.Relationships";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "muted_by_list", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "blocked_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "blocking", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "blocked_by_list", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "blocking_by_list", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "following", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "followed_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "muted_only_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "muted_only_quoteposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Relationships {
    return new Relationships().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Relationships {
    return new Relationships().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Relationships {
    return new Relationships().fromJsonString(jsonString, options);
  }

  static equals(a: Relationships | PlainMessage<Relationships> | undefined, b: Relationships | PlainMessage<Relationships> | undefined): boolean {
    return proto3.util.equals(Relationships, a, b);
  }
}

/**
 * @generated from message bsky.GetRelationshipsResponse
 */
export class GetRelationshipsResponse extends Message<GetRelationshipsResponse> {
  /**
   * @generated from field: repeated bsky.Relationships relationships = 1;
   */
  relationships: Relationships[] = [];

  constructor(data?: PartialMessage<GetRelationshipsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRelationshipsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "relationships", kind: "message", T: Relationships, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRelationshipsResponse {
    return new GetRelationshipsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRelationshipsResponse {
    return new GetRelationshipsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRelationshipsResponse {
    return new GetRelationshipsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRelationshipsResponse | PlainMessage<GetRelationshipsResponse> | undefined, b: GetRelationshipsResponse | PlainMessage<GetRelationshipsResponse> | undefined): boolean {
    return proto3.util.equals(GetRelationshipsResponse, a, b);
  }
}

/**
 * - return whether a block (bidrectionally and either direct or through a list) exists between two dids
 *     - enforcing 3rd party block violations
 *
 * @generated from message bsky.RelationshipPair
 */
export class RelationshipPair extends Message<RelationshipPair> {
  /**
   * @generated from field: string a = 1;
   */
  a = "";

  /**
   * @generated from field: string b = 2;
   */
  b = "";

  constructor(data?: PartialMessage<RelationshipPair>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.RelationshipPair";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "a", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "b", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RelationshipPair {
    return new RelationshipPair().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RelationshipPair {
    return new RelationshipPair().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RelationshipPair {
    return new RelationshipPair().fromJsonString(jsonString, options);
  }

  static equals(a: RelationshipPair | PlainMessage<RelationshipPair> | undefined, b: RelationshipPair | PlainMessage<RelationshipPair> | undefined): boolean {
    return proto3.util.equals(RelationshipPair, a, b);
  }
}

/**
 * @generated from message bsky.BlockExistence
 */
export class BlockExistence extends Message<BlockExistence> {
  /**
   * @generated from field: string blocked_by = 1;
   */
  blockedBy = "";

  /**
   * @generated from field: string blocking = 2;
   */
  blocking = "";

  /**
   * @generated from field: string blocked_by_list = 3;
   */
  blockedByList = "";

  /**
   * @generated from field: string blocking_by_list = 4;
   */
  blockingByList = "";

  constructor(data?: PartialMessage<BlockExistence>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.BlockExistence";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "blocked_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "blocking", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "blocked_by_list", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "blocking_by_list", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockExistence {
    return new BlockExistence().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockExistence {
    return new BlockExistence().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockExistence {
    return new BlockExistence().fromJsonString(jsonString, options);
  }

  static equals(a: BlockExistence | PlainMessage<BlockExistence> | undefined, b: BlockExistence | PlainMessage<BlockExistence> | undefined): boolean {
    return proto3.util.equals(BlockExistence, a, b);
  }
}

/**
 * @generated from message bsky.GetBlockExistenceRequest
 */
export class GetBlockExistenceRequest extends Message<GetBlockExistenceRequest> {
  /**
   * @generated from field: repeated bsky.RelationshipPair pairs = 1;
   */
  pairs: RelationshipPair[] = [];

  constructor(data?: PartialMessage<GetBlockExistenceRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlockExistenceRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pairs", kind: "message", T: RelationshipPair, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlockExistenceRequest {
    return new GetBlockExistenceRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlockExistenceRequest {
    return new GetBlockExistenceRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlockExistenceRequest {
    return new GetBlockExistenceRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlockExistenceRequest | PlainMessage<GetBlockExistenceRequest> | undefined, b: GetBlockExistenceRequest | PlainMessage<GetBlockExistenceRequest> | undefined): boolean {
    return proto3.util.equals(GetBlockExistenceRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlockExistenceResponse
 */
export class GetBlockExistenceResponse extends Message<GetBlockExistenceResponse> {
  /**
   * @generated from field: repeated bool exists = 1;
   */
  exists: boolean[] = [];

  /**
   * @generated from field: repeated bsky.BlockExistence blocks = 2;
   */
  blocks: BlockExistence[] = [];

  constructor(data?: PartialMessage<GetBlockExistenceResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlockExistenceResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "exists", kind: "scalar", T: 8 /* ScalarType.BOOL */, repeated: true },
    { no: 2, name: "blocks", kind: "message", T: BlockExistence, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlockExistenceResponse {
    return new GetBlockExistenceResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlockExistenceResponse {
    return new GetBlockExistenceResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlockExistenceResponse {
    return new GetBlockExistenceResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlockExistenceResponse | PlainMessage<GetBlockExistenceResponse> | undefined, b: GetBlockExistenceResponse | PlainMessage<GetBlockExistenceResponse> | undefined): boolean {
    return proto3.util.equals(GetBlockExistenceResponse, a, b);
  }
}

/**
 * @generated from message bsky.ListItemInfo
 */
export class ListItemInfo extends Message<ListItemInfo> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string did = 2;
   */
  did = "";

  constructor(data?: PartialMessage<ListItemInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ListItemInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListItemInfo {
    return new ListItemInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListItemInfo {
    return new ListItemInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListItemInfo {
    return new ListItemInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ListItemInfo | PlainMessage<ListItemInfo> | undefined, b: ListItemInfo | PlainMessage<ListItemInfo> | undefined): boolean {
    return proto3.util.equals(ListItemInfo, a, b);
  }
}

/**
 * - Return dids of users in list A
 *     - E.g. to view items in one of your mute lists
 *
 * @generated from message bsky.GetListMembersRequest
 */
export class GetListMembersRequest extends Message<GetListMembersRequest> {
  /**
   * @generated from field: string list_uri = 1;
   */
  listUri = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetListMembersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListMembersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListMembersRequest {
    return new GetListMembersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListMembersRequest {
    return new GetListMembersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListMembersRequest {
    return new GetListMembersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListMembersRequest | PlainMessage<GetListMembersRequest> | undefined, b: GetListMembersRequest | PlainMessage<GetListMembersRequest> | undefined): boolean {
    return proto3.util.equals(GetListMembersRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListMembersResponse
 */
export class GetListMembersResponse extends Message<GetListMembersResponse> {
  /**
   * @generated from field: repeated bsky.ListItemInfo listitems = 1;
   */
  listitems: ListItemInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetListMembersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListMembersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "listitems", kind: "message", T: ListItemInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListMembersResponse {
    return new GetListMembersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListMembersResponse {
    return new GetListMembersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListMembersResponse {
    return new GetListMembersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListMembersResponse | PlainMessage<GetListMembersResponse> | undefined, b: GetListMembersResponse | PlainMessage<GetListMembersResponse> | undefined): boolean {
    return proto3.util.equals(GetListMembersResponse, a, b);
  }
}

/**
 * - Return list uris where user A in list B, C, D…
 *     - Used in thread reply gates
 *
 * @generated from message bsky.GetListMembershipRequest
 */
export class GetListMembershipRequest extends Message<GetListMembershipRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string list_uris = 2;
   */
  listUris: string[] = [];

  constructor(data?: PartialMessage<GetListMembershipRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListMembershipRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "list_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListMembershipRequest {
    return new GetListMembershipRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListMembershipRequest {
    return new GetListMembershipRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListMembershipRequest {
    return new GetListMembershipRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListMembershipRequest | PlainMessage<GetListMembershipRequest> | undefined, b: GetListMembershipRequest | PlainMessage<GetListMembershipRequest> | undefined): boolean {
    return proto3.util.equals(GetListMembershipRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListMembershipResponse
 */
export class GetListMembershipResponse extends Message<GetListMembershipResponse> {
  /**
   * @generated from field: repeated string listitem_uris = 1;
   */
  listitemUris: string[] = [];

  constructor(data?: PartialMessage<GetListMembershipResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListMembershipResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "listitem_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListMembershipResponse {
    return new GetListMembershipResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListMembershipResponse {
    return new GetListMembershipResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListMembershipResponse {
    return new GetListMembershipResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListMembershipResponse | PlainMessage<GetListMembershipResponse> | undefined, b: GetListMembershipResponse | PlainMessage<GetListMembershipResponse> | undefined): boolean {
    return proto3.util.equals(GetListMembershipResponse, a, b);
  }
}

/**
 * - Return number of items in list A
 *     - For aggregate
 *
 * @generated from message bsky.GetListCountRequest
 */
export class GetListCountRequest extends Message<GetListCountRequest> {
  /**
   * @generated from field: string list_uri = 1;
   */
  listUri = "";

  constructor(data?: PartialMessage<GetListCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListCountRequest {
    return new GetListCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListCountRequest {
    return new GetListCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListCountRequest {
    return new GetListCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListCountRequest | PlainMessage<GetListCountRequest> | undefined, b: GetListCountRequest | PlainMessage<GetListCountRequest> | undefined): boolean {
    return proto3.util.equals(GetListCountRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListCountResponse
 */
export class GetListCountResponse extends Message<GetListCountResponse> {
  /**
   * @generated from field: int32 count = 1;
   */
  count = 0;

  constructor(data?: PartialMessage<GetListCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListCountResponse {
    return new GetListCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListCountResponse {
    return new GetListCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListCountResponse {
    return new GetListCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListCountResponse | PlainMessage<GetListCountResponse> | undefined, b: GetListCountResponse | PlainMessage<GetListCountResponse> | undefined): boolean {
    return proto3.util.equals(GetListCountResponse, a, b);
  }
}

/**
 * - return list of uris of lists created by A
 *     - `getLists`
 *
 * @generated from message bsky.GetActorListsRequest
 */
export class GetActorListsRequest extends Message<GetActorListsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorListsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorListsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorListsRequest {
    return new GetActorListsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorListsRequest {
    return new GetActorListsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorListsRequest {
    return new GetActorListsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorListsRequest | PlainMessage<GetActorListsRequest> | undefined, b: GetActorListsRequest | PlainMessage<GetActorListsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorListsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorListsResponse
 */
export class GetActorListsResponse extends Message<GetActorListsResponse> {
  /**
   * @generated from field: repeated string list_uris = 1;
   */
  listUris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorListsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorListsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorListsResponse {
    return new GetActorListsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorListsResponse {
    return new GetActorListsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorListsResponse {
    return new GetActorListsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorListsResponse | PlainMessage<GetActorListsResponse> | undefined, b: GetActorListsResponse | PlainMessage<GetActorListsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorListsResponse, a, b);
  }
}

/**
 * - return boolean if user A has muted user B
 *     - hydrating mute state onto profiles
 *
 * @generated from message bsky.GetActorMutesActorRequest
 */
export class GetActorMutesActorRequest extends Message<GetActorMutesActorRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string target_did = 2;
   */
  targetDid = "";

  constructor(data?: PartialMessage<GetActorMutesActorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorMutesActorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorMutesActorRequest {
    return new GetActorMutesActorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorMutesActorRequest {
    return new GetActorMutesActorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorMutesActorRequest {
    return new GetActorMutesActorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorMutesActorRequest | PlainMessage<GetActorMutesActorRequest> | undefined, b: GetActorMutesActorRequest | PlainMessage<GetActorMutesActorRequest> | undefined): boolean {
    return proto3.util.equals(GetActorMutesActorRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorMutesActorResponse
 */
export class GetActorMutesActorResponse extends Message<GetActorMutesActorResponse> {
  /**
   * whether a full (unscoped) mute exists. Mutually exclusive with the
   * scoped muted_only_* fields.
   *
   * @generated from field: bool muted = 1;
   */
  muted = false;

  /**
   * @generated from field: bool muted_only_reposts = 2;
   */
  mutedOnlyReposts = false;

  /**
   * @generated from field: bool muted_only_quoteposts = 3;
   */
  mutedOnlyQuoteposts = false;

  constructor(data?: PartialMessage<GetActorMutesActorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorMutesActorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "muted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "muted_only_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "muted_only_quoteposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorMutesActorResponse {
    return new GetActorMutesActorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorMutesActorResponse {
    return new GetActorMutesActorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorMutesActorResponse {
    return new GetActorMutesActorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorMutesActorResponse | PlainMessage<GetActorMutesActorResponse> | undefined, b: GetActorMutesActorResponse | PlainMessage<GetActorMutesActorResponse> | undefined): boolean {
    return proto3.util.equals(GetActorMutesActorResponse, a, b);
  }
}

/**
 * @generated from message bsky.MuteInfo
 */
export class MuteInfo extends Message<MuteInfo> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * scope restrictions: when any is set, just the scoped content is muted;
   * when none are set, the subject is fully muted.
   *
   * @generated from field: bool only_reposts = 2;
   */
  onlyReposts = false;

  /**
   * @generated from field: bool only_quoteposts = 3;
   */
  onlyQuoteposts = false;

  constructor(data?: PartialMessage<MuteInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.MuteInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "only_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "only_quoteposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MuteInfo {
    return new MuteInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MuteInfo {
    return new MuteInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MuteInfo {
    return new MuteInfo().fromJsonString(jsonString, options);
  }

  static equals(a: MuteInfo | PlainMessage<MuteInfo> | undefined, b: MuteInfo | PlainMessage<MuteInfo> | undefined): boolean {
    return proto3.util.equals(MuteInfo, a, b);
  }
}

/**
 * - return list of user dids of users who A mutes
 *     - `getMutes`
 *
 * @generated from message bsky.GetMutesRequest
 */
export class GetMutesRequest extends Message<GetMutesRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetMutesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutesRequest {
    return new GetMutesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutesRequest {
    return new GetMutesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutesRequest {
    return new GetMutesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutesRequest | PlainMessage<GetMutesRequest> | undefined, b: GetMutesRequest | PlainMessage<GetMutesRequest> | undefined): boolean {
    return proto3.util.equals(GetMutesRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetMutesResponse
 */
export class GetMutesResponse extends Message<GetMutesResponse> {
  /**
   * Deprecated: use mutes, which carries the scope of each mute.
   *
   * @generated from field: repeated string dids = 1 [deprecated = true];
   * @deprecated
   */
  dids: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  /**
   * @generated from field: repeated bsky.MuteInfo mutes = 3;
   */
  mutes: MuteInfo[] = [];

  constructor(data?: PartialMessage<GetMutesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "mutes", kind: "message", T: MuteInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutesResponse {
    return new GetMutesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutesResponse {
    return new GetMutesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutesResponse {
    return new GetMutesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutesResponse | PlainMessage<GetMutesResponse> | undefined, b: GetMutesResponse | PlainMessage<GetMutesResponse> | undefined): boolean {
    return proto3.util.equals(GetMutesResponse, a, b);
  }
}

/**
 * - return list uri of *any* list through which user A has muted user B
 *     - hydrating mute state onto profiles
 *     - note: we only need *one* uri even if a user is muted by multiple lists
 *
 * @generated from message bsky.GetActorMutesActorViaListRequest
 */
export class GetActorMutesActorViaListRequest extends Message<GetActorMutesActorViaListRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string target_did = 2;
   */
  targetDid = "";

  constructor(data?: PartialMessage<GetActorMutesActorViaListRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorMutesActorViaListRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorMutesActorViaListRequest {
    return new GetActorMutesActorViaListRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorMutesActorViaListRequest {
    return new GetActorMutesActorViaListRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorMutesActorViaListRequest {
    return new GetActorMutesActorViaListRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorMutesActorViaListRequest | PlainMessage<GetActorMutesActorViaListRequest> | undefined, b: GetActorMutesActorViaListRequest | PlainMessage<GetActorMutesActorViaListRequest> | undefined): boolean {
    return proto3.util.equals(GetActorMutesActorViaListRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorMutesActorViaListResponse
 */
export class GetActorMutesActorViaListResponse extends Message<GetActorMutesActorViaListResponse> {
  /**
   * @generated from field: string list_uri = 1;
   */
  listUri = "";

  constructor(data?: PartialMessage<GetActorMutesActorViaListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorMutesActorViaListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorMutesActorViaListResponse {
    return new GetActorMutesActorViaListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorMutesActorViaListResponse {
    return new GetActorMutesActorViaListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorMutesActorViaListResponse {
    return new GetActorMutesActorViaListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorMutesActorViaListResponse | PlainMessage<GetActorMutesActorViaListResponse> | undefined, b: GetActorMutesActorViaListResponse | PlainMessage<GetActorMutesActorViaListResponse> | undefined): boolean {
    return proto3.util.equals(GetActorMutesActorViaListResponse, a, b);
  }
}

/**
 * - return boolean if actor A has subscribed to mutelist B
 *     - list view hydration
 *
 * @generated from message bsky.GetMutelistSubscriptionRequest
 */
export class GetMutelistSubscriptionRequest extends Message<GetMutelistSubscriptionRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string list_uri = 2;
   */
  listUri = "";

  constructor(data?: PartialMessage<GetMutelistSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutelistSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutelistSubscriptionRequest {
    return new GetMutelistSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionRequest {
    return new GetMutelistSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionRequest {
    return new GetMutelistSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutelistSubscriptionRequest | PlainMessage<GetMutelistSubscriptionRequest> | undefined, b: GetMutelistSubscriptionRequest | PlainMessage<GetMutelistSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(GetMutelistSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetMutelistSubscriptionResponse
 */
export class GetMutelistSubscriptionResponse extends Message<GetMutelistSubscriptionResponse> {
  /**
   * @generated from field: bool subscribed = 1;
   */
  subscribed = false;

  constructor(data?: PartialMessage<GetMutelistSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutelistSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutelistSubscriptionResponse {
    return new GetMutelistSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionResponse {
    return new GetMutelistSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionResponse {
    return new GetMutelistSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutelistSubscriptionResponse | PlainMessage<GetMutelistSubscriptionResponse> | undefined, b: GetMutelistSubscriptionResponse | PlainMessage<GetMutelistSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(GetMutelistSubscriptionResponse, a, b);
  }
}

/**
 * - return list of list uris of mutelists that A subscribes to
 *     - `getListMutes`
 *
 * @generated from message bsky.GetMutelistSubscriptionsRequest
 */
export class GetMutelistSubscriptionsRequest extends Message<GetMutelistSubscriptionsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetMutelistSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutelistSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutelistSubscriptionsRequest {
    return new GetMutelistSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionsRequest {
    return new GetMutelistSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionsRequest {
    return new GetMutelistSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutelistSubscriptionsRequest | PlainMessage<GetMutelistSubscriptionsRequest> | undefined, b: GetMutelistSubscriptionsRequest | PlainMessage<GetMutelistSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(GetMutelistSubscriptionsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetMutelistSubscriptionsResponse
 */
export class GetMutelistSubscriptionsResponse extends Message<GetMutelistSubscriptionsResponse> {
  /**
   * @generated from field: repeated string list_uris = 1;
   */
  listUris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetMutelistSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetMutelistSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMutelistSubscriptionsResponse {
    return new GetMutelistSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionsResponse {
    return new GetMutelistSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMutelistSubscriptionsResponse {
    return new GetMutelistSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMutelistSubscriptionsResponse | PlainMessage<GetMutelistSubscriptionsResponse> | undefined, b: GetMutelistSubscriptionsResponse | PlainMessage<GetMutelistSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(GetMutelistSubscriptionsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetThreadMutesOnSubjectsRequest
 */
export class GetThreadMutesOnSubjectsRequest extends Message<GetThreadMutesOnSubjectsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string thread_roots = 2;
   */
  threadRoots: string[] = [];

  constructor(data?: PartialMessage<GetThreadMutesOnSubjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadMutesOnSubjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "thread_roots", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadMutesOnSubjectsRequest {
    return new GetThreadMutesOnSubjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadMutesOnSubjectsRequest {
    return new GetThreadMutesOnSubjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadMutesOnSubjectsRequest {
    return new GetThreadMutesOnSubjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadMutesOnSubjectsRequest | PlainMessage<GetThreadMutesOnSubjectsRequest> | undefined, b: GetThreadMutesOnSubjectsRequest | PlainMessage<GetThreadMutesOnSubjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetThreadMutesOnSubjectsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetThreadMutesOnSubjectsResponse
 */
export class GetThreadMutesOnSubjectsResponse extends Message<GetThreadMutesOnSubjectsResponse> {
  /**
   * @generated from field: repeated bool muted = 1;
   */
  muted: boolean[] = [];

  constructor(data?: PartialMessage<GetThreadMutesOnSubjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadMutesOnSubjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "muted", kind: "scalar", T: 8 /* ScalarType.BOOL */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadMutesOnSubjectsResponse {
    return new GetThreadMutesOnSubjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadMutesOnSubjectsResponse {
    return new GetThreadMutesOnSubjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadMutesOnSubjectsResponse {
    return new GetThreadMutesOnSubjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadMutesOnSubjectsResponse | PlainMessage<GetThreadMutesOnSubjectsResponse> | undefined, b: GetThreadMutesOnSubjectsResponse | PlainMessage<GetThreadMutesOnSubjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetThreadMutesOnSubjectsResponse, a, b);
  }
}

/**
 * - Return block uri if there is a block between users A & B (bidirectional)
 *     - hydrating (& actioning) block state on profiles
 *     - handling 3rd party blocks
 *
 * @generated from message bsky.GetBidirectionalBlockRequest
 */
export class GetBidirectionalBlockRequest extends Message<GetBidirectionalBlockRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string target_did = 2;
   */
  targetDid = "";

  constructor(data?: PartialMessage<GetBidirectionalBlockRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBidirectionalBlockRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBidirectionalBlockRequest {
    return new GetBidirectionalBlockRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBidirectionalBlockRequest {
    return new GetBidirectionalBlockRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBidirectionalBlockRequest {
    return new GetBidirectionalBlockRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBidirectionalBlockRequest | PlainMessage<GetBidirectionalBlockRequest> | undefined, b: GetBidirectionalBlockRequest | PlainMessage<GetBidirectionalBlockRequest> | undefined): boolean {
    return proto3.util.equals(GetBidirectionalBlockRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBidirectionalBlockResponse
 */
export class GetBidirectionalBlockResponse extends Message<GetBidirectionalBlockResponse> {
  /**
   * @generated from field: string block_uri = 1;
   */
  blockUri = "";

  constructor(data?: PartialMessage<GetBidirectionalBlockResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBidirectionalBlockResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBidirectionalBlockResponse {
    return new GetBidirectionalBlockResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBidirectionalBlockResponse {
    return new GetBidirectionalBlockResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBidirectionalBlockResponse {
    return new GetBidirectionalBlockResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBidirectionalBlockResponse | PlainMessage<GetBidirectionalBlockResponse> | undefined, b: GetBidirectionalBlockResponse | PlainMessage<GetBidirectionalBlockResponse> | undefined): boolean {
    return proto3.util.equals(GetBidirectionalBlockResponse, a, b);
  }
}

/**
 * - Return list of block uris and user dids of users who A blocks
 *     - `getBlocks`
 *
 * @generated from message bsky.GetBlocksRequest
 */
export class GetBlocksRequest extends Message<GetBlocksRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetBlocksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocksRequest {
    return new GetBlocksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocksRequest {
    return new GetBlocksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocksRequest {
    return new GetBlocksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocksRequest | PlainMessage<GetBlocksRequest> | undefined, b: GetBlocksRequest | PlainMessage<GetBlocksRequest> | undefined): boolean {
    return proto3.util.equals(GetBlocksRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlocksResponse
 */
export class GetBlocksResponse extends Message<GetBlocksResponse> {
  /**
   * @generated from field: repeated string block_uris = 1;
   */
  blockUris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetBlocksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocksResponse {
    return new GetBlocksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocksResponse {
    return new GetBlocksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocksResponse {
    return new GetBlocksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocksResponse | PlainMessage<GetBlocksResponse> | undefined, b: GetBlocksResponse | PlainMessage<GetBlocksResponse> | undefined): boolean {
    return proto3.util.equals(GetBlocksResponse, a, b);
  }
}

/**
 * - Return list uri of ***any*** list through which users A & B have a block (bidirectional)
 *     - hydrating (& actioning) block state on profiles
 *     - handling 3rd party blocks
 *
 * @generated from message bsky.GetBidirectionalBlockViaListRequest
 */
export class GetBidirectionalBlockViaListRequest extends Message<GetBidirectionalBlockViaListRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string target_did = 2;
   */
  targetDid = "";

  constructor(data?: PartialMessage<GetBidirectionalBlockViaListRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBidirectionalBlockViaListRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBidirectionalBlockViaListRequest {
    return new GetBidirectionalBlockViaListRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBidirectionalBlockViaListRequest {
    return new GetBidirectionalBlockViaListRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBidirectionalBlockViaListRequest {
    return new GetBidirectionalBlockViaListRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBidirectionalBlockViaListRequest | PlainMessage<GetBidirectionalBlockViaListRequest> | undefined, b: GetBidirectionalBlockViaListRequest | PlainMessage<GetBidirectionalBlockViaListRequest> | undefined): boolean {
    return proto3.util.equals(GetBidirectionalBlockViaListRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBidirectionalBlockViaListResponse
 */
export class GetBidirectionalBlockViaListResponse extends Message<GetBidirectionalBlockViaListResponse> {
  /**
   * @generated from field: string list_uri = 1;
   */
  listUri = "";

  constructor(data?: PartialMessage<GetBidirectionalBlockViaListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBidirectionalBlockViaListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBidirectionalBlockViaListResponse {
    return new GetBidirectionalBlockViaListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBidirectionalBlockViaListResponse {
    return new GetBidirectionalBlockViaListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBidirectionalBlockViaListResponse {
    return new GetBidirectionalBlockViaListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBidirectionalBlockViaListResponse | PlainMessage<GetBidirectionalBlockViaListResponse> | undefined, b: GetBidirectionalBlockViaListResponse | PlainMessage<GetBidirectionalBlockViaListResponse> | undefined): boolean {
    return proto3.util.equals(GetBidirectionalBlockViaListResponse, a, b);
  }
}

/**
 * - return boolean if user A has subscribed to blocklist B
 *     - list view hydration
 *
 * @generated from message bsky.GetBlocklistSubscriptionRequest
 */
export class GetBlocklistSubscriptionRequest extends Message<GetBlocklistSubscriptionRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string list_uri = 2;
   */
  listUri = "";

  constructor(data?: PartialMessage<GetBlocklistSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocklistSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocklistSubscriptionRequest {
    return new GetBlocklistSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionRequest {
    return new GetBlocklistSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionRequest {
    return new GetBlocklistSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocklistSubscriptionRequest | PlainMessage<GetBlocklistSubscriptionRequest> | undefined, b: GetBlocklistSubscriptionRequest | PlainMessage<GetBlocklistSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(GetBlocklistSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlocklistSubscriptionResponse
 */
export class GetBlocklistSubscriptionResponse extends Message<GetBlocklistSubscriptionResponse> {
  /**
   * @generated from field: string listblock_uri = 1;
   */
  listblockUri = "";

  constructor(data?: PartialMessage<GetBlocklistSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocklistSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "listblock_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocklistSubscriptionResponse {
    return new GetBlocklistSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionResponse {
    return new GetBlocklistSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionResponse {
    return new GetBlocklistSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocklistSubscriptionResponse | PlainMessage<GetBlocklistSubscriptionResponse> | undefined, b: GetBlocklistSubscriptionResponse | PlainMessage<GetBlocklistSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(GetBlocklistSubscriptionResponse, a, b);
  }
}

/**
 * - return list of list uris of Blockslists that A subscribes to
 *     - `getListBlocks`
 *
 * @generated from message bsky.GetBlocklistSubscriptionsRequest
 */
export class GetBlocklistSubscriptionsRequest extends Message<GetBlocklistSubscriptionsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetBlocklistSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocklistSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocklistSubscriptionsRequest {
    return new GetBlocklistSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionsRequest {
    return new GetBlocklistSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionsRequest {
    return new GetBlocklistSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocklistSubscriptionsRequest | PlainMessage<GetBlocklistSubscriptionsRequest> | undefined, b: GetBlocklistSubscriptionsRequest | PlainMessage<GetBlocklistSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(GetBlocklistSubscriptionsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlocklistSubscriptionsResponse
 */
export class GetBlocklistSubscriptionsResponse extends Message<GetBlocklistSubscriptionsResponse> {
  /**
   * @generated from field: repeated string list_uris = 1;
   */
  listUris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetBlocklistSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlocklistSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlocklistSubscriptionsResponse {
    return new GetBlocklistSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionsResponse {
    return new GetBlocklistSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlocklistSubscriptionsResponse {
    return new GetBlocklistSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlocklistSubscriptionsResponse | PlainMessage<GetBlocklistSubscriptionsResponse> | undefined, b: GetBlocklistSubscriptionsResponse | PlainMessage<GetBlocklistSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(GetBlocklistSubscriptionsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationPreferencesRequest
 */
export class GetNotificationPreferencesRequest extends Message<GetNotificationPreferencesRequest> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  constructor(data?: PartialMessage<GetNotificationPreferencesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationPreferencesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationPreferencesRequest {
    return new GetNotificationPreferencesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationPreferencesRequest {
    return new GetNotificationPreferencesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationPreferencesRequest {
    return new GetNotificationPreferencesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationPreferencesRequest | PlainMessage<GetNotificationPreferencesRequest> | undefined, b: GetNotificationPreferencesRequest | PlainMessage<GetNotificationPreferencesRequest> | undefined): boolean {
    return proto3.util.equals(GetNotificationPreferencesRequest, a, b);
  }
}

/**
 * @generated from message bsky.NotificationChannelList
 */
export class NotificationChannelList extends Message<NotificationChannelList> {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  constructor(data?: PartialMessage<NotificationChannelList>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.NotificationChannelList";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationChannelList {
    return new NotificationChannelList().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationChannelList {
    return new NotificationChannelList().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationChannelList {
    return new NotificationChannelList().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationChannelList | PlainMessage<NotificationChannelList> | undefined, b: NotificationChannelList | PlainMessage<NotificationChannelList> | undefined): boolean {
    return proto3.util.equals(NotificationChannelList, a, b);
  }
}

/**
 * @generated from message bsky.NotificationChannelPush
 */
export class NotificationChannelPush extends Message<NotificationChannelPush> {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled = false;

  constructor(data?: PartialMessage<NotificationChannelPush>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.NotificationChannelPush";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationChannelPush {
    return new NotificationChannelPush().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationChannelPush {
    return new NotificationChannelPush().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationChannelPush {
    return new NotificationChannelPush().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationChannelPush | PlainMessage<NotificationChannelPush> | undefined, b: NotificationChannelPush | PlainMessage<NotificationChannelPush> | undefined): boolean {
    return proto3.util.equals(NotificationChannelPush, a, b);
  }
}

/**
 * @generated from message bsky.FilterableNotificationPreference
 */
export class FilterableNotificationPreference extends Message<FilterableNotificationPreference> {
  /**
   * @generated from field: bsky.NotificationInclude include = 1;
   */
  include = NotificationInclude.UNSPECIFIED;

  /**
   * @generated from field: bsky.NotificationChannelList list = 2;
   */
  list?: NotificationChannelList;

  /**
   * @generated from field: bsky.NotificationChannelPush push = 3;
   */
  push?: NotificationChannelPush;

  constructor(data?: PartialMessage<FilterableNotificationPreference>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.FilterableNotificationPreference";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "include", kind: "enum", T: proto3.getEnumType(NotificationInclude) },
    { no: 2, name: "list", kind: "message", T: NotificationChannelList },
    { no: 3, name: "push", kind: "message", T: NotificationChannelPush },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FilterableNotificationPreference {
    return new FilterableNotificationPreference().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FilterableNotificationPreference {
    return new FilterableNotificationPreference().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FilterableNotificationPreference {
    return new FilterableNotificationPreference().fromJsonString(jsonString, options);
  }

  static equals(a: FilterableNotificationPreference | PlainMessage<FilterableNotificationPreference> | undefined, b: FilterableNotificationPreference | PlainMessage<FilterableNotificationPreference> | undefined): boolean {
    return proto3.util.equals(FilterableNotificationPreference, a, b);
  }
}

/**
 * @generated from message bsky.NotificationPreference
 */
export class NotificationPreference extends Message<NotificationPreference> {
  /**
   * @generated from field: bsky.NotificationChannelList list = 1;
   */
  list?: NotificationChannelList;

  /**
   * @generated from field: bsky.NotificationChannelPush push = 2;
   */
  push?: NotificationChannelPush;

  constructor(data?: PartialMessage<NotificationPreference>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.NotificationPreference";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list", kind: "message", T: NotificationChannelList },
    { no: 2, name: "push", kind: "message", T: NotificationChannelPush },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPreference {
    return new NotificationPreference().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPreference {
    return new NotificationPreference().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPreference {
    return new NotificationPreference().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPreference | PlainMessage<NotificationPreference> | undefined, b: NotificationPreference | PlainMessage<NotificationPreference> | undefined): boolean {
    return proto3.util.equals(NotificationPreference, a, b);
  }
}

/**
 * @generated from message bsky.NotificationPreferences
 */
export class NotificationPreferences extends Message<NotificationPreferences> {
  /**
   * @generated from field: bytes entry = 1;
   */
  entry = new Uint8Array(0);

  /**
   * @generated from field: bsky.FilterableNotificationPreference follow = 3;
   */
  follow?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference like = 4;
   */
  like?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference like_via_repost = 5;
   */
  likeViaRepost?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference mention = 6;
   */
  mention?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference quote = 7;
   */
  quote?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference reply = 8;
   */
  reply?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference repost = 9;
   */
  repost?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.FilterableNotificationPreference repost_via_repost = 10;
   */
  repostViaRepost?: FilterableNotificationPreference;

  /**
   * @generated from field: bsky.NotificationPreference starterpack_joined = 11;
   */
  starterpackJoined?: NotificationPreference;

  /**
   * @generated from field: bsky.NotificationPreference subscribed_post = 12;
   */
  subscribedPost?: NotificationPreference;

  /**
   * @generated from field: bsky.NotificationPreference unverified = 13;
   */
  unverified?: NotificationPreference;

  /**
   * @generated from field: bsky.NotificationPreference verified = 14;
   */
  verified?: NotificationPreference;

  constructor(data?: PartialMessage<NotificationPreferences>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.NotificationPreferences";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entry", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "follow", kind: "message", T: FilterableNotificationPreference },
    { no: 4, name: "like", kind: "message", T: FilterableNotificationPreference },
    { no: 5, name: "like_via_repost", kind: "message", T: FilterableNotificationPreference },
    { no: 6, name: "mention", kind: "message", T: FilterableNotificationPreference },
    { no: 7, name: "quote", kind: "message", T: FilterableNotificationPreference },
    { no: 8, name: "reply", kind: "message", T: FilterableNotificationPreference },
    { no: 9, name: "repost", kind: "message", T: FilterableNotificationPreference },
    { no: 10, name: "repost_via_repost", kind: "message", T: FilterableNotificationPreference },
    { no: 11, name: "starterpack_joined", kind: "message", T: NotificationPreference },
    { no: 12, name: "subscribed_post", kind: "message", T: NotificationPreference },
    { no: 13, name: "unverified", kind: "message", T: NotificationPreference },
    { no: 14, name: "verified", kind: "message", T: NotificationPreference },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): NotificationPreferences {
    return new NotificationPreferences().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): NotificationPreferences {
    return new NotificationPreferences().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): NotificationPreferences {
    return new NotificationPreferences().fromJsonString(jsonString, options);
  }

  static equals(a: NotificationPreferences | PlainMessage<NotificationPreferences> | undefined, b: NotificationPreferences | PlainMessage<NotificationPreferences> | undefined): boolean {
    return proto3.util.equals(NotificationPreferences, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationPreferencesResponse
 */
export class GetNotificationPreferencesResponse extends Message<GetNotificationPreferencesResponse> {
  /**
   * @generated from field: repeated bsky.NotificationPreferences preferences = 1;
   */
  preferences: NotificationPreferences[] = [];

  constructor(data?: PartialMessage<GetNotificationPreferencesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationPreferencesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "preferences", kind: "message", T: NotificationPreferences, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationPreferencesResponse {
    return new GetNotificationPreferencesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationPreferencesResponse {
    return new GetNotificationPreferencesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationPreferencesResponse {
    return new GetNotificationPreferencesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationPreferencesResponse | PlainMessage<GetNotificationPreferencesResponse> | undefined, b: GetNotificationPreferencesResponse | PlainMessage<GetNotificationPreferencesResponse> | undefined): boolean {
    return proto3.util.equals(GetNotificationPreferencesResponse, a, b);
  }
}

/**
 * - list recent notifications for a user
 *     - notifications should include a uri for the record that caused the notif & a “reason” for the notification (reply, like, quotepost, etc)
 *     - this should include both read & unread notifs
 *
 * @generated from message bsky.GetNotificationsRequest
 */
export class GetNotificationsRequest extends Message<GetNotificationsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: bool priority = 4;
   */
  priority = false;

  constructor(data?: PartialMessage<GetNotificationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "priority", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationsRequest {
    return new GetNotificationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationsRequest {
    return new GetNotificationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationsRequest {
    return new GetNotificationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationsRequest | PlainMessage<GetNotificationsRequest> | undefined, b: GetNotificationsRequest | PlainMessage<GetNotificationsRequest> | undefined): boolean {
    return proto3.util.equals(GetNotificationsRequest, a, b);
  }
}

/**
 * @generated from message bsky.Notification
 */
export class Notification extends Message<Notification> {
  /**
   * @generated from field: string recipient_did = 1;
   */
  recipientDid = "";

  /**
   * @generated from field: string uri = 2;
   */
  uri = "";

  /**
   * @generated from field: string reason = 3;
   */
  reason = "";

  /**
   * @generated from field: string reason_subject = 4;
   */
  reasonSubject = "";

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: bool priority = 6;
   */
  priority = false;

  constructor(data?: PartialMessage<Notification>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.Notification";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "recipient_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reason_subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "priority", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Notification {
    return new Notification().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Notification {
    return new Notification().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Notification {
    return new Notification().fromJsonString(jsonString, options);
  }

  static equals(a: Notification | PlainMessage<Notification> | undefined, b: Notification | PlainMessage<Notification> | undefined): boolean {
    return proto3.util.equals(Notification, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationsResponse
 */
export class GetNotificationsResponse extends Message<GetNotificationsResponse> {
  /**
   * @generated from field: repeated bsky.Notification notifications = 1;
   */
  notifications: Notification[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetNotificationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "notifications", kind: "message", T: Notification, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationsResponse {
    return new GetNotificationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationsResponse {
    return new GetNotificationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationsResponse {
    return new GetNotificationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationsResponse | PlainMessage<GetNotificationsResponse> | undefined, b: GetNotificationsResponse | PlainMessage<GetNotificationsResponse> | undefined): boolean {
    return proto3.util.equals(GetNotificationsResponse, a, b);
  }
}

/**
 * - update a user’s “last seen time”
 *     - `updateSeen`
 *
 * @generated from message bsky.UpdateNotificationSeenRequest
 */
export class UpdateNotificationSeenRequest extends Message<UpdateNotificationSeenRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: bool priority = 3;
   */
  priority = false;

  constructor(data?: PartialMessage<UpdateNotificationSeenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UpdateNotificationSeenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "priority", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateNotificationSeenRequest {
    return new UpdateNotificationSeenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateNotificationSeenRequest {
    return new UpdateNotificationSeenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateNotificationSeenRequest {
    return new UpdateNotificationSeenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateNotificationSeenRequest | PlainMessage<UpdateNotificationSeenRequest> | undefined, b: UpdateNotificationSeenRequest | PlainMessage<UpdateNotificationSeenRequest> | undefined): boolean {
    return proto3.util.equals(UpdateNotificationSeenRequest, a, b);
  }
}

/**
 * @generated from message bsky.UpdateNotificationSeenResponse
 */
export class UpdateNotificationSeenResponse extends Message<UpdateNotificationSeenResponse> {
  constructor(data?: PartialMessage<UpdateNotificationSeenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UpdateNotificationSeenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateNotificationSeenResponse {
    return new UpdateNotificationSeenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateNotificationSeenResponse {
    return new UpdateNotificationSeenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateNotificationSeenResponse {
    return new UpdateNotificationSeenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateNotificationSeenResponse | PlainMessage<UpdateNotificationSeenResponse> | undefined, b: UpdateNotificationSeenResponse | PlainMessage<UpdateNotificationSeenResponse> | undefined): boolean {
    return proto3.util.equals(UpdateNotificationSeenResponse, a, b);
  }
}

/**
 * - get a user’s “last seen time”
 *     - hydrating read state onto notifications
 *
 * @generated from message bsky.GetNotificationSeenRequest
 */
export class GetNotificationSeenRequest extends Message<GetNotificationSeenRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: bool priority = 2;
   */
  priority = false;

  constructor(data?: PartialMessage<GetNotificationSeenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationSeenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "priority", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationSeenRequest {
    return new GetNotificationSeenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationSeenRequest {
    return new GetNotificationSeenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationSeenRequest {
    return new GetNotificationSeenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationSeenRequest | PlainMessage<GetNotificationSeenRequest> | undefined, b: GetNotificationSeenRequest | PlainMessage<GetNotificationSeenRequest> | undefined): boolean {
    return proto3.util.equals(GetNotificationSeenRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetNotificationSeenResponse
 */
export class GetNotificationSeenResponse extends Message<GetNotificationSeenResponse> {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  constructor(data?: PartialMessage<GetNotificationSeenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetNotificationSeenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNotificationSeenResponse {
    return new GetNotificationSeenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNotificationSeenResponse {
    return new GetNotificationSeenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNotificationSeenResponse {
    return new GetNotificationSeenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNotificationSeenResponse | PlainMessage<GetNotificationSeenResponse> | undefined, b: GetNotificationSeenResponse | PlainMessage<GetNotificationSeenResponse> | undefined): boolean {
    return proto3.util.equals(GetNotificationSeenResponse, a, b);
  }
}

/**
 * - get a count of all unread notifications (notifications after `updateSeen`)
 *     - `getUnreadCount`
 *
 * @generated from message bsky.GetUnreadNotificationCountRequest
 */
export class GetUnreadNotificationCountRequest extends Message<GetUnreadNotificationCountRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: bool priority = 2;
   */
  priority = false;

  constructor(data?: PartialMessage<GetUnreadNotificationCountRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetUnreadNotificationCountRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "priority", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUnreadNotificationCountRequest {
    return new GetUnreadNotificationCountRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUnreadNotificationCountRequest {
    return new GetUnreadNotificationCountRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUnreadNotificationCountRequest {
    return new GetUnreadNotificationCountRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUnreadNotificationCountRequest | PlainMessage<GetUnreadNotificationCountRequest> | undefined, b: GetUnreadNotificationCountRequest | PlainMessage<GetUnreadNotificationCountRequest> | undefined): boolean {
    return proto3.util.equals(GetUnreadNotificationCountRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetUnreadNotificationCountResponse
 */
export class GetUnreadNotificationCountResponse extends Message<GetUnreadNotificationCountResponse> {
  /**
   * @generated from field: int32 count = 1;
   */
  count = 0;

  constructor(data?: PartialMessage<GetUnreadNotificationCountResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetUnreadNotificationCountResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUnreadNotificationCountResponse {
    return new GetUnreadNotificationCountResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUnreadNotificationCountResponse {
    return new GetUnreadNotificationCountResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUnreadNotificationCountResponse {
    return new GetUnreadNotificationCountResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUnreadNotificationCountResponse | PlainMessage<GetUnreadNotificationCountResponse> | undefined, b: GetUnreadNotificationCountResponse | PlainMessage<GetUnreadNotificationCountResponse> | undefined): boolean {
    return proto3.util.equals(GetUnreadNotificationCountResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActivitySubscriptionDidsRequest
 */
export class GetActivitySubscriptionDidsRequest extends Message<GetActivitySubscriptionDidsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActivitySubscriptionDidsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActivitySubscriptionDidsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivitySubscriptionDidsRequest {
    return new GetActivitySubscriptionDidsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivitySubscriptionDidsRequest {
    return new GetActivitySubscriptionDidsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivitySubscriptionDidsRequest {
    return new GetActivitySubscriptionDidsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivitySubscriptionDidsRequest | PlainMessage<GetActivitySubscriptionDidsRequest> | undefined, b: GetActivitySubscriptionDidsRequest | PlainMessage<GetActivitySubscriptionDidsRequest> | undefined): boolean {
    return proto3.util.equals(GetActivitySubscriptionDidsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActivitySubscriptionDidsResponse
 */
export class GetActivitySubscriptionDidsResponse extends Message<GetActivitySubscriptionDidsResponse> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActivitySubscriptionDidsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActivitySubscriptionDidsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivitySubscriptionDidsResponse {
    return new GetActivitySubscriptionDidsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivitySubscriptionDidsResponse {
    return new GetActivitySubscriptionDidsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivitySubscriptionDidsResponse {
    return new GetActivitySubscriptionDidsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivitySubscriptionDidsResponse | PlainMessage<GetActivitySubscriptionDidsResponse> | undefined, b: GetActivitySubscriptionDidsResponse | PlainMessage<GetActivitySubscriptionDidsResponse> | undefined): boolean {
    return proto3.util.equals(GetActivitySubscriptionDidsResponse, a, b);
  }
}

/**
 * @generated from message bsky.PostActivitySubscription
 */
export class PostActivitySubscription extends Message<PostActivitySubscription> {
  constructor(data?: PartialMessage<PostActivitySubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PostActivitySubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostActivitySubscription {
    return new PostActivitySubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostActivitySubscription {
    return new PostActivitySubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostActivitySubscription {
    return new PostActivitySubscription().fromJsonString(jsonString, options);
  }

  static equals(a: PostActivitySubscription | PlainMessage<PostActivitySubscription> | undefined, b: PostActivitySubscription | PlainMessage<PostActivitySubscription> | undefined): boolean {
    return proto3.util.equals(PostActivitySubscription, a, b);
  }
}

/**
 * @generated from message bsky.ReplyActivitySubscription
 */
export class ReplyActivitySubscription extends Message<ReplyActivitySubscription> {
  constructor(data?: PartialMessage<ReplyActivitySubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ReplyActivitySubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplyActivitySubscription {
    return new ReplyActivitySubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplyActivitySubscription {
    return new ReplyActivitySubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplyActivitySubscription {
    return new ReplyActivitySubscription().fromJsonString(jsonString, options);
  }

  static equals(a: ReplyActivitySubscription | PlainMessage<ReplyActivitySubscription> | undefined, b: ReplyActivitySubscription | PlainMessage<ReplyActivitySubscription> | undefined): boolean {
    return proto3.util.equals(ReplyActivitySubscription, a, b);
  }
}

/**
 * @generated from message bsky.ActivitySubscription
 */
export class ActivitySubscription extends Message<ActivitySubscription> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string namespace = 2;
   */
  namespace = "";

  /**
   * @generated from field: string key = 3;
   */
  key = "";

  /**
   * @generated from field: optional bsky.PostActivitySubscription post = 4;
   */
  post?: PostActivitySubscription;

  /**
   * @generated from field: optional bsky.ReplyActivitySubscription reply = 5;
   */
  reply?: ReplyActivitySubscription;

  /**
   * @generated from field: string subject_did = 6;
   */
  subjectDid = "";

  /**
   * @generated from field: google.protobuf.Timestamp indexed_at = 7;
   */
  indexedAt?: Timestamp;

  constructor(data?: PartialMessage<ActivitySubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ActivitySubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "namespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "post", kind: "message", T: PostActivitySubscription, opt: true },
    { no: 5, name: "reply", kind: "message", T: ReplyActivitySubscription, opt: true },
    { no: 6, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "indexed_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivitySubscription {
    return new ActivitySubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivitySubscription {
    return new ActivitySubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivitySubscription {
    return new ActivitySubscription().fromJsonString(jsonString, options);
  }

  static equals(a: ActivitySubscription | PlainMessage<ActivitySubscription> | undefined, b: ActivitySubscription | PlainMessage<ActivitySubscription> | undefined): boolean {
    return proto3.util.equals(ActivitySubscription, a, b);
  }
}

/**
 * @generated from message bsky.GetActivitySubscriptionsByActorAndSubjectsRequest
 */
export class GetActivitySubscriptionsByActorAndSubjectsRequest extends Message<GetActivitySubscriptionsByActorAndSubjectsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string subject_dids = 2;
   */
  subjectDids: string[] = [];

  constructor(data?: PartialMessage<GetActivitySubscriptionsByActorAndSubjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActivitySubscriptionsByActorAndSubjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivitySubscriptionsByActorAndSubjectsRequest {
    return new GetActivitySubscriptionsByActorAndSubjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivitySubscriptionsByActorAndSubjectsRequest {
    return new GetActivitySubscriptionsByActorAndSubjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivitySubscriptionsByActorAndSubjectsRequest {
    return new GetActivitySubscriptionsByActorAndSubjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivitySubscriptionsByActorAndSubjectsRequest | PlainMessage<GetActivitySubscriptionsByActorAndSubjectsRequest> | undefined, b: GetActivitySubscriptionsByActorAndSubjectsRequest | PlainMessage<GetActivitySubscriptionsByActorAndSubjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetActivitySubscriptionsByActorAndSubjectsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActivitySubscriptionsByActorAndSubjectsResponse
 */
export class GetActivitySubscriptionsByActorAndSubjectsResponse extends Message<GetActivitySubscriptionsByActorAndSubjectsResponse> {
  /**
   * @generated from field: repeated bsky.ActivitySubscription subscriptions = 1;
   */
  subscriptions: ActivitySubscription[] = [];

  constructor(data?: PartialMessage<GetActivitySubscriptionsByActorAndSubjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActivitySubscriptionsByActorAndSubjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subscriptions", kind: "message", T: ActivitySubscription, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActivitySubscriptionsByActorAndSubjectsResponse {
    return new GetActivitySubscriptionsByActorAndSubjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActivitySubscriptionsByActorAndSubjectsResponse {
    return new GetActivitySubscriptionsByActorAndSubjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActivitySubscriptionsByActorAndSubjectsResponse {
    return new GetActivitySubscriptionsByActorAndSubjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActivitySubscriptionsByActorAndSubjectsResponse | PlainMessage<GetActivitySubscriptionsByActorAndSubjectsResponse> | undefined, b: GetActivitySubscriptionsByActorAndSubjectsResponse | PlainMessage<GetActivitySubscriptionsByActorAndSubjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetActivitySubscriptionsByActorAndSubjectsResponse, a, b);
  }
}

/**
 * - Return uris of feed generator records created by user A
 *     - `getActorFeeds`
 *
 * @generated from message bsky.GetActorFeedsRequest
 */
export class GetActorFeedsRequest extends Message<GetActorFeedsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorFeedsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorFeedsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorFeedsRequest {
    return new GetActorFeedsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorFeedsRequest {
    return new GetActorFeedsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorFeedsRequest {
    return new GetActorFeedsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorFeedsRequest | PlainMessage<GetActorFeedsRequest> | undefined, b: GetActorFeedsRequest | PlainMessage<GetActorFeedsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorFeedsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorFeedsResponse
 */
export class GetActorFeedsResponse extends Message<GetActorFeedsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorFeedsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorFeedsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorFeedsResponse {
    return new GetActorFeedsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorFeedsResponse {
    return new GetActorFeedsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorFeedsResponse {
    return new GetActorFeedsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorFeedsResponse | PlainMessage<GetActorFeedsResponse> | undefined, b: GetActorFeedsResponse | PlainMessage<GetActorFeedsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorFeedsResponse, a, b);
  }
}

/**
 * - Returns a list of suggested feed generator uris for an actor, paginated
 *     - `getSuggestedFeeds`
 *     - This is currently just hardcoded in the Appview DB
 *
 * @generated from message bsky.GetSuggestedFeedsRequest
 */
export class GetSuggestedFeedsRequest extends Message<GetSuggestedFeedsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetSuggestedFeedsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSuggestedFeedsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedFeedsRequest {
    return new GetSuggestedFeedsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedFeedsRequest {
    return new GetSuggestedFeedsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedFeedsRequest {
    return new GetSuggestedFeedsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedFeedsRequest | PlainMessage<GetSuggestedFeedsRequest> | undefined, b: GetSuggestedFeedsRequest | PlainMessage<GetSuggestedFeedsRequest> | undefined): boolean {
    return proto3.util.equals(GetSuggestedFeedsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSuggestedFeedsResponse
 */
export class GetSuggestedFeedsResponse extends Message<GetSuggestedFeedsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetSuggestedFeedsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSuggestedFeedsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedFeedsResponse {
    return new GetSuggestedFeedsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedFeedsResponse {
    return new GetSuggestedFeedsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedFeedsResponse {
    return new GetSuggestedFeedsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedFeedsResponse | PlainMessage<GetSuggestedFeedsResponse> | undefined, b: GetSuggestedFeedsResponse | PlainMessage<GetSuggestedFeedsResponse> | undefined): boolean {
    return proto3.util.equals(GetSuggestedFeedsResponse, a, b);
  }
}

/**
 * @generated from message bsky.SearchFeedGeneratorsRequest
 */
export class SearchFeedGeneratorsRequest extends Message<SearchFeedGeneratorsRequest> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<SearchFeedGeneratorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchFeedGeneratorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchFeedGeneratorsRequest {
    return new SearchFeedGeneratorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsRequest {
    return new SearchFeedGeneratorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsRequest {
    return new SearchFeedGeneratorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchFeedGeneratorsRequest | PlainMessage<SearchFeedGeneratorsRequest> | undefined, b: SearchFeedGeneratorsRequest | PlainMessage<SearchFeedGeneratorsRequest> | undefined): boolean {
    return proto3.util.equals(SearchFeedGeneratorsRequest, a, b);
  }
}

/**
 * @generated from message bsky.SearchFeedGeneratorsResponse
 */
export class SearchFeedGeneratorsResponse extends Message<SearchFeedGeneratorsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<SearchFeedGeneratorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchFeedGeneratorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchFeedGeneratorsResponse {
    return new SearchFeedGeneratorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsResponse {
    return new SearchFeedGeneratorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsResponse {
    return new SearchFeedGeneratorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchFeedGeneratorsResponse | PlainMessage<SearchFeedGeneratorsResponse> | undefined, b: SearchFeedGeneratorsResponse | PlainMessage<SearchFeedGeneratorsResponse> | undefined): boolean {
    return proto3.util.equals(SearchFeedGeneratorsResponse, a, b);
  }
}

/**
 * - Returns feed generator validity and online status with uris A, B, C…
 *     - Not currently being used, but could be worhthwhile.
 *
 * @generated from message bsky.GetFeedGeneratorStatusRequest
 */
export class GetFeedGeneratorStatusRequest extends Message<GetFeedGeneratorStatusRequest> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetFeedGeneratorStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFeedGeneratorStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFeedGeneratorStatusRequest {
    return new GetFeedGeneratorStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFeedGeneratorStatusRequest {
    return new GetFeedGeneratorStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFeedGeneratorStatusRequest {
    return new GetFeedGeneratorStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFeedGeneratorStatusRequest | PlainMessage<GetFeedGeneratorStatusRequest> | undefined, b: GetFeedGeneratorStatusRequest | PlainMessage<GetFeedGeneratorStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetFeedGeneratorStatusRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetFeedGeneratorStatusResponse
 */
export class GetFeedGeneratorStatusResponse extends Message<GetFeedGeneratorStatusResponse> {
  /**
   * @generated from field: repeated string status = 1;
   */
  status: string[] = [];

  constructor(data?: PartialMessage<GetFeedGeneratorStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFeedGeneratorStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFeedGeneratorStatusResponse {
    return new GetFeedGeneratorStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFeedGeneratorStatusResponse {
    return new GetFeedGeneratorStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFeedGeneratorStatusResponse {
    return new GetFeedGeneratorStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFeedGeneratorStatusResponse | PlainMessage<GetFeedGeneratorStatusResponse> | undefined, b: GetFeedGeneratorStatusResponse | PlainMessage<GetFeedGeneratorStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetFeedGeneratorStatusResponse, a, b);
  }
}

/**
 * - Returns recent posts authored by a given DID, paginated
 *     - `getAuthorFeed`
 *     - Optionally: filter by if a post is/isn’t a reply and if a post has a media object in it
 *
 * @generated from message bsky.GetAuthorFeedRequest
 */
export class GetAuthorFeedRequest extends Message<GetAuthorFeedRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: bsky.FeedType feed_type = 4;
   */
  feedType = FeedType.UNSPECIFIED;

  constructor(data?: PartialMessage<GetAuthorFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetAuthorFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "feed_type", kind: "enum", T: proto3.getEnumType(FeedType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAuthorFeedRequest {
    return new GetAuthorFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAuthorFeedRequest {
    return new GetAuthorFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAuthorFeedRequest {
    return new GetAuthorFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAuthorFeedRequest | PlainMessage<GetAuthorFeedRequest> | undefined, b: GetAuthorFeedRequest | PlainMessage<GetAuthorFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetAuthorFeedRequest, a, b);
  }
}

/**
 * @generated from message bsky.AuthorFeedItem
 */
export class AuthorFeedItem extends Message<AuthorFeedItem> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  /**
   * @generated from field: string repost = 3;
   */
  repost = "";

  /**
   * @generated from field: string repost_cid = 4;
   */
  repostCid = "";

  /**
   * @generated from field: bool posts_and_author_threads = 5;
   */
  postsAndAuthorThreads = false;

  /**
   * @generated from field: bool posts_no_replies = 6;
   */
  postsNoReplies = false;

  /**
   * @generated from field: bool posts_with_media = 7;
   */
  postsWithMedia = false;

  /**
   * @generated from field: bool is_reply = 8;
   */
  isReply = false;

  /**
   * @generated from field: bool is_repost = 9;
   */
  isRepost = false;

  /**
   * @generated from field: bool is_quote_post = 10;
   */
  isQuotePost = false;

  /**
   * @generated from field: bool posts_with_video = 11;
   */
  postsWithVideo = false;

  constructor(data?: PartialMessage<AuthorFeedItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.AuthorFeedItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "repost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "repost_cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "posts_and_author_threads", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "posts_no_replies", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "posts_with_media", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_repost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_quote_post", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "posts_with_video", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuthorFeedItem {
    return new AuthorFeedItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuthorFeedItem {
    return new AuthorFeedItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuthorFeedItem {
    return new AuthorFeedItem().fromJsonString(jsonString, options);
  }

  static equals(a: AuthorFeedItem | PlainMessage<AuthorFeedItem> | undefined, b: AuthorFeedItem | PlainMessage<AuthorFeedItem> | undefined): boolean {
    return proto3.util.equals(AuthorFeedItem, a, b);
  }
}

/**
 * @generated from message bsky.GetAuthorFeedResponse
 */
export class GetAuthorFeedResponse extends Message<GetAuthorFeedResponse> {
  /**
   * @generated from field: repeated bsky.AuthorFeedItem items = 1;
   */
  items: AuthorFeedItem[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetAuthorFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetAuthorFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: AuthorFeedItem, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAuthorFeedResponse {
    return new GetAuthorFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAuthorFeedResponse {
    return new GetAuthorFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAuthorFeedResponse {
    return new GetAuthorFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAuthorFeedResponse | PlainMessage<GetAuthorFeedResponse> | undefined, b: GetAuthorFeedResponse | PlainMessage<GetAuthorFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetAuthorFeedResponse, a, b);
  }
}

/**
 * - Returns recent posts authored by users followed by a given DID, paginated
 *     - `getTimeline`
 *
 * @generated from message bsky.GetTimelineRequest
 */
export class GetTimelineRequest extends Message<GetTimelineRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: bool exclude_replies = 4;
   */
  excludeReplies = false;

  /**
   * @generated from field: bool exclude_reposts = 5;
   */
  excludeReposts = false;

  /**
   * @generated from field: bool exclude_quotes = 6;
   */
  excludeQuotes = false;

  constructor(data?: PartialMessage<GetTimelineRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetTimelineRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "exclude_replies", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "exclude_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "exclude_quotes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTimelineRequest {
    return new GetTimelineRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTimelineRequest {
    return new GetTimelineRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTimelineRequest {
    return new GetTimelineRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTimelineRequest | PlainMessage<GetTimelineRequest> | undefined, b: GetTimelineRequest | PlainMessage<GetTimelineRequest> | undefined): boolean {
    return proto3.util.equals(GetTimelineRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetTimelineResponse
 */
export class GetTimelineResponse extends Message<GetTimelineResponse> {
  /**
   * @generated from field: repeated bsky.TimelineFeedItem items = 1;
   */
  items: TimelineFeedItem[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetTimelineResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetTimelineResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TimelineFeedItem, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTimelineResponse {
    return new GetTimelineResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTimelineResponse {
    return new GetTimelineResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTimelineResponse {
    return new GetTimelineResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTimelineResponse | PlainMessage<GetTimelineResponse> | undefined, b: GetTimelineResponse | PlainMessage<GetTimelineResponse> | undefined): boolean {
    return proto3.util.equals(GetTimelineResponse, a, b);
  }
}

/**
 * @generated from message bsky.TimelineFeedItem
 */
export class TimelineFeedItem extends Message<TimelineFeedItem> {
  /**
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  /**
   * @generated from field: string repost = 3;
   */
  repost = "";

  /**
   * @generated from field: string repost_cid = 4;
   */
  repostCid = "";

  /**
   * @generated from field: bool is_reply = 5;
   */
  isReply = false;

  /**
   * @generated from field: bool is_repost = 6;
   */
  isRepost = false;

  /**
   * @generated from field: bool is_quote_post = 7;
   */
  isQuotePost = false;

  constructor(data?: PartialMessage<TimelineFeedItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TimelineFeedItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "repost", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "repost_cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_reply", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_repost", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_quote_post", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TimelineFeedItem {
    return new TimelineFeedItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TimelineFeedItem {
    return new TimelineFeedItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TimelineFeedItem {
    return new TimelineFeedItem().fromJsonString(jsonString, options);
  }

  static equals(a: TimelineFeedItem | PlainMessage<TimelineFeedItem> | undefined, b: TimelineFeedItem | PlainMessage<TimelineFeedItem> | undefined): boolean {
    return proto3.util.equals(TimelineFeedItem, a, b);
  }
}

/**
 * - Return recent post uris from users in list A
 *     - `getListFeed`
 *     - (This is essentially the same as `getTimeline` but instead of follows of a did, it is list items of a list)
 *
 * @generated from message bsky.GetListFeedRequest
 */
export class GetListFeedRequest extends Message<GetListFeedRequest> {
  /**
   * @generated from field: string list_uri = 1;
   */
  listUri = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  /**
   * @generated from field: bool exclude_replies = 4;
   */
  excludeReplies = false;

  /**
   * @generated from field: bool exclude_reposts = 5;
   */
  excludeReposts = false;

  /**
   * @generated from field: bool exclude_quotes = 6;
   */
  excludeQuotes = false;

  constructor(data?: PartialMessage<GetListFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "list_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "exclude_replies", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "exclude_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "exclude_quotes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListFeedRequest {
    return new GetListFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListFeedRequest {
    return new GetListFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListFeedRequest {
    return new GetListFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetListFeedRequest | PlainMessage<GetListFeedRequest> | undefined, b: GetListFeedRequest | PlainMessage<GetListFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetListFeedRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetListFeedResponse
 */
export class GetListFeedResponse extends Message<GetListFeedResponse> {
  /**
   * @generated from field: repeated bsky.TimelineFeedItem items = 1;
   */
  items: TimelineFeedItem[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetListFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetListFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TimelineFeedItem, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetListFeedResponse {
    return new GetListFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetListFeedResponse {
    return new GetListFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetListFeedResponse {
    return new GetListFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetListFeedResponse | PlainMessage<GetListFeedResponse> | undefined, b: GetListFeedResponse | PlainMessage<GetListFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetListFeedResponse, a, b);
  }
}

/**
 * Return posts uris of any replies N levels above or M levels below post A
 *
 * @generated from message bsky.GetThreadRequest
 */
export class GetThreadRequest extends Message<GetThreadRequest> {
  /**
   * @generated from field: string post_uri = 1;
   */
  postUri = "";

  /**
   * @generated from field: int32 above = 2;
   */
  above = 0;

  /**
   * @generated from field: int32 below = 3;
   */
  below = 0;

  constructor(data?: PartialMessage<GetThreadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "post_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "above", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "below", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadRequest {
    return new GetThreadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadRequest {
    return new GetThreadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadRequest {
    return new GetThreadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadRequest | PlainMessage<GetThreadRequest> | undefined, b: GetThreadRequest | PlainMessage<GetThreadRequest> | undefined): boolean {
    return proto3.util.equals(GetThreadRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetThreadResponse
 */
export class GetThreadResponse extends Message<GetThreadResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * The complete OP thread: the root post followed by the oldest contiguous
   * chain of OP replies, in chain order. Never trimmed to the posts present
   * in uris — callers derive a post's position with indexOf and the thread
   * length with len, so completeness and ordering are load-bearing. Empty
   * when the thread has no OP replies.
   *
   * @generated from field: repeated string op_thread = 2;
   */
  opThread: string[] = [];

  constructor(data?: PartialMessage<GetThreadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetThreadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "op_thread", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetThreadResponse {
    return new GetThreadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetThreadResponse {
    return new GetThreadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetThreadResponse {
    return new GetThreadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetThreadResponse | PlainMessage<GetThreadResponse> | undefined, b: GetThreadResponse | PlainMessage<GetThreadResponse> | undefined): boolean {
    return proto3.util.equals(GetThreadResponse, a, b);
  }
}

/**
 * - Return DIDs of actors matching term, paginated
 *     - `searchActors` skeleton
 *
 * @generated from message bsky.SearchActorsRequest
 */
export class SearchActorsRequest extends Message<SearchActorsRequest> {
  /**
   * @generated from field: string term = 1;
   */
  term = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchActorsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsRequest {
    return new SearchActorsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsRequest {
    return new SearchActorsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsRequest {
    return new SearchActorsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsRequest | PlainMessage<SearchActorsRequest> | undefined, b: SearchActorsRequest | PlainMessage<SearchActorsRequest> | undefined): boolean {
    return proto3.util.equals(SearchActorsRequest, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorsResponse
 */
export class SearchActorsResponse extends Message<SearchActorsResponse> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchActorsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsResponse {
    return new SearchActorsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsResponse {
    return new SearchActorsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsResponse {
    return new SearchActorsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsResponse | PlainMessage<SearchActorsResponse> | undefined, b: SearchActorsResponse | PlainMessage<SearchActorsResponse> | undefined): boolean {
    return proto3.util.equals(SearchActorsResponse, a, b);
  }
}

/**
 * - Return uris of posts matching term, paginated
 *     - `searchPosts` skeleton
 *
 * @generated from message bsky.SearchPostsRequest
 */
export class SearchPostsRequest extends Message<SearchPostsRequest> {
  /**
   * @generated from field: string term = 1;
   */
  term = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchPostsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchPostsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchPostsRequest {
    return new SearchPostsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchPostsRequest {
    return new SearchPostsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchPostsRequest {
    return new SearchPostsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchPostsRequest | PlainMessage<SearchPostsRequest> | undefined, b: SearchPostsRequest | PlainMessage<SearchPostsRequest> | undefined): boolean {
    return proto3.util.equals(SearchPostsRequest, a, b);
  }
}

/**
 * @generated from message bsky.SearchPostsResponse
 */
export class SearchPostsResponse extends Message<SearchPostsResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchPostsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchPostsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchPostsResponse {
    return new SearchPostsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchPostsResponse {
    return new SearchPostsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchPostsResponse {
    return new SearchPostsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchPostsResponse | PlainMessage<SearchPostsResponse> | undefined, b: SearchPostsResponse | PlainMessage<SearchPostsResponse> | undefined): boolean {
    return proto3.util.equals(SearchPostsResponse, a, b);
  }
}

/**
 * - Return uris of starter packs matching term, paginated
 *     - `searchStarterPacks` skeleton
 *
 * @generated from message bsky.SearchStarterPacksRequest
 */
export class SearchStarterPacksRequest extends Message<SearchStarterPacksRequest> {
  /**
   * @generated from field: string term = 1;
   */
  term = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchStarterPacksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchStarterPacksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "term", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchStarterPacksRequest {
    return new SearchStarterPacksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchStarterPacksRequest {
    return new SearchStarterPacksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchStarterPacksRequest {
    return new SearchStarterPacksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchStarterPacksRequest | PlainMessage<SearchStarterPacksRequest> | undefined, b: SearchStarterPacksRequest | PlainMessage<SearchStarterPacksRequest> | undefined): boolean {
    return proto3.util.equals(SearchStarterPacksRequest, a, b);
  }
}

/**
 * @generated from message bsky.SearchStarterPacksResponse
 */
export class SearchStarterPacksResponse extends Message<SearchStarterPacksResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchStarterPacksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchStarterPacksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchStarterPacksResponse {
    return new SearchStarterPacksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchStarterPacksResponse {
    return new SearchStarterPacksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchStarterPacksResponse {
    return new SearchStarterPacksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchStarterPacksResponse | PlainMessage<SearchStarterPacksResponse> | undefined, b: SearchStarterPacksResponse | PlainMessage<SearchStarterPacksResponse> | undefined): boolean {
    return proto3.util.equals(SearchStarterPacksResponse, a, b);
  }
}

/**
 * Shared request params for paginated methods
 *
 * @generated from message bsky.SearchParams
 */
export class SearchParams extends Message<SearchParams> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: string viewer = 2;
   */
  viewer = "";

  /**
   * Pagination
   *
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 4;
   */
  cursor = "";

  constructor(data?: PartialMessage<SearchParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "viewer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchParams {
    return new SearchParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchParams {
    return new SearchParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchParams {
    return new SearchParams().fromJsonString(jsonString, options);
  }

  static equals(a: SearchParams | PlainMessage<SearchParams> | undefined, b: SearchParams | PlainMessage<SearchParams> | undefined): boolean {
    return proto3.util.equals(SearchParams, a, b);
  }
}

/**
 * Shared params for typeahead-style searches, which aren't paginated.
 *
 * @generated from message bsky.SearchTypeaheadParams
 */
export class SearchTypeaheadParams extends Message<SearchTypeaheadParams> {
  /**
   * @generated from field: string query = 1;
   */
  query = "";

  /**
   * @generated from field: string viewer = 2;
   */
  viewer = "";

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  constructor(data?: PartialMessage<SearchTypeaheadParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchTypeaheadParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "viewer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchTypeaheadParams {
    return new SearchTypeaheadParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchTypeaheadParams {
    return new SearchTypeaheadParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchTypeaheadParams {
    return new SearchTypeaheadParams().fromJsonString(jsonString, options);
  }

  static equals(a: SearchTypeaheadParams | PlainMessage<SearchTypeaheadParams> | undefined, b: SearchTypeaheadParams | PlainMessage<SearchTypeaheadParams> | undefined): boolean {
    return proto3.util.equals(SearchTypeaheadParams, a, b);
  }
}

/**
 * SearchRecordResult represents a generic result hit corresponding to a record.
 *
 * @generated from message bsky.SearchRecordResult
 */
export class SearchRecordResult extends Message<SearchRecordResult> {
  /**
   * AT URI of the record, e.g. "at://did:example:alice/app.bsky.feed.post/12345"
   *
   * @generated from field: string uri = 1;
   */
  uri = "";

  /**
   * @generated from field: double score = 2;
   */
  score = 0;

  constructor(data?: PartialMessage<SearchRecordResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchRecordResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchRecordResult {
    return new SearchRecordResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchRecordResult {
    return new SearchRecordResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchRecordResult {
    return new SearchRecordResult().fromJsonString(jsonString, options);
  }

  static equals(a: SearchRecordResult | PlainMessage<SearchRecordResult> | undefined, b: SearchRecordResult | PlainMessage<SearchRecordResult> | undefined): boolean {
    return proto3.util.equals(SearchRecordResult, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorResult
 */
export class SearchActorResult extends Message<SearchActorResult> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: double score = 2;
   */
  score = 0;

  constructor(data?: PartialMessage<SearchActorResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorResult {
    return new SearchActorResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorResult {
    return new SearchActorResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorResult {
    return new SearchActorResult().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorResult | PlainMessage<SearchActorResult> | undefined, b: SearchActorResult | PlainMessage<SearchActorResult> | undefined): boolean {
    return proto3.util.equals(SearchActorResult, a, b);
  }
}

/**
 * @generated from message bsky.PageInfo
 */
export class PageInfo extends Message<PageInfo> {
  /**
   * @generated from field: string cursor = 1;
   */
  cursor = "";

  /**
   * @generated from field: int64 hits_total = 2;
   */
  hitsTotal = protoInt64.zero;

  constructor(data?: PartialMessage<PageInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PageInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "hits_total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PageInfo {
    return new PageInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PageInfo {
    return new PageInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PageInfo {
    return new PageInfo().fromJsonString(jsonString, options);
  }

  static equals(a: PageInfo | PlainMessage<PageInfo> | undefined, b: PageInfo | PlainMessage<PageInfo> | undefined): boolean {
    return proto3.util.equals(PageInfo, a, b);
  }
}

/**
 * PostFilters are logical filters that should be used to match or exclude posts.
 * Each repeated field is applied as OR within the field with all fields applied together as AND.
 * example:
 *  filters: {
 *    authors: [alice, bob]
 *    mentions: [carol]
 *  }
 * => (author is alice OR bob) AND (mentions carol)
 *
 *
 * @generated from message bsky.PostsFilters
 */
export class PostsFilters extends Message<PostsFilters> {
  /**
   * Author/mention filters
   *
   * @generated from field: repeated string authors = 1;
   */
  authors: string[] = [];

  /**
   * @generated from field: repeated string mentions = 2;
   */
  mentions: string[] = [];

  /**
   * Content filters
   *
   * @generated from field: repeated string domains = 3;
   */
  domains: string[] = [];

  /**
   * @generated from field: repeated string urls = 4;
   */
  urls: string[] = [];

  /**
   * Canonical request field for posts embedding these AT-URI records.
   *
   * @generated from field: repeated string embedded_at_uris = 5;
   */
  embeddedAtUris: string[] = [];

  /**
   * @generated from field: repeated string hashtags = 6;
   */
  hashtags: string[] = [];

  /**
   * Filter posts in any of these languages
   * Supports 2-char ISO prefixes ("en", "ja", "fr", etc) and compares against
   * the 2-char prefix of any `langs` field values of the post record.
   * e.g. a post with langs=["en-US", "fr"] matches ["en"] or ["fr", "ja"] but not ["ja"].
   *
   * @generated from field: repeated string languages = 7;
   */
  languages: string[] = [];

  constructor(data?: PartialMessage<PostsFilters>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PostsFilters";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "authors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "mentions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "embedded_at_uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "hashtags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "languages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PostsFilters {
    return new PostsFilters().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PostsFilters {
    return new PostsFilters().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PostsFilters {
    return new PostsFilters().fromJsonString(jsonString, options);
  }

  static equals(a: PostsFilters | PlainMessage<PostsFilters> | undefined, b: PostsFilters | PlainMessage<PostsFilters> | undefined): boolean {
    return proto3.util.equals(PostsFilters, a, b);
  }
}

/**
 * @generated from message bsky.SearchPostsV2Request
 */
export class SearchPostsV2Request extends Message<SearchPostsV2Request> {
  /**
   * Required fields
   *
   * @generated from field: bsky.SearchParams params = 1;
   */
  params?: SearchParams;

  /**
   * @generated from field: bsky.SearchSortOrder sort = 2;
   */
  sort = SearchSortOrder.UNSPECIFIED;

  /**
   * Logical filters and exclude fields applied together as AND
   *
   * filters: include posts matching the filters
   *
   * @generated from field: bsky.PostsFilters filters = 3;
   */
  filters?: PostsFilters;

  /**
   * Exclude filters: exclude posts matching the filters
   *
   * @generated from field: bsky.PostsFilters exclude = 4;
   */
  exclude?: PostsFilters;

  /**
   * Date range filters
   *
   * @generated from field: optional google.protobuf.Timestamp since = 5;
   */
  since?: Timestamp;

  /**
   * defaults to "now"
   *
   * @generated from field: optional google.protobuf.Timestamp until = 6;
   */
  until?: Timestamp;

  /**
   * If false, will only query against last 30 days of posts
   * so `since` and `until` will silently be capped
   *
   * @generated from field: optional bool all_time = 7;
   */
  allTime?: boolean;

  /**
   * Media filters
   *
   * @generated from field: optional bool has_media = 8;
   */
  hasMedia?: boolean;

  /**
   * @generated from field: optional bool has_video = 9;
   */
  hasVideo?: boolean;

  /**
   * Reply filters
   *
   * @generated from field: optional string reply_parent_uri = 10;
   */
  replyParentUri?: string;

  /**
   * @generated from field: optional string thread_root_uri = 11;
   */
  threadRootUri?: string;

  /**
   * @generated from field: optional bool exclude_replies = 12;
   */
  excludeReplies?: boolean;

  /**
   * @generated from field: optional bool replies_only = 13;
   */
  repliesOnly?: boolean;

  /**
   * Social filters
   *
   * @generated from field: optional bool following = 14;
   */
  following?: boolean;

  /**
   * Query analysis hint — forces a specific language analyzer.
   * Auto-detects from query text when unset.
   *
   * @generated from field: optional bsky.SearchQueryLanguage query_language = 15;
   */
  queryLanguage?: SearchQueryLanguage;

  constructor(data?: PartialMessage<SearchPostsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchPostsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: SearchParams },
    { no: 2, name: "sort", kind: "enum", T: proto3.getEnumType(SearchSortOrder) },
    { no: 3, name: "filters", kind: "message", T: PostsFilters },
    { no: 4, name: "exclude", kind: "message", T: PostsFilters },
    { no: 5, name: "since", kind: "message", T: Timestamp, opt: true },
    { no: 6, name: "until", kind: "message", T: Timestamp, opt: true },
    { no: 7, name: "all_time", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 8, name: "has_media", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 9, name: "has_video", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "reply_parent_uri", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "thread_root_uri", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "exclude_replies", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 13, name: "replies_only", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 14, name: "following", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 15, name: "query_language", kind: "enum", T: proto3.getEnumType(SearchQueryLanguage), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchPostsV2Request {
    return new SearchPostsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchPostsV2Request {
    return new SearchPostsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchPostsV2Request {
    return new SearchPostsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: SearchPostsV2Request | PlainMessage<SearchPostsV2Request> | undefined, b: SearchPostsV2Request | PlainMessage<SearchPostsV2Request> | undefined): boolean {
    return proto3.util.equals(SearchPostsV2Request, a, b);
  }
}

/**
 * @generated from message bsky.SearchPostsV2Response
 */
export class SearchPostsV2Response extends Message<SearchPostsV2Response> {
  /**
   * @generated from field: repeated bsky.SearchRecordResult posts = 1;
   */
  posts: SearchRecordResult[] = [];

  /**
   * @generated from field: bsky.PageInfo page_info = 2;
   */
  pageInfo?: PageInfo;

  /**
   * Detected CJK/Thai/Arabic languages of the query, usually one. Han-only text
   * returns ["zh", "ja"] since it's ambiguous between Chinese and Japanese.
   * set query_language on the request to disambiguate.
   * Currently left empty for other scripts (e.g. Latin-based languages like English).
   *
   * @generated from field: repeated string detected_query_languages = 3;
   */
  detectedQueryLanguages: string[] = [];

  constructor(data?: PartialMessage<SearchPostsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchPostsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "posts", kind: "message", T: SearchRecordResult, repeated: true },
    { no: 2, name: "page_info", kind: "message", T: PageInfo },
    { no: 3, name: "detected_query_languages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchPostsV2Response {
    return new SearchPostsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchPostsV2Response {
    return new SearchPostsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchPostsV2Response {
    return new SearchPostsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: SearchPostsV2Response | PlainMessage<SearchPostsV2Response> | undefined, b: SearchPostsV2Response | PlainMessage<SearchPostsV2Response> | undefined): boolean {
    return proto3.util.equals(SearchPostsV2Response, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorsV2Request
 */
export class SearchActorsV2Request extends Message<SearchActorsV2Request> {
  /**
   * @generated from field: bsky.SearchParams params = 1;
   */
  params?: SearchParams;

  constructor(data?: PartialMessage<SearchActorsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: SearchParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsV2Request {
    return new SearchActorsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsV2Request {
    return new SearchActorsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsV2Request {
    return new SearchActorsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsV2Request | PlainMessage<SearchActorsV2Request> | undefined, b: SearchActorsV2Request | PlainMessage<SearchActorsV2Request> | undefined): boolean {
    return proto3.util.equals(SearchActorsV2Request, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorsV2Response
 */
export class SearchActorsV2Response extends Message<SearchActorsV2Response> {
  /**
   * @generated from field: repeated bsky.SearchActorResult actors = 1;
   */
  actors: SearchActorResult[] = [];

  /**
   * @generated from field: bsky.PageInfo page_info = 2;
   */
  pageInfo?: PageInfo;

  constructor(data?: PartialMessage<SearchActorsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actors", kind: "message", T: SearchActorResult, repeated: true },
    { no: 2, name: "page_info", kind: "message", T: PageInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsV2Response {
    return new SearchActorsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsV2Response {
    return new SearchActorsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsV2Response {
    return new SearchActorsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsV2Response | PlainMessage<SearchActorsV2Response> | undefined, b: SearchActorsV2Response | PlainMessage<SearchActorsV2Response> | undefined): boolean {
    return proto3.util.equals(SearchActorsV2Response, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorsTypeaheadRequest
 */
export class SearchActorsTypeaheadRequest extends Message<SearchActorsTypeaheadRequest> {
  /**
   * @generated from field: bsky.SearchTypeaheadParams params = 1;
   */
  params?: SearchTypeaheadParams;

  constructor(data?: PartialMessage<SearchActorsTypeaheadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsTypeaheadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: SearchTypeaheadParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsTypeaheadRequest {
    return new SearchActorsTypeaheadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsTypeaheadRequest {
    return new SearchActorsTypeaheadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsTypeaheadRequest {
    return new SearchActorsTypeaheadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsTypeaheadRequest | PlainMessage<SearchActorsTypeaheadRequest> | undefined, b: SearchActorsTypeaheadRequest | PlainMessage<SearchActorsTypeaheadRequest> | undefined): boolean {
    return proto3.util.equals(SearchActorsTypeaheadRequest, a, b);
  }
}

/**
 * @generated from message bsky.SearchActorsTypeaheadResponse
 */
export class SearchActorsTypeaheadResponse extends Message<SearchActorsTypeaheadResponse> {
  /**
   * @generated from field: repeated bsky.SearchActorResult actors = 1;
   */
  actors: SearchActorResult[] = [];

  constructor(data?: PartialMessage<SearchActorsTypeaheadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchActorsTypeaheadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actors", kind: "message", T: SearchActorResult, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchActorsTypeaheadResponse {
    return new SearchActorsTypeaheadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchActorsTypeaheadResponse {
    return new SearchActorsTypeaheadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchActorsTypeaheadResponse {
    return new SearchActorsTypeaheadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchActorsTypeaheadResponse | PlainMessage<SearchActorsTypeaheadResponse> | undefined, b: SearchActorsTypeaheadResponse | PlainMessage<SearchActorsTypeaheadResponse> | undefined): boolean {
    return proto3.util.equals(SearchActorsTypeaheadResponse, a, b);
  }
}

/**
 * @generated from message bsky.SearchFeedGeneratorsV2Request
 */
export class SearchFeedGeneratorsV2Request extends Message<SearchFeedGeneratorsV2Request> {
  /**
   * @generated from field: bsky.SearchParams params = 1;
   */
  params?: SearchParams;

  constructor(data?: PartialMessage<SearchFeedGeneratorsV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchFeedGeneratorsV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: SearchParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchFeedGeneratorsV2Request {
    return new SearchFeedGeneratorsV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsV2Request {
    return new SearchFeedGeneratorsV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsV2Request {
    return new SearchFeedGeneratorsV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: SearchFeedGeneratorsV2Request | PlainMessage<SearchFeedGeneratorsV2Request> | undefined, b: SearchFeedGeneratorsV2Request | PlainMessage<SearchFeedGeneratorsV2Request> | undefined): boolean {
    return proto3.util.equals(SearchFeedGeneratorsV2Request, a, b);
  }
}

/**
 * @generated from message bsky.SearchFeedGeneratorsV2Response
 */
export class SearchFeedGeneratorsV2Response extends Message<SearchFeedGeneratorsV2Response> {
  /**
   * @generated from field: repeated bsky.SearchRecordResult feed_generators = 1;
   */
  feedGenerators: SearchRecordResult[] = [];

  /**
   * @generated from field: bsky.PageInfo page_info = 2;
   */
  pageInfo?: PageInfo;

  constructor(data?: PartialMessage<SearchFeedGeneratorsV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchFeedGeneratorsV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "feed_generators", kind: "message", T: SearchRecordResult, repeated: true },
    { no: 2, name: "page_info", kind: "message", T: PageInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchFeedGeneratorsV2Response {
    return new SearchFeedGeneratorsV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsV2Response {
    return new SearchFeedGeneratorsV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchFeedGeneratorsV2Response {
    return new SearchFeedGeneratorsV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: SearchFeedGeneratorsV2Response | PlainMessage<SearchFeedGeneratorsV2Response> | undefined, b: SearchFeedGeneratorsV2Response | PlainMessage<SearchFeedGeneratorsV2Response> | undefined): boolean {
    return proto3.util.equals(SearchFeedGeneratorsV2Response, a, b);
  }
}

/**
 * @generated from message bsky.SearchStarterPacksV2Request
 */
export class SearchStarterPacksV2Request extends Message<SearchStarterPacksV2Request> {
  /**
   * @generated from field: bsky.SearchParams params = 1;
   */
  params?: SearchParams;

  constructor(data?: PartialMessage<SearchStarterPacksV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchStarterPacksV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "params", kind: "message", T: SearchParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchStarterPacksV2Request {
    return new SearchStarterPacksV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchStarterPacksV2Request {
    return new SearchStarterPacksV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchStarterPacksV2Request {
    return new SearchStarterPacksV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: SearchStarterPacksV2Request | PlainMessage<SearchStarterPacksV2Request> | undefined, b: SearchStarterPacksV2Request | PlainMessage<SearchStarterPacksV2Request> | undefined): boolean {
    return proto3.util.equals(SearchStarterPacksV2Request, a, b);
  }
}

/**
 * @generated from message bsky.SearchStarterPacksV2Response
 */
export class SearchStarterPacksV2Response extends Message<SearchStarterPacksV2Response> {
  /**
   * @generated from field: repeated bsky.SearchRecordResult starter_packs = 1;
   */
  starterPacks: SearchRecordResult[] = [];

  /**
   * @generated from field: bsky.PageInfo page_info = 2;
   */
  pageInfo?: PageInfo;

  constructor(data?: PartialMessage<SearchStarterPacksV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SearchStarterPacksV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "starter_packs", kind: "message", T: SearchRecordResult, repeated: true },
    { no: 2, name: "page_info", kind: "message", T: PageInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchStarterPacksV2Response {
    return new SearchStarterPacksV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchStarterPacksV2Response {
    return new SearchStarterPacksV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchStarterPacksV2Response {
    return new SearchStarterPacksV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: SearchStarterPacksV2Response | PlainMessage<SearchStarterPacksV2Response> | undefined, b: SearchStarterPacksV2Response | PlainMessage<SearchStarterPacksV2Response> | undefined): boolean {
    return proto3.util.equals(SearchStarterPacksV2Response, a, b);
  }
}

/**
 * - Return DIDs of suggested follows for a user, excluding anyone they already follow
 *     - `getSuggestions`, `getSuggestedFollowsByActor`
 *
 * @generated from message bsky.GetFollowSuggestionsRequest
 */
export class GetFollowSuggestionsRequest extends Message<GetFollowSuggestionsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string relative_to_did = 2;
   */
  relativeToDid = "";

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 4;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetFollowSuggestionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowSuggestionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "relative_to_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowSuggestionsRequest {
    return new GetFollowSuggestionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowSuggestionsRequest {
    return new GetFollowSuggestionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowSuggestionsRequest {
    return new GetFollowSuggestionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowSuggestionsRequest | PlainMessage<GetFollowSuggestionsRequest> | undefined, b: GetFollowSuggestionsRequest | PlainMessage<GetFollowSuggestionsRequest> | undefined): boolean {
    return proto3.util.equals(GetFollowSuggestionsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowSuggestionsResponse
 */
export class GetFollowSuggestionsResponse extends Message<GetFollowSuggestionsResponse> {
  /**
   * @generated from field: repeated string dids = 1;
   */
  dids: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetFollowSuggestionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowSuggestionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowSuggestionsResponse {
    return new GetFollowSuggestionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowSuggestionsResponse {
    return new GetFollowSuggestionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowSuggestionsResponse {
    return new GetFollowSuggestionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowSuggestionsResponse | PlainMessage<GetFollowSuggestionsResponse> | undefined, b: GetFollowSuggestionsResponse | PlainMessage<GetFollowSuggestionsResponse> | undefined): boolean {
    return proto3.util.equals(GetFollowSuggestionsResponse, a, b);
  }
}

/**
 * @generated from message bsky.SuggestedEntity
 */
export class SuggestedEntity extends Message<SuggestedEntity> {
  /**
   * @generated from field: string tag = 1;
   */
  tag = "";

  /**
   * @generated from field: string subject = 2;
   */
  subject = "";

  /**
   * @generated from field: string subject_type = 3;
   */
  subjectType = "";

  /**
   * @generated from field: int64 priority = 4;
   */
  priority = protoInt64.zero;

  constructor(data?: PartialMessage<SuggestedEntity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SuggestedEntity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "priority", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuggestedEntity {
    return new SuggestedEntity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuggestedEntity {
    return new SuggestedEntity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuggestedEntity {
    return new SuggestedEntity().fromJsonString(jsonString, options);
  }

  static equals(a: SuggestedEntity | PlainMessage<SuggestedEntity> | undefined, b: SuggestedEntity | PlainMessage<SuggestedEntity> | undefined): boolean {
    return proto3.util.equals(SuggestedEntity, a, b);
  }
}

/**
 * @generated from message bsky.GetSuggestedEntitiesRequest
 */
export class GetSuggestedEntitiesRequest extends Message<GetSuggestedEntitiesRequest> {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetSuggestedEntitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSuggestedEntitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedEntitiesRequest {
    return new GetSuggestedEntitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedEntitiesRequest {
    return new GetSuggestedEntitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedEntitiesRequest {
    return new GetSuggestedEntitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedEntitiesRequest | PlainMessage<GetSuggestedEntitiesRequest> | undefined, b: GetSuggestedEntitiesRequest | PlainMessage<GetSuggestedEntitiesRequest> | undefined): boolean {
    return proto3.util.equals(GetSuggestedEntitiesRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSuggestedEntitiesResponse
 */
export class GetSuggestedEntitiesResponse extends Message<GetSuggestedEntitiesResponse> {
  /**
   * @generated from field: repeated bsky.SuggestedEntity entities = 1;
   */
  entities: SuggestedEntity[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetSuggestedEntitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSuggestedEntitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entities", kind: "message", T: SuggestedEntity, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedEntitiesResponse {
    return new GetSuggestedEntitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedEntitiesResponse {
    return new GetSuggestedEntitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedEntitiesResponse {
    return new GetSuggestedEntitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedEntitiesResponse | PlainMessage<GetSuggestedEntitiesResponse> | undefined, b: GetSuggestedEntitiesResponse | PlainMessage<GetSuggestedEntitiesResponse> | undefined): boolean {
    return proto3.util.equals(GetSuggestedEntitiesResponse, a, b);
  }
}

/**
 * - Get all labels on a subjects A, B, C (uri or did) issued by dids D, E, F…
 *     - label hydration on nearly every view
 *
 * @generated from message bsky.GetLabelsRequest
 */
export class GetLabelsRequest extends Message<GetLabelsRequest> {
  /**
   * @generated from field: repeated string subjects = 1;
   */
  subjects: string[] = [];

  /**
   * @generated from field: repeated string issuers = 2;
   */
  issuers: string[] = [];

  constructor(data?: PartialMessage<GetLabelsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLabelsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subjects", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "issuers", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLabelsRequest {
    return new GetLabelsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLabelsRequest {
    return new GetLabelsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLabelsRequest {
    return new GetLabelsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLabelsRequest | PlainMessage<GetLabelsRequest> | undefined, b: GetLabelsRequest | PlainMessage<GetLabelsRequest> | undefined): boolean {
    return proto3.util.equals(GetLabelsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLabelsResponse
 */
export class GetLabelsResponse extends Message<GetLabelsResponse> {
  /**
   * @generated from field: repeated bytes labels = 1;
   */
  labels: Uint8Array[] = [];

  constructor(data?: PartialMessage<GetLabelsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLabelsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "labels", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLabelsResponse {
    return new GetLabelsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLabelsResponse {
    return new GetLabelsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLabelsResponse {
    return new GetLabelsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLabelsResponse | PlainMessage<GetLabelsResponse> | undefined, b: GetLabelsResponse | PlainMessage<GetLabelsResponse> | undefined): boolean {
    return proto3.util.equals(GetLabelsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActorStarterPacksRequest
 */
export class GetActorStarterPacksRequest extends Message<GetActorStarterPacksRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorStarterPacksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorStarterPacksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorStarterPacksRequest {
    return new GetActorStarterPacksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorStarterPacksRequest {
    return new GetActorStarterPacksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorStarterPacksRequest {
    return new GetActorStarterPacksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorStarterPacksRequest | PlainMessage<GetActorStarterPacksRequest> | undefined, b: GetActorStarterPacksRequest | PlainMessage<GetActorStarterPacksRequest> | undefined): boolean {
    return proto3.util.equals(GetActorStarterPacksRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorStarterPacksResponse
 */
export class GetActorStarterPacksResponse extends Message<GetActorStarterPacksResponse> {
  /**
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorStarterPacksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorStarterPacksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorStarterPacksResponse {
    return new GetActorStarterPacksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorStarterPacksResponse {
    return new GetActorStarterPacksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorStarterPacksResponse {
    return new GetActorStarterPacksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorStarterPacksResponse | PlainMessage<GetActorStarterPacksResponse> | undefined, b: GetActorStarterPacksResponse | PlainMessage<GetActorStarterPacksResponse> | undefined): boolean {
    return proto3.util.equals(GetActorStarterPacksResponse, a, b);
  }
}

/**
 * - Latest repo rev of user w/ DID
 *     - Read-after-write header in`getProfile`, `getProfiles`, `getActorLikes`, `getAuthorFeed`, `getListFeed`, `getPostThread`, `getTimeline`.  Could it be view dependent?
 *
 * @generated from message bsky.GetLatestRevRequest
 */
export class GetLatestRevRequest extends Message<GetLatestRevRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  constructor(data?: PartialMessage<GetLatestRevRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLatestRevRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestRevRequest {
    return new GetLatestRevRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestRevRequest {
    return new GetLatestRevRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestRevRequest {
    return new GetLatestRevRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestRevRequest | PlainMessage<GetLatestRevRequest> | undefined, b: GetLatestRevRequest | PlainMessage<GetLatestRevRequest> | undefined): boolean {
    return proto3.util.equals(GetLatestRevRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetLatestRevResponse
 */
export class GetLatestRevResponse extends Message<GetLatestRevResponse> {
  /**
   * @generated from field: string rev = 1;
   */
  rev = "";

  constructor(data?: PartialMessage<GetLatestRevResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetLatestRevResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rev", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLatestRevResponse {
    return new GetLatestRevResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLatestRevResponse {
    return new GetLatestRevResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLatestRevResponse {
    return new GetLatestRevResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLatestRevResponse | PlainMessage<GetLatestRevResponse> | undefined, b: GetLatestRevResponse | PlainMessage<GetLatestRevResponse> | undefined): boolean {
    return proto3.util.equals(GetLatestRevResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetIdentityByDidRequest
 */
export class GetIdentityByDidRequest extends Message<GetIdentityByDidRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  constructor(data?: PartialMessage<GetIdentityByDidRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetIdentityByDidRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityByDidRequest {
    return new GetIdentityByDidRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityByDidRequest {
    return new GetIdentityByDidRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityByDidRequest {
    return new GetIdentityByDidRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityByDidRequest | PlainMessage<GetIdentityByDidRequest> | undefined, b: GetIdentityByDidRequest | PlainMessage<GetIdentityByDidRequest> | undefined): boolean {
    return proto3.util.equals(GetIdentityByDidRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetIdentityByDidResponse
 */
export class GetIdentityByDidResponse extends Message<GetIdentityByDidResponse> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: string handle = 2;
   */
  handle = "";

  /**
   * @generated from field: bytes keys = 3;
   */
  keys = new Uint8Array(0);

  /**
   * @generated from field: bytes services = 4;
   */
  services = new Uint8Array(0);

  /**
   * @generated from field: google.protobuf.Timestamp updated = 5;
   */
  updated?: Timestamp;

  constructor(data?: PartialMessage<GetIdentityByDidResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetIdentityByDidResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "keys", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "services", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "updated", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityByDidResponse {
    return new GetIdentityByDidResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityByDidResponse {
    return new GetIdentityByDidResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityByDidResponse {
    return new GetIdentityByDidResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityByDidResponse | PlainMessage<GetIdentityByDidResponse> | undefined, b: GetIdentityByDidResponse | PlainMessage<GetIdentityByDidResponse> | undefined): boolean {
    return proto3.util.equals(GetIdentityByDidResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetIdentityByHandleRequest
 */
export class GetIdentityByHandleRequest extends Message<GetIdentityByHandleRequest> {
  /**
   * @generated from field: string handle = 1;
   */
  handle = "";

  constructor(data?: PartialMessage<GetIdentityByHandleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetIdentityByHandleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityByHandleRequest {
    return new GetIdentityByHandleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityByHandleRequest {
    return new GetIdentityByHandleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityByHandleRequest {
    return new GetIdentityByHandleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityByHandleRequest | PlainMessage<GetIdentityByHandleRequest> | undefined, b: GetIdentityByHandleRequest | PlainMessage<GetIdentityByHandleRequest> | undefined): boolean {
    return proto3.util.equals(GetIdentityByHandleRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetIdentityByHandleResponse
 */
export class GetIdentityByHandleResponse extends Message<GetIdentityByHandleResponse> {
  /**
   * @generated from field: string handle = 1;
   */
  handle = "";

  /**
   * @generated from field: string did = 2;
   */
  did = "";

  /**
   * @generated from field: bytes keys = 3;
   */
  keys = new Uint8Array(0);

  /**
   * @generated from field: bytes services = 4;
   */
  services = new Uint8Array(0);

  /**
   * @generated from field: google.protobuf.Timestamp updated = 5;
   */
  updated?: Timestamp;

  constructor(data?: PartialMessage<GetIdentityByHandleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetIdentityByHandleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "handle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "keys", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "services", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "updated", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetIdentityByHandleResponse {
    return new GetIdentityByHandleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetIdentityByHandleResponse {
    return new GetIdentityByHandleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetIdentityByHandleResponse {
    return new GetIdentityByHandleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetIdentityByHandleResponse | PlainMessage<GetIdentityByHandleResponse> | undefined, b: GetIdentityByHandleResponse | PlainMessage<GetIdentityByHandleResponse> | undefined): boolean {
    return proto3.util.equals(GetIdentityByHandleResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetBlobTakedownRequest
 */
export class GetBlobTakedownRequest extends Message<GetBlobTakedownRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  constructor(data?: PartialMessage<GetBlobTakedownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlobTakedownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlobTakedownRequest {
    return new GetBlobTakedownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlobTakedownRequest {
    return new GetBlobTakedownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlobTakedownRequest {
    return new GetBlobTakedownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlobTakedownRequest | PlainMessage<GetBlobTakedownRequest> | undefined, b: GetBlobTakedownRequest | PlainMessage<GetBlobTakedownRequest> | undefined): boolean {
    return proto3.util.equals(GetBlobTakedownRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBlobTakedownResponse
 */
export class GetBlobTakedownResponse extends Message<GetBlobTakedownResponse> {
  /**
   * @generated from field: bool taken_down = 1;
   */
  takenDown = false;

  /**
   * @generated from field: string takedown_ref = 2;
   */
  takedownRef = "";

  constructor(data?: PartialMessage<GetBlobTakedownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBlobTakedownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taken_down", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "takedown_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBlobTakedownResponse {
    return new GetBlobTakedownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBlobTakedownResponse {
    return new GetBlobTakedownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBlobTakedownResponse {
    return new GetBlobTakedownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBlobTakedownResponse | PlainMessage<GetBlobTakedownResponse> | undefined, b: GetBlobTakedownResponse | PlainMessage<GetBlobTakedownResponse> | undefined): boolean {
    return proto3.util.equals(GetBlobTakedownResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActorTakedownRequest
 */
export class GetActorTakedownRequest extends Message<GetActorTakedownRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  constructor(data?: PartialMessage<GetActorTakedownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorTakedownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorTakedownRequest {
    return new GetActorTakedownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorTakedownRequest {
    return new GetActorTakedownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorTakedownRequest {
    return new GetActorTakedownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorTakedownRequest | PlainMessage<GetActorTakedownRequest> | undefined, b: GetActorTakedownRequest | PlainMessage<GetActorTakedownRequest> | undefined): boolean {
    return proto3.util.equals(GetActorTakedownRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetActorTakedownResponse
 */
export class GetActorTakedownResponse extends Message<GetActorTakedownResponse> {
  /**
   * @generated from field: bool taken_down = 1;
   */
  takenDown = false;

  /**
   * @generated from field: string takedown_ref = 2;
   */
  takedownRef = "";

  constructor(data?: PartialMessage<GetActorTakedownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorTakedownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taken_down", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "takedown_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorTakedownResponse {
    return new GetActorTakedownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorTakedownResponse {
    return new GetActorTakedownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorTakedownResponse {
    return new GetActorTakedownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorTakedownResponse | PlainMessage<GetActorTakedownResponse> | undefined, b: GetActorTakedownResponse | PlainMessage<GetActorTakedownResponse> | undefined): boolean {
    return proto3.util.equals(GetActorTakedownResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetRecordTakedownRequest
 */
export class GetRecordTakedownRequest extends Message<GetRecordTakedownRequest> {
  /**
   * @generated from field: string record_uri = 1;
   */
  recordUri = "";

  constructor(data?: PartialMessage<GetRecordTakedownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRecordTakedownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "record_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRecordTakedownRequest {
    return new GetRecordTakedownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRecordTakedownRequest {
    return new GetRecordTakedownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRecordTakedownRequest {
    return new GetRecordTakedownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRecordTakedownRequest | PlainMessage<GetRecordTakedownRequest> | undefined, b: GetRecordTakedownRequest | PlainMessage<GetRecordTakedownRequest> | undefined): boolean {
    return proto3.util.equals(GetRecordTakedownRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetRecordTakedownResponse
 */
export class GetRecordTakedownResponse extends Message<GetRecordTakedownResponse> {
  /**
   * @generated from field: bool taken_down = 1;
   */
  takenDown = false;

  /**
   * @generated from field: string takedown_ref = 2;
   */
  takedownRef = "";

  constructor(data?: PartialMessage<GetRecordTakedownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetRecordTakedownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taken_down", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "takedown_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRecordTakedownResponse {
    return new GetRecordTakedownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRecordTakedownResponse {
    return new GetRecordTakedownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRecordTakedownResponse {
    return new GetRecordTakedownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetRecordTakedownResponse | PlainMessage<GetRecordTakedownResponse> | undefined, b: GetRecordTakedownResponse | PlainMessage<GetRecordTakedownResponse> | undefined): boolean {
    return proto3.util.equals(GetRecordTakedownResponse, a, b);
  }
}

/**
 *
 * Bookmarks
 *
 *
 * @generated from message bsky.Bookmark
 */
export class Bookmark extends Message<Bookmark> {
  /**
   * @generated from field: bsky.StashRef ref = 1;
   */
  ref?: StashRef;

  /**
   * @generated from field: string subject_uri = 2;
   */
  subjectUri = "";

  /**
   * @generated from field: string subject_cid = 3;
   */
  subjectCid = "";

  /**
   * @generated from field: google.protobuf.Timestamp indexed_at = 4;
   */
  indexedAt?: Timestamp;

  constructor(data?: PartialMessage<Bookmark>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.Bookmark";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "message", T: StashRef },
    { no: 2, name: "subject_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject_cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "indexed_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Bookmark {
    return new Bookmark().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Bookmark {
    return new Bookmark().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Bookmark {
    return new Bookmark().fromJsonString(jsonString, options);
  }

  static equals(a: Bookmark | PlainMessage<Bookmark> | undefined, b: Bookmark | PlainMessage<Bookmark> | undefined): boolean {
    return proto3.util.equals(Bookmark, a, b);
  }
}

/**
 * @generated from message bsky.GetBookmarksByActorAndSubjectsRequest
 */
export class GetBookmarksByActorAndSubjectsRequest extends Message<GetBookmarksByActorAndSubjectsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string uris = 2;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetBookmarksByActorAndSubjectsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBookmarksByActorAndSubjectsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBookmarksByActorAndSubjectsRequest {
    return new GetBookmarksByActorAndSubjectsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBookmarksByActorAndSubjectsRequest {
    return new GetBookmarksByActorAndSubjectsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBookmarksByActorAndSubjectsRequest {
    return new GetBookmarksByActorAndSubjectsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBookmarksByActorAndSubjectsRequest | PlainMessage<GetBookmarksByActorAndSubjectsRequest> | undefined, b: GetBookmarksByActorAndSubjectsRequest | PlainMessage<GetBookmarksByActorAndSubjectsRequest> | undefined): boolean {
    return proto3.util.equals(GetBookmarksByActorAndSubjectsRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetBookmarksByActorAndSubjectsResponse
 */
export class GetBookmarksByActorAndSubjectsResponse extends Message<GetBookmarksByActorAndSubjectsResponse> {
  /**
   * @generated from field: repeated bsky.Bookmark bookmarks = 1;
   */
  bookmarks: Bookmark[] = [];

  constructor(data?: PartialMessage<GetBookmarksByActorAndSubjectsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetBookmarksByActorAndSubjectsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bookmarks", kind: "message", T: Bookmark, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBookmarksByActorAndSubjectsResponse {
    return new GetBookmarksByActorAndSubjectsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBookmarksByActorAndSubjectsResponse {
    return new GetBookmarksByActorAndSubjectsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBookmarksByActorAndSubjectsResponse {
    return new GetBookmarksByActorAndSubjectsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBookmarksByActorAndSubjectsResponse | PlainMessage<GetBookmarksByActorAndSubjectsResponse> | undefined, b: GetBookmarksByActorAndSubjectsResponse | PlainMessage<GetBookmarksByActorAndSubjectsResponse> | undefined): boolean {
    return proto3.util.equals(GetBookmarksByActorAndSubjectsResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActorBookmarksRequest
 */
export class GetActorBookmarksRequest extends Message<GetActorBookmarksRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorBookmarksRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorBookmarksRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorBookmarksRequest {
    return new GetActorBookmarksRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorBookmarksRequest {
    return new GetActorBookmarksRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorBookmarksRequest {
    return new GetActorBookmarksRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorBookmarksRequest | PlainMessage<GetActorBookmarksRequest> | undefined, b: GetActorBookmarksRequest | PlainMessage<GetActorBookmarksRequest> | undefined): boolean {
    return proto3.util.equals(GetActorBookmarksRequest, a, b);
  }
}

/**
 * @generated from message bsky.BookmarkInfo
 */
export class BookmarkInfo extends Message<BookmarkInfo> {
  /**
   * stash key
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string subject = 2;
   */
  subject = "";

  constructor(data?: PartialMessage<BookmarkInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.BookmarkInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BookmarkInfo {
    return new BookmarkInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BookmarkInfo {
    return new BookmarkInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BookmarkInfo {
    return new BookmarkInfo().fromJsonString(jsonString, options);
  }

  static equals(a: BookmarkInfo | PlainMessage<BookmarkInfo> | undefined, b: BookmarkInfo | PlainMessage<BookmarkInfo> | undefined): boolean {
    return proto3.util.equals(BookmarkInfo, a, b);
  }
}

/**
 * @generated from message bsky.GetActorBookmarksResponse
 */
export class GetActorBookmarksResponse extends Message<GetActorBookmarksResponse> {
  /**
   * @generated from field: repeated bsky.BookmarkInfo bookmarks = 1;
   */
  bookmarks: BookmarkInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorBookmarksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorBookmarksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bookmarks", kind: "message", T: BookmarkInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorBookmarksResponse {
    return new GetActorBookmarksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorBookmarksResponse {
    return new GetActorBookmarksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorBookmarksResponse {
    return new GetActorBookmarksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorBookmarksResponse | PlainMessage<GetActorBookmarksResponse> | undefined, b: GetActorBookmarksResponse | PlainMessage<GetActorBookmarksResponse> | undefined): boolean {
    return proto3.util.equals(GetActorBookmarksResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetActorDraftsRequest
 */
export class GetActorDraftsRequest extends Message<GetActorDraftsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorDraftsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorDraftsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorDraftsRequest {
    return new GetActorDraftsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorDraftsRequest {
    return new GetActorDraftsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorDraftsRequest {
    return new GetActorDraftsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorDraftsRequest | PlainMessage<GetActorDraftsRequest> | undefined, b: GetActorDraftsRequest | PlainMessage<GetActorDraftsRequest> | undefined): boolean {
    return proto3.util.equals(GetActorDraftsRequest, a, b);
  }
}

/**
 * @generated from message bsky.DraftInfo
 */
export class DraftInfo extends Message<DraftInfo> {
  /**
   * stash key
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: bytes payload = 4;
   */
  payload = new Uint8Array(0);

  constructor(data?: PartialMessage<DraftInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DraftInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "message", T: Timestamp },
    { no: 3, name: "updated_at", kind: "message", T: Timestamp },
    { no: 4, name: "payload", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DraftInfo {
    return new DraftInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DraftInfo {
    return new DraftInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DraftInfo {
    return new DraftInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DraftInfo | PlainMessage<DraftInfo> | undefined, b: DraftInfo | PlainMessage<DraftInfo> | undefined): boolean {
    return proto3.util.equals(DraftInfo, a, b);
  }
}

/**
 * @generated from message bsky.GetActorDraftsResponse
 */
export class GetActorDraftsResponse extends Message<GetActorDraftsResponse> {
  /**
   * @generated from field: repeated bsky.DraftInfo drafts = 1;
   */
  drafts: DraftInfo[] = [];

  /**
   * @generated from field: string cursor = 2;
   */
  cursor = "";

  constructor(data?: PartialMessage<GetActorDraftsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetActorDraftsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "drafts", kind: "message", T: DraftInfo, repeated: true },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActorDraftsResponse {
    return new GetActorDraftsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActorDraftsResponse {
    return new GetActorDraftsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActorDraftsResponse {
    return new GetActorDraftsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActorDraftsResponse | PlainMessage<GetActorDraftsResponse> | undefined, b: GetActorDraftsResponse | PlainMessage<GetActorDraftsResponse> | undefined): boolean {
    return proto3.util.equals(GetActorDraftsResponse, a, b);
  }
}

/**
 * GetFollowsFollowing gets the list of DIDs that the actor follows that also follow the targets
 *
 * @generated from message bsky.GetFollowsFollowingRequest
 */
export class GetFollowsFollowingRequest extends Message<GetFollowsFollowingRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: repeated string target_dids = 2;
   */
  targetDids: string[] = [];

  constructor(data?: PartialMessage<GetFollowsFollowingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowsFollowingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowsFollowingRequest {
    return new GetFollowsFollowingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowsFollowingRequest {
    return new GetFollowsFollowingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowsFollowingRequest {
    return new GetFollowsFollowingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowsFollowingRequest | PlainMessage<GetFollowsFollowingRequest> | undefined, b: GetFollowsFollowingRequest | PlainMessage<GetFollowsFollowingRequest> | undefined): boolean {
    return proto3.util.equals(GetFollowsFollowingRequest, a, b);
  }
}

/**
 * @generated from message bsky.FollowsFollowing
 */
export class FollowsFollowing extends Message<FollowsFollowing> {
  /**
   * @generated from field: string target_did = 1;
   */
  targetDid = "";

  /**
   * @generated from field: repeated string dids = 2;
   */
  dids: string[] = [];

  constructor(data?: PartialMessage<FollowsFollowing>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.FollowsFollowing";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "target_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FollowsFollowing {
    return new FollowsFollowing().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FollowsFollowing {
    return new FollowsFollowing().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FollowsFollowing {
    return new FollowsFollowing().fromJsonString(jsonString, options);
  }

  static equals(a: FollowsFollowing | PlainMessage<FollowsFollowing> | undefined, b: FollowsFollowing | PlainMessage<FollowsFollowing> | undefined): boolean {
    return proto3.util.equals(FollowsFollowing, a, b);
  }
}

/**
 * @generated from message bsky.GetFollowsFollowingResponse
 */
export class GetFollowsFollowingResponse extends Message<GetFollowsFollowingResponse> {
  /**
   * @generated from field: repeated bsky.FollowsFollowing results = 1;
   */
  results: FollowsFollowing[] = [];

  constructor(data?: PartialMessage<GetFollowsFollowingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetFollowsFollowingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: FollowsFollowing, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFollowsFollowingResponse {
    return new GetFollowsFollowingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFollowsFollowingResponse {
    return new GetFollowsFollowingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFollowsFollowingResponse {
    return new GetFollowsFollowingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFollowsFollowingResponse | PlainMessage<GetFollowsFollowingResponse> | undefined, b: GetFollowsFollowingResponse | PlainMessage<GetFollowsFollowingResponse> | undefined): boolean {
    return proto3.util.equals(GetFollowsFollowingResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetSitemapIndexRequest
 */
export class GetSitemapIndexRequest extends Message<GetSitemapIndexRequest> {
  /**
   * @generated from field: bsky.SitemapPageType type = 1;
   */
  type = SitemapPageType.UNSPECIFIED;

  constructor(data?: PartialMessage<GetSitemapIndexRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSitemapIndexRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SitemapPageType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSitemapIndexRequest {
    return new GetSitemapIndexRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSitemapIndexRequest {
    return new GetSitemapIndexRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSitemapIndexRequest {
    return new GetSitemapIndexRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSitemapIndexRequest | PlainMessage<GetSitemapIndexRequest> | undefined, b: GetSitemapIndexRequest | PlainMessage<GetSitemapIndexRequest> | undefined): boolean {
    return proto3.util.equals(GetSitemapIndexRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSitemapIndexResponse
 */
export class GetSitemapIndexResponse extends Message<GetSitemapIndexResponse> {
  /**
   * GZIP compressed XML sitemap
   *
   * @generated from field: bytes sitemap = 1;
   */
  sitemap = new Uint8Array(0);

  constructor(data?: PartialMessage<GetSitemapIndexResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSitemapIndexResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sitemap", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSitemapIndexResponse {
    return new GetSitemapIndexResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSitemapIndexResponse {
    return new GetSitemapIndexResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSitemapIndexResponse {
    return new GetSitemapIndexResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSitemapIndexResponse | PlainMessage<GetSitemapIndexResponse> | undefined, b: GetSitemapIndexResponse | PlainMessage<GetSitemapIndexResponse> | undefined): boolean {
    return proto3.util.equals(GetSitemapIndexResponse, a, b);
  }
}

/**
 * Sitemap HTTP paths are typically of the form `/type/yyyy-mm-dd/N.xml.gz`, i.e. `/users/2025-01-01/1.xml.gz`
 *
 * @generated from message bsky.GetSitemapPageRequest
 */
export class GetSitemapPageRequest extends Message<GetSitemapPageRequest> {
  /**
   * @generated from field: bsky.SitemapPageType type = 1;
   */
  type = SitemapPageType.UNSPECIFIED;

  /**
   * @generated from field: google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp;

  /**
   * One-indexed
   *
   * @generated from field: int32 bucket = 3;
   */
  bucket = 0;

  constructor(data?: PartialMessage<GetSitemapPageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSitemapPageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(SitemapPageType) },
    { no: 2, name: "date", kind: "message", T: Timestamp },
    { no: 3, name: "bucket", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSitemapPageRequest {
    return new GetSitemapPageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSitemapPageRequest {
    return new GetSitemapPageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSitemapPageRequest {
    return new GetSitemapPageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSitemapPageRequest | PlainMessage<GetSitemapPageRequest> | undefined, b: GetSitemapPageRequest | PlainMessage<GetSitemapPageRequest> | undefined): boolean {
    return proto3.util.equals(GetSitemapPageRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSitemapPageResponse
 */
export class GetSitemapPageResponse extends Message<GetSitemapPageResponse> {
  /**
   * GZIP compressed XML sitemap
   *
   * @generated from field: bytes sitemap = 1;
   */
  sitemap = new Uint8Array(0);

  constructor(data?: PartialMessage<GetSitemapPageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSitemapPageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sitemap", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSitemapPageResponse {
    return new GetSitemapPageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSitemapPageResponse {
    return new GetSitemapPageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSitemapPageResponse {
    return new GetSitemapPageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSitemapPageResponse | PlainMessage<GetSitemapPageResponse> | undefined, b: GetSitemapPageResponse | PlainMessage<GetSitemapPageResponse> | undefined): boolean {
    return proto3.util.equals(GetSitemapPageResponse, a, b);
  }
}

/**
 * Ping
 *
 * @generated from message bsky.PingRequest
 */
export class PingRequest extends Message<PingRequest> {
  constructor(data?: PartialMessage<PingRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PingRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PingRequest {
    return new PingRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PingRequest {
    return new PingRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PingRequest {
    return new PingRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PingRequest | PlainMessage<PingRequest> | undefined, b: PingRequest | PlainMessage<PingRequest> | undefined): boolean {
    return proto3.util.equals(PingRequest, a, b);
  }
}

/**
 * @generated from message bsky.PingResponse
 */
export class PingResponse extends Message<PingResponse> {
  constructor(data?: PartialMessage<PingResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.PingResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PingResponse {
    return new PingResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PingResponse {
    return new PingResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PingResponse {
    return new PingResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PingResponse | PlainMessage<PingResponse> | undefined, b: PingResponse | PlainMessage<PingResponse> | undefined): boolean {
    return proto3.util.equals(PingResponse, a, b);
  }
}

/**
 * @generated from message bsky.StashRef
 */
export class StashRef extends Message<StashRef> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string namespace = 2;
   */
  namespace = "";

  /**
   * @generated from field: string key = 3;
   */
  key = "";

  constructor(data?: PartialMessage<StashRef>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.StashRef";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "namespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StashRef {
    return new StashRef().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StashRef {
    return new StashRef().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StashRef {
    return new StashRef().fromJsonString(jsonString, options);
  }

  static equals(a: StashRef | PlainMessage<StashRef> | undefined, b: StashRef | PlainMessage<StashRef> | undefined): boolean {
    return proto3.util.equals(StashRef, a, b);
  }
}

/**
 * Standard.site records
 *
 * @generated from message bsky.GetSiteStandardRecordsByURIRequest
 */
export class GetSiteStandardRecordsByURIRequest extends Message<GetSiteStandardRecordsByURIRequest> {
  /**
   * Mixed list of site.standard.document and site.standard.publication AT-URIs.
   * URIs of other collections (or unparseable strings) are silently skipped.
   *
   * @generated from field: repeated string uris = 1;
   */
  uris: string[] = [];

  constructor(data?: PartialMessage<GetSiteStandardRecordsByURIRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSiteStandardRecordsByURIRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "uris", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSiteStandardRecordsByURIRequest {
    return new GetSiteStandardRecordsByURIRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByURIRequest {
    return new GetSiteStandardRecordsByURIRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByURIRequest {
    return new GetSiteStandardRecordsByURIRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSiteStandardRecordsByURIRequest | PlainMessage<GetSiteStandardRecordsByURIRequest> | undefined, b: GetSiteStandardRecordsByURIRequest | PlainMessage<GetSiteStandardRecordsByURIRequest> | undefined): boolean {
    return proto3.util.equals(GetSiteStandardRecordsByURIRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSiteStandardRecordsByURIResponse
 */
export class GetSiteStandardRecordsByURIResponse extends Message<GetSiteStandardRecordsByURIResponse> {
  /**
   * Latest indexed version of each requested document.
   *
   * @generated from field: repeated bsky.SiteStandardRecord documents = 1;
   */
  documents: SiteStandardRecord[] = [];

  /**
   * Latest indexed version of each requested publication AND each publication
   * resolved from a document's `site` field. Each publication appears at most
   * once across the two sources.
   *
   * @generated from field: repeated bsky.SiteStandardRecord publications = 2;
   */
  publications: SiteStandardRecord[] = [];

  constructor(data?: PartialMessage<GetSiteStandardRecordsByURIResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSiteStandardRecordsByURIResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: SiteStandardRecord, repeated: true },
    { no: 2, name: "publications", kind: "message", T: SiteStandardRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSiteStandardRecordsByURIResponse {
    return new GetSiteStandardRecordsByURIResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByURIResponse {
    return new GetSiteStandardRecordsByURIResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByURIResponse {
    return new GetSiteStandardRecordsByURIResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSiteStandardRecordsByURIResponse | PlainMessage<GetSiteStandardRecordsByURIResponse> | undefined, b: GetSiteStandardRecordsByURIResponse | PlainMessage<GetSiteStandardRecordsByURIResponse> | undefined): boolean {
    return proto3.util.equals(GetSiteStandardRecordsByURIResponse, a, b);
  }
}

/**
 * @generated from message bsky.GetSiteStandardRecordsByRefRequest
 */
export class GetSiteStandardRecordsByRefRequest extends Message<GetSiteStandardRecordsByRefRequest> {
  /**
   * Mixed list of site.standard.document and site.standard.publication refs
   * (uri + cid). Refs whose URI is not a SiteStandard collection (or doesn't
   * parse) are silently skipped.
   *
   * @generated from field: repeated bsky.RecordRef refs = 1;
   */
  refs: RecordRef[] = [];

  constructor(data?: PartialMessage<GetSiteStandardRecordsByRefRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSiteStandardRecordsByRefRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "refs", kind: "message", T: RecordRef, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSiteStandardRecordsByRefRequest {
    return new GetSiteStandardRecordsByRefRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByRefRequest {
    return new GetSiteStandardRecordsByRefRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByRefRequest {
    return new GetSiteStandardRecordsByRefRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSiteStandardRecordsByRefRequest | PlainMessage<GetSiteStandardRecordsByRefRequest> | undefined, b: GetSiteStandardRecordsByRefRequest | PlainMessage<GetSiteStandardRecordsByRefRequest> | undefined): boolean {
    return proto3.util.equals(GetSiteStandardRecordsByRefRequest, a, b);
  }
}

/**
 * @generated from message bsky.GetSiteStandardRecordsByRefResponse
 */
export class GetSiteStandardRecordsByRefResponse extends Message<GetSiteStandardRecordsByRefResponse> {
  /**
   * Document version exactly matching each requested doc ref.
   *
   * @generated from field: repeated bsky.SiteStandardRecord documents = 1;
   */
  documents: SiteStandardRecord[] = [];

  /**
   * Publication version exactly matching each requested pub ref. This RPC
   * does NOT auto-resolve publications referenced by documents — callers who
   * want a paired publication should pass its ref explicitly.
   *
   * @generated from field: repeated bsky.SiteStandardRecord publications = 2;
   */
  publications: SiteStandardRecord[] = [];

  constructor(data?: PartialMessage<GetSiteStandardRecordsByRefResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.GetSiteStandardRecordsByRefResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "message", T: SiteStandardRecord, repeated: true },
    { no: 2, name: "publications", kind: "message", T: SiteStandardRecord, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSiteStandardRecordsByRefResponse {
    return new GetSiteStandardRecordsByRefResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByRefResponse {
    return new GetSiteStandardRecordsByRefResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSiteStandardRecordsByRefResponse {
    return new GetSiteStandardRecordsByRefResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSiteStandardRecordsByRefResponse | PlainMessage<GetSiteStandardRecordsByRefResponse> | undefined, b: GetSiteStandardRecordsByRefResponse | PlainMessage<GetSiteStandardRecordsByRefResponse> | undefined): boolean {
    return proto3.util.equals(GetSiteStandardRecordsByRefResponse, a, b);
  }
}

/**
 * SiteStandardRecord pairs a record with its addressing ref so callers can
 * build a uri- or (uri,cid)-keyed lookup without server-side encoding.
 *
 * @generated from message bsky.SiteStandardRecord
 */
export class SiteStandardRecord extends Message<SiteStandardRecord> {
  /**
   * @generated from field: bsky.RecordRef ref = 1;
   */
  ref?: RecordRef;

  /**
   * @generated from field: bsky.Record record = 2;
   */
  record?: Record;

  constructor(data?: PartialMessage<SiteStandardRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.SiteStandardRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "message", T: RecordRef },
    { no: 2, name: "record", kind: "message", T: Record },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SiteStandardRecord {
    return new SiteStandardRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SiteStandardRecord {
    return new SiteStandardRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SiteStandardRecord {
    return new SiteStandardRecord().fromJsonString(jsonString, options);
  }

  static equals(a: SiteStandardRecord | PlainMessage<SiteStandardRecord> | undefined, b: SiteStandardRecord | PlainMessage<SiteStandardRecord> | undefined): boolean {
    return proto3.util.equals(SiteStandardRecord, a, b);
  }
}

/**
 * @generated from message bsky.UpdateActorUpstreamStatusRequest
 */
export class UpdateActorUpstreamStatusRequest extends Message<UpdateActorUpstreamStatusRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: bool active = 2;
   */
  active = false;

  /**
   * @generated from field: string upstream_status = 3;
   */
  upstreamStatus = "";

  constructor(data?: PartialMessage<UpdateActorUpstreamStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UpdateActorUpstreamStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "upstream_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateActorUpstreamStatusRequest {
    return new UpdateActorUpstreamStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateActorUpstreamStatusRequest {
    return new UpdateActorUpstreamStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateActorUpstreamStatusRequest {
    return new UpdateActorUpstreamStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateActorUpstreamStatusRequest | PlainMessage<UpdateActorUpstreamStatusRequest> | undefined, b: UpdateActorUpstreamStatusRequest | PlainMessage<UpdateActorUpstreamStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateActorUpstreamStatusRequest, a, b);
  }
}

/**
 * @generated from message bsky.UpdateActorUpstreamStatusResponse
 */
export class UpdateActorUpstreamStatusResponse extends Message<UpdateActorUpstreamStatusResponse> {
  constructor(data?: PartialMessage<UpdateActorUpstreamStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UpdateActorUpstreamStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateActorUpstreamStatusResponse {
    return new UpdateActorUpstreamStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateActorUpstreamStatusResponse {
    return new UpdateActorUpstreamStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateActorUpstreamStatusResponse {
    return new UpdateActorUpstreamStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateActorUpstreamStatusResponse | PlainMessage<UpdateActorUpstreamStatusResponse> | undefined, b: UpdateActorUpstreamStatusResponse | PlainMessage<UpdateActorUpstreamStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateActorUpstreamStatusResponse, a, b);
  }
}

/**
 * @generated from message bsky.TakedownActorRequest
 */
export class TakedownActorRequest extends Message<TakedownActorRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: string ref = 2;
   */
  ref = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 3;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<TakedownActorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownActorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownActorRequest {
    return new TakedownActorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownActorRequest {
    return new TakedownActorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownActorRequest {
    return new TakedownActorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownActorRequest | PlainMessage<TakedownActorRequest> | undefined, b: TakedownActorRequest | PlainMessage<TakedownActorRequest> | undefined): boolean {
    return proto3.util.equals(TakedownActorRequest, a, b);
  }
}

/**
 * @generated from message bsky.TakedownActorResponse
 */
export class TakedownActorResponse extends Message<TakedownActorResponse> {
  constructor(data?: PartialMessage<TakedownActorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownActorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownActorResponse {
    return new TakedownActorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownActorResponse {
    return new TakedownActorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownActorResponse {
    return new TakedownActorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownActorResponse | PlainMessage<TakedownActorResponse> | undefined, b: TakedownActorResponse | PlainMessage<TakedownActorResponse> | undefined): boolean {
    return proto3.util.equals(TakedownActorResponse, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownActorRequest
 */
export class UntakedownActorRequest extends Message<UntakedownActorRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 2;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<UntakedownActorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownActorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownActorRequest {
    return new UntakedownActorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownActorRequest {
    return new UntakedownActorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownActorRequest {
    return new UntakedownActorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownActorRequest | PlainMessage<UntakedownActorRequest> | undefined, b: UntakedownActorRequest | PlainMessage<UntakedownActorRequest> | undefined): boolean {
    return proto3.util.equals(UntakedownActorRequest, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownActorResponse
 */
export class UntakedownActorResponse extends Message<UntakedownActorResponse> {
  constructor(data?: PartialMessage<UntakedownActorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownActorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownActorResponse {
    return new UntakedownActorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownActorResponse {
    return new UntakedownActorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownActorResponse {
    return new UntakedownActorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownActorResponse | PlainMessage<UntakedownActorResponse> | undefined, b: UntakedownActorResponse | PlainMessage<UntakedownActorResponse> | undefined): boolean {
    return proto3.util.equals(UntakedownActorResponse, a, b);
  }
}

/**
 * @generated from message bsky.TakedownBlobRequest
 */
export class TakedownBlobRequest extends Message<TakedownBlobRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  /**
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 4;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<TakedownBlobRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownBlobRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownBlobRequest {
    return new TakedownBlobRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownBlobRequest {
    return new TakedownBlobRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownBlobRequest {
    return new TakedownBlobRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownBlobRequest | PlainMessage<TakedownBlobRequest> | undefined, b: TakedownBlobRequest | PlainMessage<TakedownBlobRequest> | undefined): boolean {
    return proto3.util.equals(TakedownBlobRequest, a, b);
  }
}

/**
 * @generated from message bsky.TakedownBlobResponse
 */
export class TakedownBlobResponse extends Message<TakedownBlobResponse> {
  constructor(data?: PartialMessage<TakedownBlobResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownBlobResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownBlobResponse {
    return new TakedownBlobResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownBlobResponse {
    return new TakedownBlobResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownBlobResponse {
    return new TakedownBlobResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownBlobResponse | PlainMessage<TakedownBlobResponse> | undefined, b: TakedownBlobResponse | PlainMessage<TakedownBlobResponse> | undefined): boolean {
    return proto3.util.equals(TakedownBlobResponse, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownBlobRequest
 */
export class UntakedownBlobRequest extends Message<UntakedownBlobRequest> {
  /**
   * @generated from field: string did = 1;
   */
  did = "";

  /**
   * @generated from field: string cid = 2;
   */
  cid = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 3;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<UntakedownBlobRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownBlobRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownBlobRequest {
    return new UntakedownBlobRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownBlobRequest {
    return new UntakedownBlobRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownBlobRequest {
    return new UntakedownBlobRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownBlobRequest | PlainMessage<UntakedownBlobRequest> | undefined, b: UntakedownBlobRequest | PlainMessage<UntakedownBlobRequest> | undefined): boolean {
    return proto3.util.equals(UntakedownBlobRequest, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownBlobResponse
 */
export class UntakedownBlobResponse extends Message<UntakedownBlobResponse> {
  constructor(data?: PartialMessage<UntakedownBlobResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownBlobResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownBlobResponse {
    return new UntakedownBlobResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownBlobResponse {
    return new UntakedownBlobResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownBlobResponse {
    return new UntakedownBlobResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownBlobResponse | PlainMessage<UntakedownBlobResponse> | undefined, b: UntakedownBlobResponse | PlainMessage<UntakedownBlobResponse> | undefined): boolean {
    return proto3.util.equals(UntakedownBlobResponse, a, b);
  }
}

/**
 * @generated from message bsky.TakedownRecordRequest
 */
export class TakedownRecordRequest extends Message<TakedownRecordRequest> {
  /**
   * @generated from field: string record_uri = 1;
   */
  recordUri = "";

  /**
   * @generated from field: string ref = 2;
   */
  ref = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 3;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<TakedownRecordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownRecordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "record_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownRecordRequest {
    return new TakedownRecordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownRecordRequest {
    return new TakedownRecordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownRecordRequest {
    return new TakedownRecordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownRecordRequest | PlainMessage<TakedownRecordRequest> | undefined, b: TakedownRecordRequest | PlainMessage<TakedownRecordRequest> | undefined): boolean {
    return proto3.util.equals(TakedownRecordRequest, a, b);
  }
}

/**
 * @generated from message bsky.TakedownRecordResponse
 */
export class TakedownRecordResponse extends Message<TakedownRecordResponse> {
  constructor(data?: PartialMessage<TakedownRecordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.TakedownRecordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TakedownRecordResponse {
    return new TakedownRecordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TakedownRecordResponse {
    return new TakedownRecordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TakedownRecordResponse {
    return new TakedownRecordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TakedownRecordResponse | PlainMessage<TakedownRecordResponse> | undefined, b: TakedownRecordResponse | PlainMessage<TakedownRecordResponse> | undefined): boolean {
    return proto3.util.equals(TakedownRecordResponse, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownRecordRequest
 */
export class UntakedownRecordRequest extends Message<UntakedownRecordRequest> {
  /**
   * @generated from field: string record_uri = 1;
   */
  recordUri = "";

  /**
   * @generated from field: google.protobuf.Timestamp seen = 2;
   */
  seen?: Timestamp;

  constructor(data?: PartialMessage<UntakedownRecordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownRecordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "record_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seen", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownRecordRequest {
    return new UntakedownRecordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownRecordRequest {
    return new UntakedownRecordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownRecordRequest {
    return new UntakedownRecordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownRecordRequest | PlainMessage<UntakedownRecordRequest> | undefined, b: UntakedownRecordRequest | PlainMessage<UntakedownRecordRequest> | undefined): boolean {
    return proto3.util.equals(UntakedownRecordRequest, a, b);
  }
}

/**
 * @generated from message bsky.UntakedownRecordResponse
 */
export class UntakedownRecordResponse extends Message<UntakedownRecordResponse> {
  constructor(data?: PartialMessage<UntakedownRecordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.UntakedownRecordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UntakedownRecordResponse {
    return new UntakedownRecordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UntakedownRecordResponse {
    return new UntakedownRecordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UntakedownRecordResponse {
    return new UntakedownRecordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UntakedownRecordResponse | PlainMessage<UntakedownRecordResponse> | undefined, b: UntakedownRecordResponse | PlainMessage<UntakedownRecordResponse> | undefined): boolean {
    return proto3.util.equals(UntakedownRecordResponse, a, b);
  }
}

/**
 * @generated from message bsky.CreateActorMuteRequest
 */
export class CreateActorMuteRequest extends Message<CreateActorMuteRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string subject_did = 2;
   */
  subjectDid = "";

  /**
   * scope restrictions: when any is set, just the scoped content is muted;
   * when none are set, the subject is fully muted. If a mute already exists
   * for the pair, its stored scope is replaced with this one.
   *
   * @generated from field: bool only_reposts = 3;
   */
  onlyReposts = false;

  /**
   * @generated from field: bool only_quoteposts = 4;
   */
  onlyQuoteposts = false;

  constructor(data?: PartialMessage<CreateActorMuteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateActorMuteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "only_reposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "only_quoteposts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateActorMuteRequest {
    return new CreateActorMuteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateActorMuteRequest {
    return new CreateActorMuteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateActorMuteRequest {
    return new CreateActorMuteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateActorMuteRequest | PlainMessage<CreateActorMuteRequest> | undefined, b: CreateActorMuteRequest | PlainMessage<CreateActorMuteRequest> | undefined): boolean {
    return proto3.util.equals(CreateActorMuteRequest, a, b);
  }
}

/**
 * @generated from message bsky.CreateActorMuteResponse
 */
export class CreateActorMuteResponse extends Message<CreateActorMuteResponse> {
  constructor(data?: PartialMessage<CreateActorMuteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateActorMuteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateActorMuteResponse {
    return new CreateActorMuteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateActorMuteResponse {
    return new CreateActorMuteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateActorMuteResponse {
    return new CreateActorMuteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateActorMuteResponse | PlainMessage<CreateActorMuteResponse> | undefined, b: CreateActorMuteResponse | PlainMessage<CreateActorMuteResponse> | undefined): boolean {
    return proto3.util.equals(CreateActorMuteResponse, a, b);
  }
}

/**
 * @generated from message bsky.DeleteActorMuteRequest
 */
export class DeleteActorMuteRequest extends Message<DeleteActorMuteRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string subject_did = 2;
   */
  subjectDid = "";

  constructor(data?: PartialMessage<DeleteActorMuteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteActorMuteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteActorMuteRequest {
    return new DeleteActorMuteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteActorMuteRequest {
    return new DeleteActorMuteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteActorMuteRequest {
    return new DeleteActorMuteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteActorMuteRequest | PlainMessage<DeleteActorMuteRequest> | undefined, b: DeleteActorMuteRequest | PlainMessage<DeleteActorMuteRequest> | undefined): boolean {
    return proto3.util.equals(DeleteActorMuteRequest, a, b);
  }
}

/**
 * @generated from message bsky.DeleteActorMuteResponse
 */
export class DeleteActorMuteResponse extends Message<DeleteActorMuteResponse> {
  constructor(data?: PartialMessage<DeleteActorMuteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteActorMuteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteActorMuteResponse {
    return new DeleteActorMuteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteActorMuteResponse {
    return new DeleteActorMuteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteActorMuteResponse {
    return new DeleteActorMuteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteActorMuteResponse | PlainMessage<DeleteActorMuteResponse> | undefined, b: DeleteActorMuteResponse | PlainMessage<DeleteActorMuteResponse> | undefined): boolean {
    return proto3.util.equals(DeleteActorMuteResponse, a, b);
  }
}

/**
 * @generated from message bsky.ClearActorMutesRequest
 */
export class ClearActorMutesRequest extends Message<ClearActorMutesRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  constructor(data?: PartialMessage<ClearActorMutesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearActorMutesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearActorMutesRequest {
    return new ClearActorMutesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearActorMutesRequest {
    return new ClearActorMutesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearActorMutesRequest {
    return new ClearActorMutesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearActorMutesRequest | PlainMessage<ClearActorMutesRequest> | undefined, b: ClearActorMutesRequest | PlainMessage<ClearActorMutesRequest> | undefined): boolean {
    return proto3.util.equals(ClearActorMutesRequest, a, b);
  }
}

/**
 * @generated from message bsky.ClearActorMutesResponse
 */
export class ClearActorMutesResponse extends Message<ClearActorMutesResponse> {
  constructor(data?: PartialMessage<ClearActorMutesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearActorMutesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearActorMutesResponse {
    return new ClearActorMutesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearActorMutesResponse {
    return new ClearActorMutesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearActorMutesResponse {
    return new ClearActorMutesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearActorMutesResponse | PlainMessage<ClearActorMutesResponse> | undefined, b: ClearActorMutesResponse | PlainMessage<ClearActorMutesResponse> | undefined): boolean {
    return proto3.util.equals(ClearActorMutesResponse, a, b);
  }
}

/**
 * @generated from message bsky.CreateActorMutelistSubscriptionRequest
 */
export class CreateActorMutelistSubscriptionRequest extends Message<CreateActorMutelistSubscriptionRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string subject_uri = 2;
   */
  subjectUri = "";

  constructor(data?: PartialMessage<CreateActorMutelistSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateActorMutelistSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateActorMutelistSubscriptionRequest {
    return new CreateActorMutelistSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateActorMutelistSubscriptionRequest {
    return new CreateActorMutelistSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateActorMutelistSubscriptionRequest {
    return new CreateActorMutelistSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateActorMutelistSubscriptionRequest | PlainMessage<CreateActorMutelistSubscriptionRequest> | undefined, b: CreateActorMutelistSubscriptionRequest | PlainMessage<CreateActorMutelistSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(CreateActorMutelistSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message bsky.CreateActorMutelistSubscriptionResponse
 */
export class CreateActorMutelistSubscriptionResponse extends Message<CreateActorMutelistSubscriptionResponse> {
  constructor(data?: PartialMessage<CreateActorMutelistSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateActorMutelistSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateActorMutelistSubscriptionResponse {
    return new CreateActorMutelistSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateActorMutelistSubscriptionResponse {
    return new CreateActorMutelistSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateActorMutelistSubscriptionResponse {
    return new CreateActorMutelistSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateActorMutelistSubscriptionResponse | PlainMessage<CreateActorMutelistSubscriptionResponse> | undefined, b: CreateActorMutelistSubscriptionResponse | PlainMessage<CreateActorMutelistSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(CreateActorMutelistSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message bsky.DeleteActorMutelistSubscriptionRequest
 */
export class DeleteActorMutelistSubscriptionRequest extends Message<DeleteActorMutelistSubscriptionRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string subject_uri = 2;
   */
  subjectUri = "";

  constructor(data?: PartialMessage<DeleteActorMutelistSubscriptionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteActorMutelistSubscriptionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteActorMutelistSubscriptionRequest {
    return new DeleteActorMutelistSubscriptionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteActorMutelistSubscriptionRequest {
    return new DeleteActorMutelistSubscriptionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteActorMutelistSubscriptionRequest {
    return new DeleteActorMutelistSubscriptionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteActorMutelistSubscriptionRequest | PlainMessage<DeleteActorMutelistSubscriptionRequest> | undefined, b: DeleteActorMutelistSubscriptionRequest | PlainMessage<DeleteActorMutelistSubscriptionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteActorMutelistSubscriptionRequest, a, b);
  }
}

/**
 * @generated from message bsky.DeleteActorMutelistSubscriptionResponse
 */
export class DeleteActorMutelistSubscriptionResponse extends Message<DeleteActorMutelistSubscriptionResponse> {
  constructor(data?: PartialMessage<DeleteActorMutelistSubscriptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteActorMutelistSubscriptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteActorMutelistSubscriptionResponse {
    return new DeleteActorMutelistSubscriptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteActorMutelistSubscriptionResponse {
    return new DeleteActorMutelistSubscriptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteActorMutelistSubscriptionResponse {
    return new DeleteActorMutelistSubscriptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteActorMutelistSubscriptionResponse | PlainMessage<DeleteActorMutelistSubscriptionResponse> | undefined, b: DeleteActorMutelistSubscriptionResponse | PlainMessage<DeleteActorMutelistSubscriptionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteActorMutelistSubscriptionResponse, a, b);
  }
}

/**
 * @generated from message bsky.ClearActorMutelistSubscriptionsRequest
 */
export class ClearActorMutelistSubscriptionsRequest extends Message<ClearActorMutelistSubscriptionsRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  constructor(data?: PartialMessage<ClearActorMutelistSubscriptionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearActorMutelistSubscriptionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearActorMutelistSubscriptionsRequest {
    return new ClearActorMutelistSubscriptionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearActorMutelistSubscriptionsRequest {
    return new ClearActorMutelistSubscriptionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearActorMutelistSubscriptionsRequest {
    return new ClearActorMutelistSubscriptionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearActorMutelistSubscriptionsRequest | PlainMessage<ClearActorMutelistSubscriptionsRequest> | undefined, b: ClearActorMutelistSubscriptionsRequest | PlainMessage<ClearActorMutelistSubscriptionsRequest> | undefined): boolean {
    return proto3.util.equals(ClearActorMutelistSubscriptionsRequest, a, b);
  }
}

/**
 * @generated from message bsky.ClearActorMutelistSubscriptionsResponse
 */
export class ClearActorMutelistSubscriptionsResponse extends Message<ClearActorMutelistSubscriptionsResponse> {
  constructor(data?: PartialMessage<ClearActorMutelistSubscriptionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearActorMutelistSubscriptionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearActorMutelistSubscriptionsResponse {
    return new ClearActorMutelistSubscriptionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearActorMutelistSubscriptionsResponse {
    return new ClearActorMutelistSubscriptionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearActorMutelistSubscriptionsResponse {
    return new ClearActorMutelistSubscriptionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearActorMutelistSubscriptionsResponse | PlainMessage<ClearActorMutelistSubscriptionsResponse> | undefined, b: ClearActorMutelistSubscriptionsResponse | PlainMessage<ClearActorMutelistSubscriptionsResponse> | undefined): boolean {
    return proto3.util.equals(ClearActorMutelistSubscriptionsResponse, a, b);
  }
}

/**
 * @generated from message bsky.CreateThreadMuteRequest
 */
export class CreateThreadMuteRequest extends Message<CreateThreadMuteRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string thread_root = 2;
   */
  threadRoot = "";

  constructor(data?: PartialMessage<CreateThreadMuteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateThreadMuteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "thread_root", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateThreadMuteRequest {
    return new CreateThreadMuteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateThreadMuteRequest {
    return new CreateThreadMuteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateThreadMuteRequest {
    return new CreateThreadMuteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateThreadMuteRequest | PlainMessage<CreateThreadMuteRequest> | undefined, b: CreateThreadMuteRequest | PlainMessage<CreateThreadMuteRequest> | undefined): boolean {
    return proto3.util.equals(CreateThreadMuteRequest, a, b);
  }
}

/**
 * @generated from message bsky.CreateThreadMuteResponse
 */
export class CreateThreadMuteResponse extends Message<CreateThreadMuteResponse> {
  constructor(data?: PartialMessage<CreateThreadMuteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.CreateThreadMuteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateThreadMuteResponse {
    return new CreateThreadMuteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateThreadMuteResponse {
    return new CreateThreadMuteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateThreadMuteResponse {
    return new CreateThreadMuteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateThreadMuteResponse | PlainMessage<CreateThreadMuteResponse> | undefined, b: CreateThreadMuteResponse | PlainMessage<CreateThreadMuteResponse> | undefined): boolean {
    return proto3.util.equals(CreateThreadMuteResponse, a, b);
  }
}

/**
 * @generated from message bsky.DeleteThreadMuteRequest
 */
export class DeleteThreadMuteRequest extends Message<DeleteThreadMuteRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  /**
   * @generated from field: string thread_root = 2;
   */
  threadRoot = "";

  constructor(data?: PartialMessage<DeleteThreadMuteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteThreadMuteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "thread_root", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteThreadMuteRequest {
    return new DeleteThreadMuteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteThreadMuteRequest {
    return new DeleteThreadMuteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteThreadMuteRequest {
    return new DeleteThreadMuteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteThreadMuteRequest | PlainMessage<DeleteThreadMuteRequest> | undefined, b: DeleteThreadMuteRequest | PlainMessage<DeleteThreadMuteRequest> | undefined): boolean {
    return proto3.util.equals(DeleteThreadMuteRequest, a, b);
  }
}

/**
 * @generated from message bsky.DeleteThreadMuteResponse
 */
export class DeleteThreadMuteResponse extends Message<DeleteThreadMuteResponse> {
  constructor(data?: PartialMessage<DeleteThreadMuteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.DeleteThreadMuteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteThreadMuteResponse {
    return new DeleteThreadMuteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteThreadMuteResponse {
    return new DeleteThreadMuteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteThreadMuteResponse {
    return new DeleteThreadMuteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteThreadMuteResponse | PlainMessage<DeleteThreadMuteResponse> | undefined, b: DeleteThreadMuteResponse | PlainMessage<DeleteThreadMuteResponse> | undefined): boolean {
    return proto3.util.equals(DeleteThreadMuteResponse, a, b);
  }
}

/**
 * @generated from message bsky.ClearThreadMutesRequest
 */
export class ClearThreadMutesRequest extends Message<ClearThreadMutesRequest> {
  /**
   * @generated from field: string actor_did = 1;
   */
  actorDid = "";

  constructor(data?: PartialMessage<ClearThreadMutesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearThreadMutesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "actor_did", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearThreadMutesRequest {
    return new ClearThreadMutesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearThreadMutesRequest {
    return new ClearThreadMutesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearThreadMutesRequest {
    return new ClearThreadMutesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearThreadMutesRequest | PlainMessage<ClearThreadMutesRequest> | undefined, b: ClearThreadMutesRequest | PlainMessage<ClearThreadMutesRequest> | undefined): boolean {
    return proto3.util.equals(ClearThreadMutesRequest, a, b);
  }
}

/**
 * @generated from message bsky.ClearThreadMutesResponse
 */
export class ClearThreadMutesResponse extends Message<ClearThreadMutesResponse> {
  constructor(data?: PartialMessage<ClearThreadMutesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "bsky.ClearThreadMutesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearThreadMutesResponse {
    return new ClearThreadMutesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearThreadMutesResponse {
    return new ClearThreadMutesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearThreadMutesResponse {
    return new ClearThreadMutesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearThreadMutesResponse | PlainMessage<ClearThreadMutesResponse> | undefined, b: ClearThreadMutesResponse | PlainMessage<ClearThreadMutesResponse> | undefined): boolean {
    return proto3.util.equals(ClearThreadMutesResponse, a, b);
  }
}

